// Build input: the existing Golden session/challenge/read functions are inserted
// at the marker by the reviewed builder. No second auth policy or UI controller.
(function () {
  'use strict';
  var ENDPOINT='https://nova-ai-image-generator.nerds-567.workers.dev/generate';
  var databasePromise=null, active=new Map();
  var context=window.location.origin+window.location.pathname;
  if (window.NovaProjectArtworkAccess) { installPrivateArtworkDisplay(); installAutomaticVectorFees(); installNonGoldenProofService(); installSimpleBackgroundAccess(); installCurrentProcessingAccess(); installPreparedArtworkAccess(); return; }
  var aiSecurityScript=null,aiSecurityBusy=false,aiOwnerSession='';
  var aiSessionKey='nova-ai-owner-session',aiSessionAnchorKey='nova-ai-private-session-anchor',aiSessionBoundKey='nova-ai-private-session-bound';
  var aiSessionLogoutEpoch=0,aiSessionExpiryTimer=null,artworkReadsInFlight=new Set(),artworkAccessRenewal=null;
  var preparedArtworkReads=new Map(),preparedMetadataReads=new Map();
    function aiSessionClaims(proof) {
    // Scheduling/storage validation only. Signature, ownership and revocation
    // remain server checks on every protected request. Never export this data.
    try {
      if (typeof proof !== 'string' || proof.length > 3000 || !/^[A-Za-z0-9_-]+\.[A-Za-z0-9_-]+$/.test(proof)) return null;
      var claims = JSON.parse(atob(proof.split('.')[0].replace(/-/g, '+').replace(/_/g, '/')));
      if (claims.v !== 2 || claims.purpose !== 'session' || claims.origin !== window.location.origin ||
          typeof claims.principal !== 'string' || !claims.principal || typeof claims.scope !== 'string' || !claims.scope ||
          !/^[a-f0-9]{8}(?:-[a-f0-9]{4}){3}-[a-f0-9]{12}$/.test(claims.sid || '') ||
          !Number.isSafeInteger(claims.iat) || claims.iat > Date.now() / 1000 || !Number.isSafeInteger(claims.exp) ||
          claims.exp <= claims.iat || !Number.isSafeInteger(claims.recovery) || claims.recovery < claims.exp) return null;
      return claims;
    } catch (error) { return null; }
  }

  function aiSessionAnchor() {
    var raw = window.localStorage.getItem(aiSessionAnchorKey);
    if (!raw) return null;
    try {
      var record = JSON.parse(raw), claims = record && aiSessionClaims(record.proof);
      if (record && record.version === 1 && record.origin === window.location.origin) {
        if (aiSessionClearRecord(record)) return record;
        if (claims && Number.isSafeInteger(record.expiresAt) && record.expiresAt <= claims.recovery && record.expiresAt > claims.iat) return record;
      }
    } catch (error) {}
    throw new Error('Private artwork access storage is invalid. No new identity or artwork request was created.');
  }

  function aiSessionClearRecord(record) {
    return record && record.version === 1 && record.origin === window.location.origin && !record.proof &&
      Number.isSafeInteger(record.clearedAt) && /^[a-f0-9]{8}(?:-[a-f0-9]{4}){3}-[a-f0-9]{12}$/.test(record.clearance || '');
  }

  function clearAiSession() {
    if (aiSessionExpiryTimer !== null) window.clearTimeout(aiSessionExpiryTimer);
    aiSessionExpiryTimer = null;
    aiSessionLogoutEpoch += 1;
    aiOwnerSession = '';
    try { window.sessionStorage.removeItem(aiSessionKey); } catch (error) {}
    try { window.sessionStorage.removeItem(aiSessionBoundKey); } catch (error) {}
    // A non-secret tombstone also prevents an older open tab from re-persisting
    // a pre-logout credential. Do not touch projects, artwork, proofs or carts.
    try { window.localStorage.setItem(aiSessionAnchorKey, JSON.stringify({ version: 1, origin: window.location.origin, clearedAt: Math.floor(Date.now() / 1000), clearance: crypto.randomUUID() })); }
    catch (error) { try { window.localStorage.removeItem(aiSessionAnchorKey); } catch (ignored) {} }
  }

  function armAiSessionExpiry(anchor) {
    if (aiSessionExpiryTimer !== null) window.clearTimeout(aiSessionExpiryTimer);
    aiSessionExpiryTimer = null;
    if (!anchor || anchor.clearedAt) return;
    var remaining = anchor.expiresAt * 1000 - Date.now();
    if (remaining <= 0) { clearAiSession(); return; }
    aiSessionExpiryTimer = window.setTimeout(function () {
      aiSessionExpiryTimer = null;
      try { armAiSessionExpiry(aiSessionAnchor()); } catch (error) {}
    }, Math.min(remaining, 2147483647));
  }

  function readAiSession() {
    var proof = window.sessionStorage.getItem(aiSessionKey) || '';
    var anchor = aiSessionAnchor();
    if (anchor && anchor.clearedAt) {
      if (proof) { window.sessionStorage.removeItem(aiSessionKey); aiOwnerSession = ''; }
      return '';
    }
    if (anchor) {
      if (anchor.expiresAt <= Date.now() / 1000) {
        clearAiSession();
        throw new Error('The original private artwork recovery window has expired. No session was renewed.');
      }
      var current = aiSessionClaims(proof), saved = aiSessionClaims(anchor.proof);
      if (proof && (!current || current.principal !== saved.principal || current.scope !== saved.scope)) {
        throw new Error('The private artwork session changed. No identity was replaced.');
      }
      if (!proof) { proof = anchor.proof; window.sessionStorage.setItem(aiSessionKey, proof); }
      window.sessionStorage.setItem(aiSessionBoundKey, '1');
      armAiSessionExpiry(anchor);
      return proof;
    }
    if (window.sessionStorage.getItem(aiSessionBoundKey)) {
      window.sessionStorage.removeItem(aiSessionKey); window.sessionStorage.removeItem(aiSessionBoundKey); aiOwnerSession = '';
      throw new Error('Private artwork access was cleared. No previous credential was restored.');
    }
    // Upgrade only this same-origin browser's existing supported credential;
    // never infer credentials from a project ID, artwork or exported state.
    if (aiSessionClaims(proof)) writeAiSession(proof, proof);
    return proof;
  }

  function aiSessionWriteGuard() {
    var anchor = aiSessionAnchor();
    return { epoch: aiSessionLogoutEpoch, clearance: anchor && anchor.clearance || '', anchored: !!anchor && !anchor.clearedAt };
  }

  function writeAiSession(proof, previousProof, guard) {
    var claims = aiSessionClaims(proof), prior = aiSessionClaims(previousProof), anchor = aiSessionAnchor();
    if (guard && (guard.epoch !== aiSessionLogoutEpoch || guard.clearance !== (anchor && anchor.clearance || '') ||
        guard.anchored && !anchor)) throw new Error('Private artwork access changed during verification. No credential was restored.');
    if (!claims) {
      var legacy;
      try { legacy = JSON.parse(atob(proof.split('.')[0].replace(/-/g, '+').replace(/_/g, '/'))); } catch (error) {}
      // Preserve the earlier v1 QA transport only as a tab-scoped credential.
      // Malformed/v2/wrong-origin responses may never replace valid access.
      if (!legacy || legacy.v !== 1 || legacy.purpose !== 'owner-qa-session' || legacy.aud !== 'nova-ai-image-generator' ||
          legacy.origin !== window.location.origin || !Number.isSafeInteger(legacy.iat) || !Number.isSafeInteger(legacy.exp) ||
          legacy.iat > Date.now() / 1000 || legacy.exp <= Date.now() / 1000 || legacy.exp > legacy.iat + 900 ||
          prior || anchor && !anchor.clearedAt) throw new Error('The private artwork session response is invalid. Existing access is unchanged.');
    }
    if (claims) {
      var ceiling = anchor && !anchor.clearedAt ? anchor.expiresAt : prior ? prior.recovery : claims.recovery;
      var saved = anchor && !anchor.clearedAt ? aiSessionClaims(anchor.proof) : prior;
      if (ceiling <= Date.now() / 1000 || claims.recovery < ceiling ||
          saved && (saved.principal !== claims.principal || saved.scope !== claims.scope) ||
          anchor && anchor.clearedAt && previousProof) throw new Error('The original private artwork recovery window cannot be replaced or extended.');
      // Retain the original signed credential, not a rolling sequence of
      // renewed ones. Reopening must still pass its original server deadline
      // and revocation check; an active renewed session remains tab-scoped.
      var original = anchor && !anchor.clearedAt ? anchor.proof : prior ? previousProof : proof;
      var record = JSON.stringify({ version: 1, origin: window.location.origin, proof: original, expiresAt: ceiling });
      try {
        window.localStorage.setItem(aiSessionAnchorKey, record);
        if (window.localStorage.getItem(aiSessionAnchorKey) !== record) throw new Error('private storage readback');
      } catch (error) { throw new Error('Private artwork recovery storage is unavailable. No artwork was submitted.'); }
      window.sessionStorage.setItem(aiSessionBoundKey, '1');
      armAiSessionExpiry(JSON.parse(record));
    }
    window.sessionStorage.setItem(aiSessionKey, proof);
    aiOwnerSession = proof;
    return proof;
  }

  function clearAiSessionForLogout(event) {
    var node = event.target && event.target.closest && event.target.closest(event.type === 'submit' ? 'form[action]' : 'a[href]');
    if (!node) return;
    try {
      var destination = new URL(node.getAttribute(event.type === 'submit' ? 'action' : 'href'), window.location.href);
      if (destination.origin === window.location.origin && /\/account\/logout\/?$/.test(destination.pathname)) clearAiSession();
    } catch (error) {}
  }

  function artworkRetryAfter(value, now) {
    if (typeof value !== 'string' || value.length > 128) return null;
    value = value.trim();
    if (/^\d+$/.test(value)) {
      var seconds = Number(value);
      return Number.isSafeInteger(seconds) && seconds <= 120 ? seconds * 1000 : null;
    }
    // HTTP-date only, not Date.parse's permissive numeric/local-date formats.
    if (!/^(?:[A-Za-z]{3}, \d{2} [A-Za-z]{3} \d{4} \d{2}:\d{2}:\d{2} GMT|[A-Za-z]+, \d{2}-[A-Za-z]{3}-\d{2} \d{2}:\d{2}:\d{2} GMT|[A-Za-z]{3} [A-Za-z]{3} [ \d]\d \d{2}:\d{2}:\d{2} \d{4})$/.test(value)) return null;
    var at = Date.parse(value), delay = at - now;
    return Number.isFinite(at) && delay <= 120000 ? Math.max(0,delay) : null;
  }

  function artworkReadWithRateLimit(url, options, onWait, readDeadline) {
    var endpoint = new URL(url), body;
    var privateServiceRead = /^\/artwork\/(read|status|reconcile)$/.test(endpoint.pathname);
    if (!options || options.method !== 'POST' || !(/^\/jobs\/(status|artifact)$/.test(endpoint.pathname) || privateServiceRead)) {
      return Promise.reject(new Error('Only existing artwork reads may wait and repeat.'));
    }
    try { body = JSON.parse(options.body); } catch (error) { return Promise.reject(error); }
    if (privateServiceRead ? !/^[a-f0-9]{64}$/.test((endpoint.pathname==='/artwork/reconcile'?body.source:body.id) || '') || !/^Bearer [A-Za-z0-9_.-]+$/.test(new Headers(options.headers).get('Authorization') || '') : !body.jobId || !body.ownerSessionProof) return Promise.reject(new Error('The existing artwork reference is unavailable.'));
    // No tokens or artwork are written to storage or broadcast between tabs.
    var identity = [endpoint.origin,endpoint.pathname,privateServiceRead ? body.id || body.source : body.jobId,body.kind || '',body.revision || '',body.checksum || ''].join('|');
    function limited(message) {
      var error = new Error(message || 'Artwork access is temporarily limited. Your job and artwork are preserved. Check this same result later; don’t submit again.');
      error.status = 429; error.errorClass = 'rate_limit'; error.novaArtworkReadLimited = true;
      return error;
    }
    if (artworkReadsInFlight.has(identity)) return Promise.reject(limited('This same artwork read is already active. Wait for it to finish; don’t submit again.'));
    artworkReadsInFlight.add(identity);
    var controller = new AbortController(), signal = options.signal;
    var deadline = Math.min(Date.now()+120000,Number.isFinite(readDeadline) ? readDeadline : Infinity);
    var timer = window.setTimeout(function () { controller.abort(); }, Math.max(0,deadline-Date.now())), retries = 0, waiting = false;
    function cancel() { controller.abort(); }
    if (signal) { if (signal.aborted) cancel(); else signal.addEventListener('abort',cancel,{once:true}); }
    function announce(value, delay) {
      waiting = value;
      if (typeof onWait === 'function') try { onWait({rateLimited:true,waiting:value,retryAt:value ? Date.now()+delay : null,seconds:Math.ceil((delay || 0)/1000)}); } catch (ignored) {}
    }
    function wait(delay) {
      return new Promise(function (resolve,reject) {
        if (controller.signal.aborted) { reject(new DOMException('Artwork read cancelled.','AbortError')); return; }
        var id = window.setTimeout(done,delay);
        function done() { controller.signal.removeEventListener('abort',abort); resolve(); }
        function abort() { window.clearTimeout(id); controller.signal.removeEventListener('abort',abort); reject(new DOMException('Artwork read cancelled.','AbortError')); }
        controller.signal.addEventListener('abort',abort,{once:true});
      });
    }
    function read() {
      if(controller.signal.aborted || Date.now()>=deadline)return Promise.reject(new DOMException('Artwork read cancelled.','AbortError'));
      return fetch(url,Object.assign({},options,{signal:controller.signal})).then(function (response) {
        if (response.status !== 429) { if (waiting) announce(false); return response; }
        var delay = artworkRetryAfter(response.headers.get('Retry-After'),Date.now());
        // Never shorten a server's requested wait to fit our local budget.
        var allowed = delay !== null && retries < 2 && Date.now()+Math.max(250,delay) < deadline;
        return (response.body ? response.body.cancel().catch(function () {}) : Promise.resolve()).then(function () {
          if (!allowed) throw limited();
          retries++; delay = Math.max(250,delay); announce(true,delay);
          return wait(delay).then(read);
        });
      });
    }
    var deliver, deny;
    var headersReady = new Promise(function (resolve,reject) { deliver=resolve; deny=reject; });
    function deliverResponse(response) {
      if (!response.body) { deliver(response); return Promise.resolve(); }
      // Hold the same-job lock through transfer without cloning/buffering an image.
      var reader=response.body.getReader(), complete, streamController, finished=false;
      var consumed=new Promise(function (resolve) { complete=resolve; });
      function done() { if(finished)return; finished=true; controller.signal.removeEventListener('abort',abortBody); complete(); }
      function abortBody() {
        reader.cancel().catch(function () {});
        if(streamController)try{streamController.error(signal && signal.aborted ? new DOMException('Artwork read cancelled.','AbortError') : limited());}catch(ignored){}
        done();
      }
      var bodyStream=new ReadableStream({
        start:function (value) { streamController=value; },
        pull:function (value) { return reader.read().then(function (part) { if(part.done){value.close();done();}else value.enqueue(part.value); },function(error){value.error(error);done();}); },
        cancel:function (reason) { return reader.cancel(reason).finally(done); }
      });
      controller.signal.addEventListener('abort',abortBody,{once:true});
      if(controller.signal.aborted)abortBody();
      deliver(new Response(bodyStream,{status:response.status,statusText:response.statusText,headers:response.headers}));
      return consumed;
    }
    // A same-job lock spans waiting/transfer, not image decoding or large copies.
    // In browsers without Web Locks, the in-document guard still applies.
    var result = Promise.resolve().then(function () {
      var locks = window.navigator && window.navigator.locks;
      return locks && typeof locks.request === 'function'
      ? locks.request('nova-artwork-read:'+identity,{ifAvailable:true},function (lock) {
          if (!lock) throw limited('This same artwork is being retrieved in another tab. Wait for that read; don’t submit again.');
          if (controller.signal.aborted) throw new DOMException('Artwork read cancelled.','AbortError');
          return read().then(deliverResponse);
        }) : read().then(deliverResponse);
    });
    result.catch(function (error) {
      deny(controller.signal.aborted && !(signal && signal.aborted) ? limited() : error);
    }).finally(function () {
      window.clearTimeout(timer); if (signal) signal.removeEventListener('abort',cancel);
      artworkReadsInFlight.delete(identity);
      if (waiting) announce(false);
    });
    return headersReady;
  }

  function aiSecurityJson(url, options, observeResponse, readDeadline) {
    var read = new URL(url).pathname === '/jobs/status' ? artworkReadWithRateLimit(url,options,observeResponse,readDeadline) : fetch(url, options);
    return read.then(function (response) {
      if (typeof observeResponse === 'function') {
        try { observeResponse({status:response.status,requestId:response.headers.get('x-request-id')}); } catch (ignored) {}
      }
      return response.json().then(function (data) {
        if (typeof observeResponse === 'function') {
          try { observeResponse({status:response.status,code:data.error,errorClass:data.errorClass,state:data.state,
            boundary:data.validationStage,correlationId:data.correlationId}); } catch (ignored) {}
        }
        if (!response.ok || !data.ok) {
          var failure = new Error(data.error || 'AI generation is temporarily unavailable.');
          failure.status = response.status; failure.errorClass = data.errorClass;
          if (data.validationStage === 'grant_expired') failure.novaSecurityCode = 'grant_expired';
          throw failure;
        }
        return data;
      }, function (error) {
        // Diagnostic-only: do not change legacy retry/uncertainty decisions
        // that deliberately inspect error.status after parsed API denials.
        error.novaSecurityStatus = response.status;
        error.novaSecurityCode = 'invalid_response';
        throw error;
      });
    });
  }

  function loadAiSecurityChallenge() {
    if (window.turnstile) return Promise.resolve(window.turnstile);
    if (aiSecurityScript) return aiSecurityScript;
    aiSecurityScript = new Promise(function (resolve, reject) {
      var script = document.createElement('script');
      function failed(message, code) { var error = new Error(message); error.novaSecurityCode = code; reject(error); }
      var timer = window.setTimeout(function () { script.remove(); failed('The security challenge could not load.', 'script_timeout'); }, 15000);
      script.src = 'https://challenges.cloudflare.com/turnstile/v0/api.js?render=explicit';
      script.async = true;
      script.onload = function () {
        window.clearTimeout(timer);
        if (window.turnstile) resolve(window.turnstile);
        else failed('The security challenge is unavailable.', 'script_unavailable');
      };
      script.onerror = function () { window.clearTimeout(timer); script.remove(); failed('The security challenge could not load.', 'script_error'); };
      document.head.appendChild(script);
    }).catch(function (error) {
      aiSecurityScript = null;
      throw error;
    });
    return aiSecurityScript;
  }

  function createAiSecurityChallengeFlow(options) {
    options = options || {};
    var host = null;
    var mount = null;
    var cancel = null;
    var activeCancel = null;
    var widgetId = null;
    var activeTurnstile = null;
    var running = false;
    var ordinary = options.operation === 'ordinary-artwork';
    var mobileUpscale = options.operation === 'upscale' && Boolean(document.querySelector('[data-nova-mobile-artwork-workflow]:not([hidden]) [data-nova-mobile-artwork-scroller]'));
    var label = null, retry = null, resize = null, dialogObserver = null;
    function returnToUpscale() {
      if (!mobileUpscale) return;
      var scroller = host && host.closest('[data-nova-mobile-artwork-scroller]');
      var action = scroller && scroller.querySelector('[data-nova-mobile-artwork-action="upscale-artwork"]');
      if (action) scroller.scrollTop += action.getBoundingClientRect().top - scroller.getBoundingClientRect().top - 12;
    }
    function reveal() {
      if (!host || !host.isConnected) return;
      if (mobileUpscale) {
        if (host.getAttribute('data-interactive') !== 'true') return;
        var scroller = host.closest('[data-nova-mobile-artwork-scroller]');
        if (scroller) scroller.scrollTop += host.getBoundingClientRect().top - scroller.getBoundingClientRect().top - 12;
      } else if (ordinary) {
        host.setAttribute('data-interactive', 'true');
        host.scrollIntoView({ block: 'center', behavior: 'instant' });
      }
    }
    function report(event, attempt, code, turnstileCode) {
      if (typeof options.onDiagnostic === 'function') {
        try { options.onDiagnostic({ event: event, attempt: attempt, code: code, turnstileCode: turnstileCode,
          hostConnected:Boolean(host && host.isConnected),hostHasLayout:Boolean(host && host.getClientRects().length),
          hostHiddenAncestor:Boolean(host && host.closest('[hidden],[inert],[aria-hidden="true"]')) }); } catch (ignored) {}
      }
      if (!ordinary || !host) return;
      host.setAttribute('data-verification-state', event);
      var box = host.getBoundingClientRect();
      var detail = {
        event: event, attempt: attempt, code: code || null, timestamp: new Date().toISOString(),
        visible: box.width > 0 && box.height > 0 && box.top >= 0 && box.bottom <= window.innerHeight
      };
      // Cloudflare's six-digit public error classification is not a token.
      // Retain it during recoverable failures; reject arbitrary callback text.
      if (typeof turnstileCode === 'string' && /^[0-9]{6}$/.test(turnstileCode)) {
        detail.turnstileCode = turnstileCode;
        host.setAttribute('data-nova-verification-error-code', turnstileCode);
      } else host.removeAttribute('data-nova-verification-error-code');
      // Fixed lifecycle metadata only, never token, session, request body or file.
      console.info('[Nova verification]', JSON.stringify(detail));
      host.dispatchEvent(new CustomEvent('nova:verification-lifecycle', { bubbles: true, detail: detail }));
    }
    function failure(message, code, turnstileCode) {
      var error = new Error(message);
      error.novaSecurityCode = code;
      if (typeof turnstileCode === 'string' && /^[0-9]{6}$/.test(turnstileCode)) error.novaTurnstileCode = turnstileCode;
      return error;
    }
    function ensureHost() {
      if (host && host.isConnected) return host;
      host = document.createElement('section');
      host.className = 'nova-ai-security-challenge';
      host.setAttribute('data-nova-ai-security-challenge', options.operation || 'request');
      host.setAttribute('data-interactive', ordinary ? 'true' : 'false');
      host.setAttribute('role', 'region');
      host.setAttribute('aria-label', options.label || 'Request security verification');
      label = document.createElement('p');
      label.setAttribute('role', 'status');
      label.textContent = 'Complete the security verification to continue.';
      mount = document.createElement('div');
      mount.setAttribute('data-nova-ai-security-challenge-mount', '');
      if (ordinary) mount.style.minHeight = window.matchMedia('(max-width: 640px)').matches ? '140px' : '65px';
      retry = document.createElement('button');
      retry.type = 'button'; retry.textContent = 'Verify again'; retry.hidden = true;
      retry.setAttribute('data-nova-verification-retry', '');
      cancel = document.createElement('button');
      cancel.type = 'button';
      cancel.textContent = 'Cancel verification';
      cancel.addEventListener('click', function () { if (activeCancel) activeCancel(); });
      host.appendChild(label); host.appendChild(mount); host.appendChild(retry); host.appendChild(cancel);
      var stableMobileParent = document.querySelector('[data-nova-mobile-artwork-scroller]');
      var compactModal = document.querySelector('[data-nova-compact-ai-modal]');
      var upscaleStatus = document.querySelector('[data-nova-upscale-artwork-status]');
      var parent = stableMobileParent || compactModal || (upscaleStatus && upscaleStatus.parentNode) || document.body;
      if (options.operation === 'owner-review') {
        // This independent owner action must not inherit a closed artwork
        // modal. Keep generation and upscale challenge placement unchanged.
        parent = document.querySelector('[data-nova-retained-association]');
        if (!parent || parent.closest('[hidden],[inert],[aria-hidden="true"]') ||
            !parent.getClientRects().length || window.getComputedStyle(parent).visibility !== 'visible') parent = document.body;
      }
      if (options.operation === 'ordinary-artwork') {
        // A new customer's upload or text proof can establish its verified
        // session while the native proof form is open. Do not mount behind it.
        var ordinaryParents = [document.querySelector('[data-nova-mobile-artwork-proof-modal] .nova-mobile-artwork-proof-modal__scroller'),
          document.querySelector('[data-nova-proof-approval-modal] [data-nova-final-proof-scroll]'),
          document.querySelector('[data-nova-location-readiness-card]')];
        parent = ordinaryParents.find(function (candidate) {
          return candidate && !candidate.closest('[hidden],[inert],[aria-hidden="true"]') && candidate.getClientRects().length &&
            window.getComputedStyle(candidate).visibility === 'visible';
        }) || document.body;
      }
      parent.appendChild(host);
      if ((ordinary || mobileUpscale) && typeof ResizeObserver === 'function') {
        // Cloudflare may size its iframe after before-interactive-callback.
        // Keep the real control inside this dialog's visible scroll area.
        resize = new ResizeObserver(reveal); resize.observe(mount);
      }
      var dialog = ordinary && parent.closest('[data-nova-mobile-artwork-proof-modal],[data-nova-proof-approval-modal]');
      if (dialog) {
        dialogObserver = new MutationObserver(function () {
          if (dialog.closest('[hidden],[inert],[aria-hidden="true"]') && activeCancel) activeCancel();
        });
        dialogObserver.observe(dialog, { attributes: true, attributeFilter: ['hidden', 'inert', 'aria-hidden'] });
      }
      reveal();
      return host;
    }
    function clearWidget() {
      if (activeTurnstile && widgetId !== null) activeTurnstile.remove(widgetId);
      widgetId = null; activeTurnstile = null;
      if (mount) mount.replaceChildren();
      if (host) host.setAttribute('data-interactive', ordinary ? 'true' : 'false');
    }
    function loadForVerification(signal) {
      if (!ordinary) return loadAiSecurityChallenge();
      ensureHost(); reveal();
      return loadAiSecurityChallenge().catch(function (error) {
        if (signal && signal.aborted) throw failure(options.cancelMessage || 'Request cancelled.', 'cancelled');
        return new Promise(function (resolve, reject) {
          retry.hidden = false;
          label.textContent = 'Security verification could not load. Your unchanged design and acknowledgments are preserved. Select Verify again to retry only verification, or Cancel verification.';
          report('retry-required', 0, ['script_error', 'script_timeout', 'script_unavailable'].indexOf(error.novaSecurityCode) >= 0 ? error.novaSecurityCode : 'script_unavailable');
          reveal();
          var waiting = true;
          function cleanup() { waiting = false; retry.onclick = null; activeCancel = null; if (signal) signal.removeEventListener('abort', aborted); }
          function aborted() { if (!waiting) return; cleanup(); reject(failure(options.cancelMessage || 'Request cancelled.', 'cancelled')); }
          activeCancel = aborted;
          if (signal) signal.addEventListener('abort', aborted, { once: true });
          retry.onclick = function () { if (!waiting) return; cleanup(); retry.hidden = true; resolve(loadForVerification(signal)); };
        });
      });
    }
    function verify(config, signal) {
      if (running) return Promise.reject(failure('Security verification is already in progress.', 'verification_busy'));
      running = true;
      return loadForVerification(signal).then(function (turnstile) {
        if (signal && signal.aborted) throw failure(options.cancelMessage || 'Request cancelled.', 'cancelled');
        ensureHost();
        if (ordinary && host.closest('[hidden],[inert],[aria-hidden="true"]')) throw failure('Artwork proof verification cancelled.', 'cancelled');
        return new Promise(function (resolve, reject) {
          var settled = false;
          var timer, attempt = 0, accepting = false;
          activeTurnstile = turnstile;
          function finish(error, token) {
            if (settled) return;
            settled = true;
            window.clearTimeout(timer);
            accepting = false; attempt++;
            if (signal) signal.removeEventListener('abort', aborted);
            activeCancel = null;
            if (retry) retry.onclick = null;
            clearWidget();
            returnToUpscale();
            if (error) reject(error); else resolve(token);
          }
          function aborted() { finish(failure(options.cancelMessage || 'Request cancelled.', 'cancelled')); }
          activeCancel = aborted;
          if (signal) signal.addEventListener('abort', aborted, { once: true });
          function recover(code, turnstileCode) {
            if (!ordinary) {
              report('failed', attempt, code, turnstileCode);
              var message = code === 'widget_unavailable' ? 'Security check is unavailable.' : code === 'turnstile_error' ? 'Security check failed. Please try again.' :
                code === 'turnstile_timeout' ? 'Security check timed out. Please try again.' : 'Security check expired. Please try again.';
              finish(failure(message, code, turnstileCode)); return;
            }
            if (settled || !accepting) return;
            accepting = false; window.clearTimeout(timer);
            clearWidget(); retry.hidden = false;
            label.textContent = 'Verification expired or failed. Your unchanged design and acknowledgments are preserved. Select Verify again to continue this artwork action, or Cancel verification. No proof has been confirmed as archived.';
            report('retry-required', attempt, code, turnstileCode); reveal();
          }
          function start() {
            if (settled || accepting) return;
            if (signal && signal.aborted) { aborted(); return; }
            accepting = true; var id = ++attempt;
            retry.hidden = true; label.textContent = ordinary ? 'Complete the security verification below to continue this artwork action.' : 'Complete the security verification to continue.';
            activeTurnstile = turnstile;
            function active() { return !settled && accepting && attempt === id; }
            timer = window.setTimeout(function () { if (active()) recover('local_timeout'); }, 120000);
            report('rendering', id); reveal();
            try {
              widgetId = turnstile.render(mount, {
              sitekey: config.sitekey, action: config.action, appearance: ordinary ? 'always' : 'interaction-only',
              size: ordinary && window.matchMedia('(max-width: 640px)').matches ? 'compact' : 'normal',
              retry: 'never', 'refresh-expired': 'never', 'refresh-timeout': 'never',
              'before-interactive-callback': function () { if (active() && host) { host.setAttribute('data-interactive', 'true'); reveal(); report('interactive', id); } },
              'after-interactive-callback': function () { if (active() && host && !ordinary) { host.setAttribute('data-interactive', 'false'); returnToUpscale(); } },
              callback: function (token) { if (active()) { report('verified', id); finish(null, token); } },
              'error-callback': function (code) { if (active()) recover('turnstile_error', code); },
              'expired-callback': function () { if (active()) recover('turnstile_expired'); },
              'timeout-callback': function () { if (active()) recover('turnstile_timeout'); }
            });
              if ((settled || !accepting) && widgetId !== null) { activeTurnstile = turnstile; clearWidget(); }
              else { reveal(); report('mounted', id); }
            } catch (error) { if (active()) recover('widget_unavailable'); }
          }
          retry.onclick = start;
          start();
        });
      }).finally(function () { running = false; });
    }
    function destroy() { clearWidget(); if (resize) resize.disconnect(); if (dialogObserver) dialogObserver.disconnect(); resize = null; dialogObserver = null; if (host) host.remove(); host = null; mount = null; cancel = null; retry = null; label = null; activeCancel = null; }
    return { verify: verify, destroy: destroy };
  }

  function runAiSecurityChallenge(config, signal, operation) {
    var ownerReview = operation === 'owner-review';
    var ordinaryArtwork = operation === 'ordinary-artwork';
    var flow = createAiSecurityChallengeFlow({ operation: ownerReview ? 'owner-review' : ordinaryArtwork ? 'ordinary-artwork' : 'generation',
      label: ownerReview ? 'Retained artwork access security verification' : ordinaryArtwork ? 'Artwork proof security verification' : 'AI generation security verification',
      cancelMessage: ownerReview ? 'Artwork access verification cancelled.' : ordinaryArtwork ? 'Artwork proof verification cancelled.' : 'Generation cancelled.' });
    return flow.verify(config, signal).finally(flow.destroy);
  }

  function retainedProjectSession(signal, existingOnly, minimumRemaining, operation, forceRenew) {
    if(!existingOnly)return retainedProjectSessionAttempt(signal,existingOnly,minimumRemaining,operation,forceRenew);
    if(signal&&signal.aborted)return Promise.reject(new DOMException('Artwork retrieval cancelled.','AbortError'));
    var proof;
    try{proof=readAiSession();}catch(error){return Promise.reject(error);}
    var record=artworkAccessRenewal;
    if(!record||record.proof!==proof){
      var controller=new AbortController(),timer=window.setTimeout(function(){controller.abort();},30000);
      record={proof:proof};artworkAccessRenewal=record;
      record.promise=retainedProjectSessionAttempt(controller.signal,true,minimumRemaining||5,operation,forceRenew).finally(function(){
        window.clearTimeout(timer);if(artworkAccessRenewal===record)artworkAccessRenewal=null;
      });
    }
    // Cancelling one preview must not cancel other thumbnails sharing renewal.
    return new Promise(function(resolve,reject){
      function cancelled(){reject(new DOMException('Artwork retrieval cancelled.','AbortError'));}
      if(signal)signal.addEventListener('abort',cancelled,{once:true});
      record.promise.then(function(auth){if(signal&&signal.aborted)cancelled();else resolve(auth);},reject).finally(function(){if(signal)signal.removeEventListener('abort',cancelled);});
    });
  }

  function retainedProjectSessionAttempt(signal, existingOnly, minimumRemaining, operation, forceRenew) {
    var base = ENDPOINT.replace(/\/(generate|generate-and-store)\/?$/, '');
    minimumRemaining = minimumRemaining || 0;
    var proof, sessionGuard;
    try { proof = readAiSession(); sessionGuard = aiSessionWriteGuard(); } catch (error) { return Promise.reject(error); }
    try {
      var payload = JSON.parse(atob(proof.split('.')[0].replace(/-/g, '+').replace(/_/g, '/')));
      if (!forceRenew && Number.isSafeInteger(payload.exp) && payload.exp > Date.now() / 1000 + minimumRemaining) return Promise.resolve({ base: base, proof: proof });
    } catch (error) {}
    if (existingOnly&&!proof) {
      var missing=new Error('Private artwork access needs authentication. Your saved project and artwork references are preserved; no processing was requested.');
      missing.errorClass='session_required';return Promise.reject(missing);
    }
    var verificationStage = 'security-config';
    return aiSecurityJson(base + '/security-config', { method: 'GET', signal: signal }).then(function (config) {
      if (config.ownerQaRequired) {
        var required = new Error('Use the existing authorized preview session before requesting owner reattachment.');
        required.novaSecurityCode = 'owner_session_required'; throw required;
      }
      verificationStage = 'challenge';
      return runAiSecurityChallenge(config, signal, operation === 'ordinary-artwork' ? operation : 'owner-review').then(function (token) {
        verificationStage = 'session';
        return aiSecurityJson(base + '/session', { method: 'POST', redirect: 'error', signal: signal,
          headers: { 'Content-Type': 'application/json' }, body: JSON.stringify(Object.assign({ turnstileToken: token }, proof ? { previousProof: proof } : {})) });
      });
    }).then(function (session) {
      if (!session.ownerSessionProof) {
        var invalid = new Error('The preview session could not be established.');
        invalid.novaSecurityCode = 'invalid_response'; throw invalid;
      }
      if (minimumRemaining) {
        if (signal && signal.aborted) throw new Error('Owner review preparation was cancelled. No access handoff was requested.');
        // This is only a scheduling check, never authentication. The server
        // still validates the signed session and the fresh owner handoff.
        var issued;
        try { issued = JSON.parse(atob(session.ownerSessionProof.split('.')[0].replace(/-/g, '+').replace(/_/g, '/'))); } catch (error) {}
        if (!issued || !Number.isSafeInteger(issued.exp) || issued.exp <= Date.now() / 1000 + minimumRemaining) throw new Error('The preview session has too little time for owner review. No access handoff was requested.');
        if ((window.sessionStorage.getItem('nova-ai-owner-session') || '') !== proof) throw new Error('The preview session changed during verification. No access handoff was requested.');
      }
      return { base: base, proof: writeAiSession(session.ownerSessionProof, proof, sessionGuard) };
    }).catch(function (error) {
      if (operation === 'ordinary-artwork') {
        // Fixed classifications only: never expose an exception message,
        // session proof, callback token, response body or request headers.
        var codes = ['script_timeout', 'script_unavailable', 'script_error', 'verification_busy', 'cancelled', 'local_timeout',
          'turnstile_error', 'turnstile_expired', 'turnstile_timeout', 'widget_unavailable', 'owner_session_required', 'invalid_response'];
        var receivedStatus = error && (Number.isInteger(error.status) ? error.status : error.novaSecurityStatus);
        var status = Number.isInteger(receivedStatus) && receivedStatus >= 100 && receivedStatus <= 599 ? receivedStatus : null;
        var code = codes.indexOf(error && error.novaSecurityCode) >= 0 ? error.novaSecurityCode :
          signal && signal.aborted ? 'cancelled' : status ? 'http_error' : 'request_failed';
        error.novaArtworkDiagnostic = { stage: code.indexOf('script_') === 0 ? 'script-load' : verificationStage,
          code: code, status: status, turnstileCode: error && /^[0-9]{6}$/.test(error.novaTurnstileCode || '') ? error.novaTurnstileCode : null };
      }
      throw error;
    });
  }

  function protectedArtworkRead(auth,path,payload,signal,retried,readDeadline) {
    // Only these read contracts may replay after an explicit expired-session
    // response. Never replay processing, preparation, association or Save.
    if(['/jobs/artifact','/jobs/retained-result','/artwork/read','/artwork/status','/artwork/reconcile','/jobs/read-proof-archive'].indexOf(path)===-1)return Promise.reject(new Error('Unsupported artwork read.'));
    var serviceRead = path.indexOf('/artwork/') === 0;
    var read = path === '/jobs/artifact' || serviceRead ? artworkReadWithRateLimit : fetch;
    return read(auth.base+path,{method:'POST',redirect:'error',headers:Object.assign({'Content-Type':'application/json'},serviceRead?{Authorization:'Bearer '+auth.proof}:{}),signal:signal,
      body:JSON.stringify(serviceRead?payload:Object.assign({},payload,{ownerSessionProof:auth.proof}))},function (wait) {
        document.dispatchEvent(new CustomEvent('nova:artwork-read-wait', { detail: {
          jobId: payload.jobId, kind: payload.kind, waiting: wait.waiting, seconds: wait.seconds
        } }));
      },readDeadline).then(function(response){
      if(response.ok)return response;
      return preparedArtifactFailure(response,payload.kind,path);
    }).catch(function(error){
      if(!retried&&error.status===403&&error.errorClass==='session_expired'&&!(signal&&signal.aborted)){
        return retainedProjectSession(signal,true,5,'ordinary-artwork',true).then(function(next){return protectedArtworkRead(next,path,payload,signal,true,readDeadline);});
      }
      throw error;
    });
  }

  function preparedArtifactFailure(response, kind, endpoint) {
    // Keep only bounded, documented non-secret fields. Never retain a response
    // body, request body, token, URL query or upstream free-form error message.
    var diagnostic = { endpoint: endpoint || '/jobs/artifact', method: 'POST', kind: kind,
      status: response.status, receivedAt: new Date().toISOString() };
    var ray = response.headers.get('CF-Ray') || '';
    var requestId = response.headers.get('X-Request-ID') || '';
    var correlationId = response.headers.get('X-Nova-Correlation-Id') || '';
    function validCorrelation(value) { return typeof value === 'string' && /^[a-f0-9]{8}(?:-[a-f0-9]{4}){3}-[a-f0-9]{12}$/i.test(value); }
    if (/^[a-f0-9]{16,32}(?:-[A-Z0-9]{3,10})?$/.test(ray)) diagnostic.cfRay = ray;
    if (validCorrelation(requestId)) diagnostic.requestId = requestId;
    if (validCorrelation(correlationId)) diagnostic.correlationId = correlationId;
    var reader = response.body && response.body.getReader ? response.body.getReader() : null;
    var chunks = [], length = 0;
    function read() {
      if (!reader) return Promise.resolve(null);
      return reader.read().then(function (part) {
        if (part.done) {
          var bytes = new Uint8Array(length), offset = 0;
          chunks.forEach(function (chunk) { bytes.set(chunk, offset); offset += chunk.length; });
          try { return JSON.parse(new TextDecoder().decode(bytes)); } catch (error) { return null; }
        }
        length += part.value.byteLength;
        if (length > 4096) return reader.cancel().catch(function () {}).then(function () { return null; });
        chunks.push(part.value); return read();
      }).catch(function () { return null; });
    }
    return read().then(function (payload) {
      var known = ['artifact_unavailable', 'print_revision_conflict', 'artifact_integrity', 'authorization_failed',
        'rate_limit', 'job_service_unavailable', 'origin_denied', 'configuration', 'production_canvas_unavailable',
        'artwork_reference_denied', 'retained_association_denied', 'retained_retention_expired', 'access_denied', 'session_expired', 'job_not_found',
        'service_access_denied', 'service_project_denied', 'service_not_ready', 'service_storage_integrity'];
      if (payload && known.indexOf(payload.errorClass) !== -1) diagnostic.errorClass = payload.errorClass;
      if (payload && validCorrelation(payload.correlationId)) {
        if (!diagnostic.correlationId) diagnostic.correlationId = payload.correlationId;
        else if (diagnostic.correlationId !== payload.correlationId) diagnostic.correlationMismatch = true;
      }
      if (payload && typeof payload.timestamp === 'string' && /^\d{4}-\d{2}-\d{2}T\d{2}:\d{2}:\d{2}\.\d{3}Z$/.test(payload.timestamp) &&
          Number.isFinite(Date.parse(payload.timestamp)) && new Date(payload.timestamp).toISOString() === payload.timestamp) diagnostic.serverTimestamp = payload.timestamp;
      var error = new Error('Authorized artwork retrieval is unavailable. Your artwork and placement are unchanged; its resolution could not be verified.');
      error.code = 'NOVA_ARTWORK_RETRIEVAL_UNAVAILABLE';
      error.status = diagnostic.status;
      if (diagnostic.errorClass) error.errorClass = diagnostic.errorClass;
      error.retrievalDiagnostic = diagnostic;
      throw error;
    });
  }

  function privateArtworkReference(source) {
    try { var url=new URL(source),base=new URL(ENDPOINT);return url.origin===base.origin&&!url.username&&!url.password&&!url.search&&!url.hash&&/^\/artwork\/files\/[a-f0-9]{64}\/[a-f0-9]{64}$/.test(url.pathname)?url.pathname.split('/'):null; } catch(error) { return null; }
  }

  function readPrivateArtwork(source,signal) {
    var ref=privateArtworkReference(source);
    if(!ref)return Promise.reject(new Error('The private artwork reference is invalid.'));
    return retainedProjectSession(signal,true,5,'ordinary-artwork').then(function(auth){
      return protectedArtworkRead(auth,'/artwork/read',{id:ref[3]},signal,false,Date.now()+65000);
    }).then(function(response){if(!response.ok||response.headers.get('X-Nova-Checksum')!==ref[4])throw new Error('The private artwork is unavailable or its identity changed.');return response.blob();}).then(function(blob){
      if(!blob.size||blob.size>10*1024*1024)throw new Error('The private artwork exceeds its size limit.');
      return blob.arrayBuffer().then(function(bytes){return crypto.subtle.digest('SHA-256',bytes);}).then(function(hash){if(Array.from(new Uint8Array(hash),function(b){return b.toString(16).padStart(2,'0');}).join('')!==ref[4])throw new Error('The private artwork checksum did not match.');return blob;});
    });
  }

  function reconcilePrivateArtwork(source) {
    return retainedProjectSession(undefined,true,5,'ordinary-artwork').then(function(auth){return protectedArtworkRead(auth,'/artwork/reconcile',{source:source},undefined,false,Date.now()+65000);}).then(function(response){return response.json();});
  }

  function projectArtworkService(blob, vector, expectedHash, signal, onStage, onSourceStored) {
    var owner=artworkProjectOwner(),project,checksum,auth,source,readDeadline;
    try{project=owner.getProjectId();owner.requirePersistedProjectId(project);}catch(error){return Promise.reject(error);}
    if(!(blob instanceof Blob)||blob.size<1||blob.size>10*1024*1024)return Promise.reject(new Error('Artwork must be within the 10 MB service limit.'));
    function current(){owner.requirePersistedProjectId(project);if(owner.getProjectId()!==project||(signal&&signal.aborted))throw new DOMException('Artwork action cancelled.','AbortError');}
    function stage(message){if(typeof onStage==='function')onStage(message);}
    function readJson(response){return response.json().then(function(data){if(!response.ok||!data.ok){var e=new Error(data.error||'The existing artwork service could not be confirmed. Do not submit again.');e.errorClass=data.errorClass;e.status=response.status;throw e;}return data;});}
    function request(path,body){current();return (path==='/artwork/status'?protectedArtworkRead(auth,path,body,signal,false,readDeadline):fetch(auth.base+path,{method:'POST',redirect:'error',signal:signal,headers:{Authorization:'Bearer '+auth.proof,'Content-Type':'application/json'},body:JSON.stringify(body)})).then(readJson);}
    stage('Verifying the selected artwork and secure project access…');
    return blob.arrayBuffer().then(function(bytes){return crypto.subtle.digest('SHA-256',bytes);}).then(function(hash){
      checksum=Array.from(new Uint8Array(hash),function(b){return b.toString(16).padStart(2,'0');}).join('');
      if(expectedHash&&expectedHash!==checksum)throw new Error('The selected Original checksum changed. Nothing was submitted.');
      current();return retainedProjectSession(signal,false,240,'ordinary-artwork');
    }).then(function(session){
      auth=session;current();stage('Storing the verified source artwork…');var form=new FormData();
      form.append('metadata',JSON.stringify({input:{project:project,mime:blob.type,checksum:checksum},operation:'source-'+checksum}));form.append('file',blob,'artwork');
      return fetch(auth.base+'/artwork/store',{method:'POST',redirect:'error',signal:signal,headers:{Authorization:'Bearer '+auth.proof},body:form}).then(readJson);
    }).then(function(saved){
      source=saved.artifact;if(!source||source.project!==project||source.checksum!==checksum||source.state!=='ready')throw new Error('The private source association was not verified.');
      if(vector)stage('Source stored. Submitting artwork and waiting for the vector service…');
      return Promise.resolve(typeof onSourceStored==='function'?onSourceStored(source):null).then(function(){current();return vector?request('/artwork/vectorize',{source:source.id,operation:'vector-'+source.id}):saved;});
    }).then(function(result){
      var artifact,deadline=Date.now()+65000;readDeadline=deadline;
      function settle(next){
        artifact=next.artifact;current();
        if(!artifact||artifact.project!==project||!(/^[a-f0-9]{64}$/.test(artifact.id||'')))throw new Error('The private artwork response was invalid.');
        if(artifact.state==='ready')return artifact;
        if(artifact.state==='blocked'||Date.now()>=deadline)throw new Error('The existing vector request is not ready. Your Original is unchanged. Do not submit again; contact support for this project.');
        return new Promise(function(resolve){window.setTimeout(resolve,2000);}).then(function(){return request('/artwork/status',{id:artifact.id});}).then(settle);
      }
      return settle(result);
    }).then(function(artifact){
      current();stage('Retrieving the prepared artwork…');return protectedArtworkRead(auth,'/artwork/read',{id:artifact.id},signal,false,Date.now()+65000).then(function(response){
        if(!response.ok||response.headers.get('X-Nova-Checksum')!==artifact.checksum)throw new Error('The private artwork could not be verified.');
        return response.blob();
      }).then(function(result){if(result.size!==artifact.bytes||result.type!==artifact.mime)throw new Error('The private artwork identity changed.');return result.arrayBuffer().then(function(bytes){return crypto.subtle.digest('SHA-256',bytes);}).then(function(hash){
        if(Array.from(new Uint8Array(hash),function(b){return b.toString(16).padStart(2,'0');}).join('')!==artifact.checksum)throw new Error('The private artwork checksum did not match.');
        current();stage('Checksum verified. Preparing the artwork preview…');var reference=auth.base+'/artwork/files/'+artifact.id+'/'+artifact.checksum;
        var preview=vector?new Promise(function(resolve,reject){var url=URL.createObjectURL(result),image=new Image();image.onerror=function(){URL.revokeObjectURL(url);reject(new Error('The vector preview could not be decoded.'));};image.onload=function(){try{var scale=Math.min(1,1024/image.naturalWidth,1024/image.naturalHeight),canvas=document.createElement('canvas');canvas.width=Math.max(1,Math.round(image.naturalWidth*scale));canvas.height=Math.max(1,Math.round(image.naturalHeight*scale));canvas.getContext('2d').drawImage(image,0,0,canvas.width,canvas.height);resolve(canvas.toDataURL('image/png'));}catch(error){reject(error);}finally{URL.revokeObjectURL(url);}};image.src=url;}):Promise.resolve('');
        return preview.then(function(dataUrl){current();return {success:true,fileUrl:reference,vectorUrl:vector?reference:'',previewUrl:dataUrl,fileName:vector?'artwork.svg':'artwork',privateArtifact:artifact};});
      });});
    });
  }

  function printPngDensity(dataUrl) {
    // Normalize pHYs and IDAT chunking without changing compressed pixels.
    // This canvas-only encoding operation does not create source detail.
    if(!/^data:image\/png;base64,/.test(dataUrl))throw new Error('Print output is not a PNG.');
    var raw=atob(dataUrl.slice(dataUrl.indexOf(',')+1));
    if(raw.length>32*1024*1024)throw new Error('Print output exceeds the supported encoded size.');
    var bytes=Uint8Array.from(raw,function(c){return c.charCodeAt(0);}),view=new DataView(bytes.buffer);
    var signature=[137,80,78,71,13,10,26,10];
    if(!signature.every(function(b,i){return bytes[i]===b;}))throw new Error('Invalid print PNG.');
    var table=Uint32Array.from({length:256},function(_,n){for(var bit=0;bit<8;bit++)n=(n>>>1)^((n&1)?0xedb88320:0);return n>>>0;});
    function crc(part){var c=0xffffffff;for(var i=0;i<part.length;i++)c=table[(c^part[i])&255]^(c>>>8);return (c^0xffffffff)>>>0;}
    var density=new Uint8Array(21),dv=new DataView(density.buffer);
    dv.setUint32(0,9);density.set([112,72,89,115],4);dv.setUint32(8,11812);dv.setUint32(12,11812);density[16]=1;dv.setUint32(17,crc(density.subarray(4,17)));
    var parts=[bytes.subarray(0,8)],pos=8,ended=false,count=0,idatParts=[],idatIndex=-1,dataEnded=false;
    while(pos<bytes.length){
      // Browsers may split one compressed stream into >4096 small chunks.
      // Bound this canvas-only input, then coalesce IDAT without recompression.
      if(++count>65536)throw new Error('Print PNG exceeds the supported canvas chunk count.');
      if(pos+12>bytes.length)throw new Error('Print PNG has a truncated chunk.');
      var length=view.getUint32(pos),end=pos+length+12;
      if(end>bytes.length||crc(bytes.subarray(pos+4,end-4))!==view.getUint32(end-4))throw new Error('Invalid print PNG integrity.');
      var type=String.fromCharCode.apply(null,bytes.subarray(pos+4,pos+8));
      if(count===1&&(type!=='IHDR'||length!==13))throw new Error('Invalid print PNG header.');
      if(type==='IDAT'){
        if(dataEnded)throw new Error('Print PNG image data is not contiguous.');
        if(idatIndex<0){idatIndex=parts.length;parts.push(null);}
        idatParts.push(bytes.subarray(pos+8,end-4));
      }else{
        if(idatIndex>=0)dataEnded=true;
        if(type!=='pHYs')parts.push(bytes.subarray(pos,end));
      }
      if(type==='IHDR')parts.push(density);
      pos=end;if(type==='IEND'){ended=true;break;}
    }
    if(!ended||pos!==bytes.length)throw new Error('Incomplete print PNG.');
    if(idatIndex<0)throw new Error('Print PNG image data is missing.');
    var idatSize=idatParts.reduce(function(n,p){return n+p.length;},0),idat=new Uint8Array(idatSize+12),idatView=new DataView(idat.buffer),idatOffset=8;
    idatView.setUint32(0,idatSize);idat.set([73,68,65,84],4);idatParts.forEach(function(p){idat.set(p,idatOffset);idatOffset+=p.length;});
    idatView.setUint32(idat.length-4,crc(idat.subarray(4,idat.length-4)));parts[idatIndex]=idat;
    if(parts.length>4097)throw new Error('Print PNG ancillary chunk count is unsupported.');
    var total=parts.reduce(function(n,p){return n+p.length;},0),out=new Uint8Array(total),offset=0;
    parts.forEach(function(p){out.set(p,offset);offset+=p.length;});
    var encoded=[];for(var at=0;at<out.length;at+=32768)encoded.push(String.fromCharCode.apply(null,out.subarray(at,at+32768)));
    return 'data:image/png;base64,'+btoa(encoded.join(''));
  }

  function saveUploadedArtwork(blob, project, sourceId, operation, normalization, signal, onStage, service) {
    // A real, privately stored raster source. It is not an AI/upscale job and
    // never creates service lineage, a billable result or a proof approval.
    if (!(blob instanceof Blob) || blob.type !== 'image/png' || !blob.size || blob.size > 32 * 1024 * 1024 ||
        !/^[A-Za-z0-9_-]{1,128}$/.test(project || '') || !/^[A-Za-z0-9:_-]{1,160}$/.test(sourceId || '')) {
      return Promise.reject(new Error('The selected upload cannot be privately associated with this project.'));
    }
    try {
      if (!window.NovaProfessionalServices || typeof window.NovaProfessionalServices.requirePersistedProjectId !== 'function') throw new Error('The artwork project identity owner is unavailable.');
      window.NovaProfessionalServices.requirePersistedProjectId(project);
    } catch (error) { return Promise.reject(error); }
    var checksum, dispatched = false, responseStatus = null;
    return blob.arrayBuffer().then(function (bytes) { return crypto.subtle.digest('SHA-256', bytes); })
      .then(function (digest) {
        checksum = Array.from(new Uint8Array(digest), function (byte) { return byte.toString(16).padStart(2, '0'); }).join('');
        return retainedProjectSession(signal, false, 0, 'ordinary-artwork');
      }).then(function (auth) {
        var upload = { project: project, sourceId: sourceId, checksum: checksum };
        if (normalization) upload.normalization = normalization;
        if (service) upload.service = service;
        var form = new FormData();
        form.append('metadata', JSON.stringify({ ownerSessionProof: auth.proof, operation: operation, upload: upload }));
        form.append('image', blob, 'nova-upload-source.png');
        if (typeof onStage === 'function') onStage('source-dispatched');
        dispatched = true;
        return fetch(auth.base + '/jobs/save-upload', { method: 'POST', redirect: 'error', body: form, signal: signal });
      }).then(function (response) {
        responseStatus = response.status;
        return response.json().catch(function () { return {}; }).then(function (saved) {
          var ref = saved.reference;
          if (!response.ok || !saved.ok || !ref || ref.kind !== 'upload' || ref.project !== project || ref.checksum !== checksum ||
              !/^[a-f0-9]{64}$/.test(ref.revision || '') || !ref.uploadId || !(saved.savedUntil > Date.now() / 1000)) {
            throw new Error('The uploaded artwork association was not verified. No artwork service was added.');
          }
          window.NovaProfessionalServices.requirePersistedProjectId(project);
          return saved;
        });
      }).catch(function (error) {
        if (dispatched || !error.novaArtworkDiagnostic) error.novaArtworkDiagnostic = { stage: 'source',
          code: responseStatus === null ? 'request_failed' : responseStatus >= 400 ? 'http_error' : 'invalid_response', status: responseStatus };
        throw error;
      });
  }

  function archiveApprovedProof(proofBlob,productionBlob,archive,operation,signal,onStage) {
    if (!(proofBlob instanceof Blob) || proofBlob.type !== 'image/png' || !proofBlob.size || proofBlob.size > 8 * 1024 * 1024) {
      return Promise.reject(new Error('The approved proof PNG is unavailable.'));
    }
    if (!(productionBlob instanceof Blob) || productionBlob.type !== 'image/png' || !productionBlob.size || productionBlob.size > 32 * 1024 * 1024) {
      return Promise.reject(new Error('The approved production PNG is unavailable.'));
    }
    if (!archive || !operation) return Promise.reject(new Error('The approved proof identity is incomplete.'));
    try {
      if (!window.NovaProfessionalServices || typeof window.NovaProfessionalServices.requirePersistedProjectId !== 'function') throw new Error('The artwork project identity owner is unavailable.');
      window.NovaProfessionalServices.requirePersistedProjectId(archive.project);
    } catch (error) { return Promise.reject(error); }
    var ordinaryArchive = archive.contract === 'nova-production-association-v2' && Array.isArray(archive.references) &&
      archive.references.every(function (reference) { return reference && reference.kind === 'upload'; });
    var dispatched = false, responseStatus = null;
    return (ordinaryArchive ? retainedProjectSession(signal, false, 0, 'ordinary-artwork') : preparedArtworkProof(signal)).then(function (auth) {
      var form = new FormData();
      form.append('metadata', JSON.stringify({ ownerSessionProof: auth.proof, archive: archive, operation: operation }));
      form.append('proof', proofBlob, 'nova-approved-proof.png');
      form.append('production', productionBlob, 'nova-production.png');
      if (typeof onStage === 'function') onStage('archive-dispatched');
      dispatched = true;
      return fetch(auth.base + '/jobs/archive-proof', { method: 'POST', redirect: 'error', body: form, signal: signal });
    }).then(function (response) {
      responseStatus = response.status;
      return response.json().catch(function () { return {}; }).then(function (payload) {
        if (!response.ok || !payload.ok || !payload.archiveLocator || payload.proofHash !== archive.expectedProofHash || payload.productionHash !== archive.expectedProductionHash) {
          var archiveError = new Error('The approved proof could not be archived without changing its identity.');
          archiveError.code = response.ok ? 'proof_archive_response_invalid' : 'proof_archive_http_error';
          archiveError.novaArtworkDiagnostic = { stage: 'archive', code: archiveError.code, status: response.status,
            errorClass: /^[a-z0-9_]{1,80}$/.test(payload.errorClass || '') ? payload.errorClass : null };
          throw archiveError;
        }
        window.NovaProfessionalServices.requirePersistedProjectId(archive.project);
        return payload;
      });
    }).catch(function (error) {
      if (!error.novaArtworkDiagnostic) error.novaArtworkDiagnostic = { stage: 'archive', dispatched: dispatched,
        code: responseStatus === null ? 'request_failed' : responseStatus >= 400 ? 'http_error' : 'invalid_response', status: responseStatus };
      throw error;
    });
  }

  function preparedArtworkProof(signal) {
    return retainedProjectSession(signal,true,5,'ordinary-artwork');
  }

  function preparedArtworkBody(master,proof,kind) {
    if(!master||master.version!=='transparent-print-v1'||!master.jobId||!master.masterHash||!master.revisionHash)throw new Error('The saved print master reference is unavailable.');
    var body={ownerSessionProof:proof,jobId:master.jobId,kind:kind,revision:master.revisionHash,checksum:master.masterHash};
    if(master.savedReference)body.reference=master.savedReference;
    return body;
  }

  function sharePreparedArtworkRead(key, read, signal) {
    if(signal && signal.aborted)return Promise.reject(new DOMException('Artwork read cancelled.','AbortError'));
    var record=preparedArtworkReads.get(key);
    if(!record){
      record={controller:new AbortController(),subscribers:new Set()};
      preparedArtworkReads.set(key,record);
      record.promise=Promise.resolve().then(function(){return read(record.controller.signal);}).finally(function(){
        if(preparedArtworkReads.get(key)===record)preparedArtworkReads.delete(key);
      });
    }
    return new Promise(function(resolve,reject){
      var subscriber={},settled=false;record.subscribers.add(subscriber);
      function release(){record.subscribers.delete(subscriber);if(signal)signal.removeEventListener('abort',cancel);}
      function cancel(){
        if(settled)return;settled=true;release();
        if(!record.subscribers.size){
          if(preparedArtworkReads.get(key)===record)preparedArtworkReads.delete(key);
          record.controller.abort();
        }
        reject(new DOMException('Artwork read cancelled.','AbortError'));
      }
      if(signal){signal.addEventListener('abort',cancel,{once:true});if(signal.aborted)cancel();}
      record.promise.then(function(blob){if(settled)return;settled=true;release();resolve(blob);},function(error){if(settled)return;settled=true;release();reject(error);});
    });
  }

  function loadPreparedArtwork(master,signal,options) {
    if(master&&master.incidentAccess)return Promise.reject(new Error('This ordinary artwork path cannot import administrative incident access. Keep the original authorized project.'));
    var productionRead = options && options.kind === 'production';
    if (options && (!productionRead || Object.keys(options).some(function (key) { return key !== 'kind'; }))) return Promise.reject(new Error('The selected artwork read is unsupported.'));
    if (productionRead && (!master || !master.production || master.incidentAccess || !/^[a-f0-9]{64}$/.test(master.production.hash || ''))) return Promise.reject(new Error('The exact retained production artifact is unavailable.'));
    function validate(response){
      if(!response.ok||response.headers.get('Content-Type')!=='image/png')return preparedArtifactFailure(response,'master');
      return response.blob();
    }
    function verify(blob){
      if(!blob.size||blob.size>64*1024*1024){var sizeError=new Error('The print master exceeds the supported size.');sizeError.errorClass='preview_format_invalid';throw sizeError;}
      return blob.arrayBuffer().then(function(bytes){return crypto.subtle.digest('SHA-256',bytes);}).then(function(hash){
        var actual=Array.from(new Uint8Array(hash),function(b){return b.toString(16).padStart(2,'0');}).join('');
        if(actual!==(productionRead ? master.production.hash : master.masterHash)){var integrityError=new Error('The print master identity changed.');integrityError.errorClass='preview_checksum_mismatch';throw integrityError;}
        return blob;
      });
    }
    if(master && master.incidentAccess)return incidentAccess('artifact',{requestId:master.incidentAccess.requestId,jobId:master.jobId,kind:'master'},signal).then(validate).then(verify);
    return preparedArtworkProof(signal).then(function(auth){
      var body=preparedArtworkBody(master,auth.proof,productionRead ? 'production' : 'master');
      // Editor bounds, readiness and proof may need the same artifact together.
      // Share only one in-flight, authenticated, fully checked immutable Blob;
      // never clone the transfer, cache access/results or replay a write.
      var key=JSON.stringify([body,productionRead ? master.production.hash : master.masterHash]);
      return sharePreparedArtworkRead(key,function(readSignal){
        return protectedArtworkRead(auth,'/jobs/artifact',body,readSignal).then(validate).then(verify);
      },signal);
    });
  }

  function inspectPreparedArtwork(master,signal) {
    if(master&&master.incidentAccess)return Promise.reject(new Error('This ordinary artwork path cannot import administrative incident access. Keep the original authorized project.'));
    if(master && master.incidentAccess)return incidentAccess('status',{requestId:master.incidentAccess.requestId,jobId:master.jobId},signal).then(function(data){
      if(!data.printMaster||data.printMaster.masterHash!==master.masterHash||data.printMaster.revisionHash!==master.revisionHash)throw new Error('The finite incident master no longer matches.');return data.printMaster;
    });
    if(signal&&signal.aborted)return Promise.reject(new DOMException('Artwork read cancelled.','AbortError'));
    return preparedArtworkProof(signal).then(function(auth){
      // Readiness and proof rendering inspect the same protected descriptor.
      // Share only an in-flight metadata read with identical auth and identity;
      // never cache authorization/results or coalesce a processing/write call.
      var body=preparedArtworkBody(master,auth.proof,'metadata'),key=JSON.stringify(body);
      var record=preparedMetadataReads.get(key);
      if(!record){
        record={controller:new AbortController(),subscribers:new Set()};
        preparedMetadataReads.set(key,record);
        record.promise=protectedArtworkRead(auth,'/jobs/artifact',body,record.controller.signal).then(function(response){
          if(!response.ok)return preparedArtifactFailure(response,'metadata');
          return response.json();
        }).then(function(data){
          var m=data.printMaster;
          if(!data.ok||!m||m.masterHash!==master.masterHash||m.revisionHash!==master.revisionHash)throw new Error('The print master reference is stale.');
          return m;
        }).finally(function(){if(preparedMetadataReads.get(key)===record)preparedMetadataReads.delete(key);});
      }
      return new Promise(function(resolve,reject){
        var subscriber={},settled=false;record.subscribers.add(subscriber);
        function release(){record.subscribers.delete(subscriber);if(signal)signal.removeEventListener('abort',cancel);}
        function cancel(){if(settled)return;settled=true;release();if(!record.subscribers.size)record.controller.abort();reject(new DOMException('Artwork read cancelled.','AbortError'));}
        if(signal){signal.addEventListener('abort',cancel,{once:true});if(signal.aborted)cancel();}
        record.promise.then(function(m){if(settled)return;settled=true;release();resolve(JSON.parse(JSON.stringify(m)));},function(error){if(settled)return;settled=true;release();reject(error);});
      });
    });
  }

  function savePreparedArtwork(master,project,operation) {
    if(master&&master.incidentAccess)return Promise.reject(new Error('This ordinary artwork path cannot import administrative incident access. Keep the original authorized project.'));
    try {
      if (!window.NovaProfessionalServices || typeof window.NovaProfessionalServices.requirePersistedProjectId !== 'function') throw new Error('The artwork project identity owner is unavailable.');
      window.NovaProfessionalServices.requirePersistedProjectId(project);
    } catch (error) { return Promise.reject(error); }
    if(master && master.incidentAccess){
      if(project!=='5da56803-1687-4e71-8df5-dc251bb3f4ba')return Promise.reject(new Error('The retained result belongs to the original incident project. This project was not changed.'));
      return incidentAccess('retain',{requestId:master.incidentAccess.requestId,jobId:master.jobId,operation:operation}).then(function(saved){return saved.printMaster;});
    }
    return preparedArtworkProof().then(function(auth){
      var reference={project:project,jobId:master.jobId,revision:master.revisionHash,checksum:master.masterHash};
      return aiSecurityJson(auth.base+'/jobs/save-artwork',{method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify({ownerSessionProof:auth.proof,reference:reference,operation:operation})})
        .then(function(saved){window.NovaProfessionalServices.requirePersistedProjectId(project);return Object.assign({},master,{savedReference:reference,savedUntil:saved.savedUntil});});
    });
  }

  function describePrivateArtwork(source, signal) {
    var ref = privateArtworkReference(source);
    if (!ref) return Promise.reject(new Error('The private artwork reference is invalid.'));
    var owner = artworkProjectOwner(), project = owner.getProjectId();
    owner.requirePersistedProjectId(project);
    return retainedProjectSession(signal,true,5,'ordinary-artwork').then(function (auth) {
      return protectedArtworkRead(auth,'/artwork/status',{id:ref[3]},signal,false,Date.now()+65000);
    }).then(function (response) {
      return response.json().then(function (result) {
        var artifact = result && result.artifact;
        owner.requirePersistedProjectId(project);
        if (!response.ok || !result || !result.ok || owner.getProjectId() !== project || !artifact ||
            artifact.project !== project || artifact.id !== ref[3] || artifact.checksum !== ref[4] || artifact.state !== 'ready') {
          throw new Error('The existing private artwork association could not be verified. No processing was submitted.');
        }
        return artifact;
      });
    });
  }

  function proofArchiveCapabilities(signal) {
    return aiSecurityJson(ENDPOINT.replace(/\/generate$/,'')+'/security-config',{method:'GET',signal:signal}).then(function(config){
      if(config.proofArchiveRead!==true||config.privateVectorArchiveSource!==true)throw new Error('The matching private archive service update is unavailable. Keep this page and artwork; no approval was submitted.');return config;
    });
  }

  // Passive descriptor read for verified display resources. The existing
  // authenticated reader remains the byte/checksum authority; this adds no
  // submission, public URL, ownership, or retention policy.
  function hash(blob){return blob.arrayBuffer().then(function(bytes){return crypto.subtle.digest('SHA-256',bytes);}).then(function(bytes){return Array.from(new Uint8Array(bytes),function(b){return b.toString(16).padStart(2,'0');}).join('');});}
  function owner(){
    var current=window.NovaProfessionalServices;
    if(current&&typeof current.requirePersistedProjectId==='function')return current;
    var key='nova-professional-services::'+window.location.pathname,record;
    try{record=JSON.parse(localStorage.getItem(key)||'null');}catch{}
    if(record&&typeof record.projectId==='string'&&/^[A-Za-z0-9_-]{1,128}$/.test(record.projectId))return {getProjectId:function(){return record.projectId;},requirePersistedProjectId:function(id){var saved=JSON.parse(localStorage.getItem(key)||'null');if(!saved||saved.projectId!==id||id!==record.projectId)throw Error('The preserved project changed. Keep this page open.');}};
    return {
      getProjectId:function(){
        var key='nova-private-artwork-project::'+window.location.pathname;
        var id=localStorage.getItem(key);
        if(!id){id=crypto.randomUUID();localStorage.setItem(key,id);}
        if(localStorage.getItem(key)!==id||!/^[a-f0-9-]{36}$/.test(id))throw Error('Artwork project storage is unavailable. Keep this page open.');
        return id;
      },
      requirePersistedProjectId:function(id){if(this.getProjectId()!==id)throw Error('The artwork project changed. Keep this page open.');}
    };
  }
  // Used only by the reused projectArtworkService function in this bundle.
  function artworkProjectOwner(){return owner();}
  function db(){
    if(databasePromise)return databasePromise;
    databasePromise=new Promise(function(resolve,reject){
      var request=indexedDB.open('nova-private-artwork-preservation',1);
      request.onupgradeneeded=function(){request.result.createObjectStore('records',{keyPath:'key'});};
      request.onerror=function(){reject(Error('Artwork preservation storage is unavailable. Keep this page open; do not refresh.'));};
      request.onblocked=request.onerror;
      request.onsuccess=function(){var database=request.result;database.onversionchange=function(){database.close();databasePromise=null;};resolve(database);};
    }).catch(function(error){databasePromise=null;throw error;});return databasePromise;
  }
  function transaction(mode,work){return db().then(function(database){return new Promise(function(resolve,reject){
    var tx=database.transaction('records',mode),result;
    tx.oncomplete=function(){resolve(result);};tx.onerror=tx.onabort=function(event){var error=Error('Artwork preservation did not complete. Keep this page open; do not refresh.');error.storageCode=tx.error&&tx.error.name||event&&event.target&&event.target.error&&event.target.error.name||'transaction_failed';reject(error);};
    try{var request=work(tx.objectStore('records'));request.onsuccess=function(){result=request.result;};}catch(error){error.storageCode=error.name;reject(error);tx.abort();}
  });});}
  function recordKey(slot){return context+'::'+owner().getProjectId()+'::'+String(slot);}
  function load(slot){return transaction('readonly',function(store){return store.get(recordKey(slot));}).then(function(record){
    if(!record)return null;
    if(!Number.isSafeInteger(record.expiresAt)||record.expiresAt<=Math.floor(Date.now()/1000))throw Error('This local preservation record has expired. Keep this page open; it cannot renew private artwork access.');
    if(record.context!==context||record.project!==owner().getProjectId()||!(record.fileBytes instanceof ArrayBuffer)||!record.fileBytes.byteLength||record.fileBytes.byteLength>10485760)throw Error('The preserved artwork belongs to another project or exceeds its limit. Keep this page open.');
    // Store bounded raw bytes instead of Blob/File handles. WebKit can report
    // UnknownError committing a serialized Blob even when ArrayBuffer works.
    record.file=new File([record.fileBytes],record.fileName,{type:record.mime});
    return hash(record.file).then(function(checksum){if(checksum!==record.checksum)throw Error('Preserved artwork integrity could not be verified. Keep this page open.');return record;});
  });}
  function preserve(slot,file,selection,operation){
    if(!(file instanceof Blob)||!file.size||file.size>10485760)return Promise.reject(Error('Artwork cannot be safely preserved. Keep this page open; do not refresh.'));
    var project=owner().getProjectId();owner().requirePersistedProjectId(project);
    var snapshot=JSON.parse(JSON.stringify(selection||{}));
    return file.arrayBuffer().then(function(bytes){return crypto.subtle.digest('SHA-256',bytes).then(function(digest){return {bytes:bytes,checksum:Array.from(new Uint8Array(digest),function(b){return b.toString(16).padStart(2,'0');}).join('')};});}).then(function(source){
      var checksum=source.checksum,record={key:recordKey(slot),context:context,project:project,fileBytes:source.bytes,fileName:file.name||'artwork',mime:file.type,checksum:checksum,selection:snapshot,operation:operation||null};
      return transaction('readonly',function(store){return store.get(record.key);}).then(function(previous){
        record.expiresAt=Math.min(previous&&previous.checksum===checksum?previous.expiresAt:Math.floor(Date.now()/1000)+30*86400,operation&&operation.artifact&&operation.artifact.expiresAt||Infinity);
        return transaction('readwrite',function(store){return store.put(record);});
      }).then(function(){return load(slot);}).then(function(saved){
        if(!saved||saved.project!==project||saved.checksum!==checksum||JSON.stringify(saved.selection)!==JSON.stringify(snapshot)||JSON.stringify(saved.operation)!==JSON.stringify(record.operation))throw Error('Artwork preservation readback did not match. Keep this page open.');
        return saved;
      });
    });
  }
  function restore(slot,apply,readSelection){
    return load(slot).then(function(record){
      if(!record)return false;
      return Promise.resolve(apply(record)).then(function(){return readSelection();}).then(function(actual){
        if(JSON.stringify(actual)!==JSON.stringify(record.selection))throw Error('Artwork restoration has not been verified. Keep the older page open; do not refresh it.');
        return record;
      });
    });
  }
  function reconcileLegacy(operation){
    if(operation&&operation.transport==='anonymous-legacy'&&operation.state!=='confirmed-ready')throw Error('An earlier vector request has an unknown outcome. Keep this page open. Twisted Swag must check that existing request before another submission; no new processing was requested.');
  }
  function submit(slot,file,vector,selection,stage){
    // Mixed cached controller versions must stop before any private write or
    // paid dispatch. A new adapter cannot make an old editor read private URLs.
    var consumers=window.NovaProjectArtworkConsumers||{};
    if(window.NovaAiGenerationAPI&&window.NovaProfessionalServices&&consumers.core!=='private-project-v1'&&typeof window.NovaAiGenerationAPI.projectArtworkService!=='function')return Promise.reject(Error('This page has mixed artwork versions. Keep it open; do not refresh until its artwork and selection are preserved and restoration is verified. No processing was submitted.'));
    var key=recordKey(slot);if(active.has(key))return active.get(key);
    var saved;
    var promise=(vector?window.NovaProjectArtworkAccess.vectorFees.ensureCatalog():Promise.resolve()).then(function(){return load(slot);}).then(function(prior){
      if(prior)reconcileLegacy(prior.operation);
      return preserve(slot,file,selection,prior&&prior.operation);
    }).then(function(record){
      saved=record;
      // Existing private operations reconcile through the authenticated read
      // route before any new submission. Unknown legacy attempts stay blocked.
      if(record.operation&&record.operation.source){
        var currentApi=window.NovaAiGenerationAPI;
        return (currentApi&&currentApi.reconcilePrivateArtwork?currentApi.reconcilePrivateArtwork(record.operation.source):reconcilePrivateArtwork(record.operation.source)).then(function(result){
          if(!result.ok)throw Error('The existing vector request could not be reconciled. Do not submit again.');
          if(result.artifact&&result.artifact.state!=='ready')throw Error('The existing vector request is not ready. Do not submit again.');
          if(!result.artifact&&record.operation.state==='dispatch-intent')throw Error('The previous dispatch has not been confirmed. Keep this page open; do not resubmit while it is reconciled.');
          return result;
        });
      }
    }).then(function(){
      var currentApi=window.NovaAiGenerationAPI,submit=currentApi&&currentApi.projectArtworkService||projectArtworkService;
      return submit(file,vector,saved.checksum,undefined,stage,function(source){
        return preserve(slot,file,selection,{transport:'private-project-v1',source:source.id,state:'source-only'}).then(function(){
          return preserve(slot,file,selection,{transport:'private-project-v1',source:source.id,state:'dispatch-intent'});
        });
      });
    }).then(function(result){return preserve(slot,file,selection,{transport:'private-project-v1',source:result.privateArtifact.source||result.privateArtifact.id,state:'confirmed-ready',artifact:result.privateArtifact,previewUrl:result.previewUrl||''}).then(function(){return result;});});
    active.set(key,promise);return promise.finally(function(){if(active.get(key)===promise)active.delete(key);});
  }
  function sourceResponse(source,options){var api=window.NovaAiGenerationAPI;return privateArtworkReference(source)?(api&&api.readPrivateArtwork?api.readPrivateArtwork(source,options&&options.signal):readPrivateArtwork(source,options&&options.signal)).then(function(blob){return new Response(blob);}):fetch(source,options);}
  var images=new Map();
  function image(source,loader){if(images.has(source))return images.get(source);var read=sourceResponse(source).then(function(response){if(!response.ok)throw Error('Artwork retrieval failed.');return response.blob();}).then(function(blob){var url=URL.createObjectURL(blob);return loader(url).finally(function(){URL.revokeObjectURL(url);});}).catch(function(error){images.delete(source);throw error;});images.set(source,read);return read;}
  if(!window.NovaAiGenerationAPI||!window.NovaAiGenerationAPI.projectArtworkService){
    document.addEventListener('click',clearAiSessionForLogout,true);document.addEventListener('submit',clearAiSessionForLogout,true);
    document.addEventListener('visibilitychange',function(){try{armAiSessionExpiry(aiSessionAnchor());}catch(error){}});
  }
  window.NovaProjectArtworkAccess={version:'private-project-v1',owner:owner,checksum:hash,preserve:preserve,restore:restore,load:load,submit:submit,reconcileLegacy:reconcileLegacy,sourceResponse:sourceResponse,image:image,isPrivateArtwork:function(source){return !!privateArtworkReference(source);},readPrivateArtwork:readPrivateArtwork,describePrivateArtwork:describePrivateArtwork};
  installPrivateArtworkDisplay();
  installAutomaticVectorFees();
  installNonGoldenProofService();
  installSimpleBackgroundAccess();
  installCurrentProcessingAccess();
  installPreparedArtworkAccess();
  // Preparation-only helper for the existing final-proof controller. No event
// listeners, global controller, provider dispatch or fallback local approval.
// The server adapters must be reviewed before wiring this into a runtime build.
function createProofArchiveTransaction({store, server, current, uuid, now}) {
  if (!store || !server || !current || !uuid || !now) throw Error('archive_dependencies_required');
  const active = new Map();
  const copy = value => JSON.parse(JSON.stringify(value));
  const digest = value => typeof value === 'string' && /^[a-f0-9]{64}$/.test(value);
  function binding(value) {
    if (!value || !value.project || !value.revision || !value.fingerprint) throw Error('proof_identity_required');
    return [value.project, value.revision, value.fingerprint].join('::');
  }
  function same(a, b) { return binding(a) === binding(b); }
  function assertCurrent(plan, signal) {
    if (signal?.aborted) throw Error('archive_cancelled_reconcile_required');
    if (!same(plan, current())) throw Error('proof_changed_reconcile_required');
  }
  function validatePlan(plan) {
    binding(plan);
    if (!plan.operation || !plan.approvalId || !Number.isFinite(Date.parse(plan.approvedAt)) ||
        !Array.isArray(plan.locations) || !plan.locations.length || plan.locations.length > 7 ||
        new Set(plan.locations.map(x => x.location)).size !== plan.locations.length ||
        plan.locations.some(x => !x.location || !digest(x.proofHash) || !digest(x.productionHash) || !x.composition)) {
      throw Error('immutable_archive_plan_required');
    }
  }
  function validateReceipt(plan, receipt) {
    validatePlan(plan);
    if (!receipt || receipt.project !== plan.project || receipt.revision !== plan.revision ||
        receipt.fingerprint !== plan.fingerprint || receipt.operation !== plan.operation ||
        receipt.approvalId !== plan.approvalId || receipt.approvedAt !== plan.approvedAt ||
        receipt.status !== 'approved-and-archived' || receipt.ownershipVerified !== true ||
        !Array.isArray(receipt.locations) || receipt.locations.length !== plan.locations.length ||
        new Set(receipt.locations.map(x => x.locator)).size !== plan.locations.length) throw Error('archive_receipt_mismatch');
    for (const location of plan.locations) {
      const saved = receipt.locations.find(x => x.location === location.location);
      if (!saved || !saved.locator || saved.proofHash !== location.proofHash ||
          saved.productionHash !== location.productionHash || saved.compositionHash !== location.compositionHash ||
          !digest(location.compositionHash)) throw Error('archive_receipt_mismatch');
    }
    return copy(receipt);
  }
  async function commit(plan, receipt, signal) {
    assertCurrent(plan, signal);
    const checked = validateReceipt(plan, receipt);
    // An immutable server receipt is necessary but browser persistence can still
    // fail. The caller receives lock:true only after its exact readback succeeds.
    const saved = {version:1, binding:binding(plan), operation:plan.operation, plan:copy(plan), receipt:checked};
    const previous = await store.readApproval(plan.project);
    if (previous && JSON.stringify(previous) !== JSON.stringify(saved)) {
      // Preserve immutable historical records before replacing the current
      // pointer, including old browser-only approvals. Never relabel them.
      const history = await store.preserveHistory(plan.project, copy(previous));
      if (JSON.stringify(history) !== JSON.stringify(previous)) throw Error('approval_history_unconfirmed');
    }
    assertCurrent(plan, signal);
    await store.writeApproval(plan.project, saved);
    const readback = await store.readApproval(plan.project);
    assertCurrent(plan, signal);
    if (JSON.stringify(readback) !== JSON.stringify(saved)) throw Error('approval_storage_unconfirmed');
    return {lock:true, approval:readback};
  }
  function exclusive(project, run) {
    if (active.has(project)) return active.get(project);
    const task = Promise.resolve().then(run).finally(() => {
      if (active.get(project) === task) active.delete(project);
    });
    active.set(project, task);
    return task;
  }
  function submit(review, signal) {
    return exclusive(review?.project, async () => {
      binding(review); assertCurrent(review, signal);
      let prior = await store.readPending(review.project);
      if (prior && !same(prior, review) && server.inspectPrevious && store.retirePending) {
        // A completed immutable operation must not permanently occupy the
        // pending slot. Reconcile it read-only before atomically retiring that
        // exact operation; preserve its identity/history, never replay it for
        // the newer design or infer new consent from the older approval.
        validateReceipt(prior, await server.inspectPrevious(copy(prior), signal));
        assertCurrent(review, signal);
        await store.retirePending(review.project, prior.operation);
        prior = await store.readPending(review.project);
      }
      let plan;
      if (prior && same(prior, review)) {
        plan = prior;
        validatePlan(plan);
        if (!plan.explicitConsent || plan.explicitConsent.binding !== binding(review)) throw Error('explicit_review_required');
      } else {
        if (prior) throw Error('earlier_archive_requires_reconciliation');
        if (!review.consent || review.consent.binding !== binding(review) || review.consent.terms !== true ||
            review.consent.artworkRights !== true || review.consent.reviewedProof !== true) throw Error('explicit_review_required');
        plan = {...copy(review), operation:uuid(), approvalId:uuid(), approvedAt:now(),
          explicitConsent:copy(review.consent)};
        delete plan.consent;
        validatePlan(plan);
        // The existing IndexedDB owner must claim this in ONE readwrite
        // transaction. localStorage read/then-write is not a cross-tab mutex.
        plan = await store.claimPending(review.project, plan);
        if (!plan || !same(plan, review) || !plan.explicitConsent ||
            plan.explicitConsent.binding !== binding(review)) throw Error('earlier_archive_requires_reconciliation');
        validatePlan(plan);
        if (JSON.stringify(await store.readPending(review.project)) !== JSON.stringify(plan)) throw Error('pending_storage_unconfirmed');
      }
      assertCurrent(plan, signal);
      // Always read first: a response can be lost after a successful commit.
      const existing = await server.inspect(copy(plan), signal);
      assertCurrent(plan, signal);
      if (existing?.status === 'approved-and-archived') return commit(plan, existing, signal);
      if (!existing || existing.status !== 'not-found') throw Error('archive_reconciliation_unavailable');
      if(plan.requiresSourceResolution&&!plan.sourcesResolved){
        if(!server.prepareImmutable||!store.finalizePending)throw Error('source_resolution_dependencies_required');
        const resolved=await server.prepareImmutable(copy(plan),signal);
        assertCurrent(plan,signal);validatePlan(resolved);
        // Resolution may add only the exact authenticated source references
        // and quality acknowledgments to the already-consented composition.
        // It cannot change pixels, physical placement, garments, identity or
        // consent while turning an upload receipt into an archive plan.
        const before=copy(plan),check=copy(resolved);delete check.sourcesResolved;
        if(check.locations.length!==before.locations.length)throw Error('resolved_archive_plan_mismatch');
        check.locations.forEach((location,index)=>{
          delete location.resolvedReferences;delete location.composition.qualityAcknowledgements;
          location.compositionHash=before.locations[index].compositionHash;
        });
        if(resolved.sourcesResolved!==true||JSON.stringify(check)!==JSON.stringify(before))throw Error('resolved_archive_plan_mismatch');
        plan=await store.finalizePending(plan.project,copy(plan),copy(resolved));
        if(JSON.stringify(plan)!==JSON.stringify(resolved)||JSON.stringify(await store.readPending(plan.project))!==JSON.stringify(resolved))throw Error('pending_storage_unconfirmed');
      }
      // submitImmutable MUST use the same immutable operation per location and
      // server-enforced idempotency across concurrent tabs. A local mutex alone
      // cannot establish this guarantee. No new identity is generated here.
      await server.submitImmutable(copy(plan), signal);
      assertCurrent(plan, signal);
      const confirmed = await server.inspect(copy(plan), signal);
      return commit(plan, confirmed, signal);
    });
  }
  async function reopen(project, signal) {
    const approval = await store.readApproval(project);
    if (!approval) return {lock:false, reason:'no-durable-approval'};
    // Historical browser-only records are preserved verbatim, never upgraded
    // into authenticated consent and never sent to a new archive operation.
    if (approval.version !== 1 || !approval.receipt || !approval.plan) return {lock:false, reason:'historical-local-approval'};
    assertCurrent(approval.plan, signal);
    validateReceipt(approval.plan, approval.receipt);
    const verified = await server.inspect(copy(approval.plan), signal);
    validateReceipt(approval.plan, verified);
    assertCurrent(approval.plan, signal);
    return {lock:true, approval:copy(approval)};
  }
  return Object.freeze({submit, reopen});
}

// Transport/storage adapters for the existing final-proof controller. No UI
// controller, automatic approval, public artifact URL or provider submission.
function installNonGoldenProofService() {
  var access=window.NovaProjectArtworkAccess;
  if(!access||access.proofService)return;
  function project(){var p=access.owner(),id=p.getProjectId();p.requirePersistedProjectId(id);return id;}
  function key(slot){return context+'::'+project()+'::proof-archive::'+slot;}
  function current(id){if(project()!==id)throw Error('The proof project changed. No approval was applied.');}
  function read(slot){return transaction('readonly',function(s){return s.get(key(slot));}).then(function(v){if(v&&v.project!==project())throw Error('Proof preservation ownership mismatch.');return v&&v.value;});}
  function write(slot,value){var id=project(),k=key(slot);return transaction('readwrite',function(s){return s.put({key:k,project:id,value:value});}).then(function(){current(id);return read(slot);}).then(function(saved){if(JSON.stringify(saved)!==JSON.stringify(value))throw Error('Proof preservation readback failed. No lock was applied.');return saved;});}
  function claimPending(id,value){
    current(id);var k=key('pending');
    return db().then(function(database){return new Promise(function(resolve,reject){
      var tx=database.transaction('records','readwrite'),s=tx.objectStore('records'),r=s.get(k),saved;
      tx.onerror=tx.onabort=function(){reject(Error('The approval operation could not be preserved. No archive was submitted.'));};
      r.onsuccess=function(){try{current(id);var old=r.result;if(old&&old.project!==id)throw Error('Proof operation ownership mismatch.');saved=old?old.value:value;if(!old)s.put({key:k,project:id,value:saved});}catch(e){reject(e);tx.abort();}};
      tx.oncomplete=function(){try{current(id);resolve(saved);}catch(e){reject(e);}};
    });});
  }
  function retirePending(id,operation){
    current(id);var pendingKey=key('pending'),historyKey=key('completed-'+operation);
    return db().then(function(database){return new Promise(function(resolve,reject){var tx=database.transaction('records','readwrite'),s=tx.objectStore('records'),r=s.get(pendingKey);
      r.onsuccess=function(){try{current(id);var row=r.result;if(!row)return;if(row.project!==id||row.value.operation!==operation)throw Error('The pending approval changed. It was not removed.');s.put({key:historyKey,project:id,value:row.value});s.delete(pendingKey);}catch(error){reject(error);tx.abort();}};
      tx.oncomplete=resolve;tx.onerror=tx.onabort=function(){reject(Error('The completed approval operation could not be preserved.'));};
    });});
  }
  function finalizePending(id,before,after){
    current(id);return db().then(function(database){return new Promise(function(resolve,reject){var tx=database.transaction('records','readwrite'),s=tx.objectStore('records'),r=s.get(key('pending')),saved;
      r.onsuccess=function(){try{current(id);var row=r.result;if(!row||row.project!==id||row.value.operation!==before.operation)throw Error('The pending approval changed before source resolution.');if(JSON.stringify(row.value)===JSON.stringify(after)){saved=row.value;return;}if(JSON.stringify(row.value)!==JSON.stringify(before))throw Error('The pending approval has a conflicting resolution.');s.put({key:key('pending'),project:id,value:after});saved=after;}catch(error){reject(error);tx.abort();}};
      tx.oncomplete=function(){resolve(saved);};tx.onabort=tx.onerror=function(){reject(Error('Resolved-source approval persistence failed. No archive was confirmed.'));};
    });});
  }
  function archiveRead(input,signal){
    var id=project();if(!input||input.project!==id)return Promise.reject(Error('The saved proof belongs to another project.'));
    var callerSignal=signal,controller=new AbortController(),timer=setTimeout(function(){controller.abort();},65000);function cancel(){controller.abort();}if(callerSignal){callerSignal.addEventListener('abort',cancel,{once:true});if(callerSignal.aborted)cancel();}signal=controller.signal;
    return retainedProjectSession(signal,true,5,'ordinary-artwork').then(function(auth){
      return protectedArtworkRead(auth,'/jobs/read-proof-archive',{input:input},signal,false,Date.now()+65000);
    }).then(function(response){current(id);if(!response.ok)throw Error('The saved proof could not be verified. Your design remains preserved and unlocked.');
      if(input.kind)return response.blob().then(function(blob){
        if(blob.type!=='image/png'||!blob.size||blob.size>(input.kind==='proof'?8:32)*1024*1024)throw Error('The archived proof file is invalid.');
        return access.checksum(blob).then(function(checksum){current(id);if(checksum!==response.headers.get('X-Nova-Checksum'))throw Error('The archived proof checksum changed.');return{blob:blob,checksum:checksum};});
      });
      return response.json().then(function(result){current(id);if(!result.ok||['not-found','approved-and-archived'].indexOf(result.state)<0||result.state==='approved-and-archived'&&(!result.ownershipVerified||result.project!==id||result.projectRevision!==input.projectRevision||result.proofFingerprint!==input.proofFingerprint||result.approvalId!==input.approvalId||result.location!==input.location))throw Error('The saved proof identity could not be verified.');return result;});
    }).finally(function(){clearTimeout(timer);if(callerSignal)callerSignal.removeEventListener('abort',cancel);});
  }
  function putBytes(slot,blob,limit){
    var id=project();if(!Number.isSafeInteger(limit)||limit<1||limit>32*1024*1024||!(blob instanceof Blob)||!blob.size||blob.size>limit) return Promise.reject(Error('The proof file exceeds its preservation limit.'));
    return blob.arrayBuffer().then(function(bytes){return crypto.subtle.digest('SHA-256',bytes).then(function(digest){return{checksum:Array.from(new Uint8Array(digest),function(b){return b.toString(16).padStart(2,'0');}).join(''),mime:blob.type,bytes:bytes};});}).then(function(row){current(id);return transaction('readwrite',function(s){return s.put({key:key('bytes-'+slot),project:id,value:row});}).then(function(){return getBytes(slot,limit);}).then(function(saved){if(saved.checksum!==row.checksum||saved.blob.size!==blob.size)throw Error('Proof byte preservation failed.');return {slot:slot,checksum:row.checksum,bytes:blob.size,mime:blob.type};});});
  }
  function getBytes(slot,limit){return read('bytes-'+slot).then(function(row){if(!Number.isSafeInteger(limit)||limit<1||limit>32*1024*1024||!row||!(row.bytes instanceof ArrayBuffer)||!row.bytes.byteLength||row.bytes.byteLength>limit)throw Error('Preserved proof bytes are unavailable.');var blob=new Blob([row.bytes],{type:row.mime});return access.checksum(blob).then(function(actual){if(actual!==row.checksum)throw Error('Preserved proof integrity failed.');return {blob:blob,checksum:actual};});});}
  function shaText(value){return access.checksum(new Blob([value],{type:'text/plain'}));}
  function canonical(value){if(Array.isArray(value))return value.map(canonical);if(value&&typeof value==='object'){var out={};Object.keys(value).sort().forEach(function(k){out[k]=canonical(value[k]);});return out;}return value;}
  function preserveLocalApproval(approvalKey){
    var raw=localStorage.getItem(approvalKey);if(!raw)return;
    var value=JSON.parse(raw),id=String(value.approvalId||'historical')+'::'+String(value.approvedAt||'unknown'),historyKey=approvalKey+'::history::'+id;
    var previous=localStorage.getItem(historyKey);if(previous&&previous!==raw)throw Error('The historical approval has a conflicting identity. It was not removed.');
    if(!previous)localStorage.setItem(historyKey,raw);
    if(localStorage.getItem(historyKey)!==raw)throw Error('The historical approval could not be preserved. It was not removed.');
  }
  async function prepareSource(layer,placement,slot,rasterTarget,signal){
    var id=project(),source=String(layer.dataUrl||''),master=layer.printMaster;
    if(master&&master.jobId){
      var saved=master.savedReference;
      if(!saved||saved.project!==id||saved.jobId!==master.jobId||saved.checksum!==master.masterHash||saved.revision!==master.revisionHash)throw Error('The selected prepared result must be retained by this same project before approval.');
      var capabilities=await proofArchiveCapabilities(signal);if(capabilities.preparedMasterComposition!==true)throw Error('The verified master-composition archive service is unavailable. No approval was submitted.');
      var verified=await inspectPreparedArtwork(master,signal);if(verified.width!==master.width||verified.height!==master.height)throw Error('The archived master dimensions changed.');
      var descriptor=access.preparedArtifacts&&await access.preparedArtifacts.record(source);
      if(!descriptor||descriptor.master.masterHash!==master.masterHash)throw Error('The selected prepared source does not match its retained descriptor.');
      return {id:String(layer.id),pixels:{width:master.width,height:master.height},version:descriptor.kind==='ai'?'AI Generated Artwork':'Upscaled Artwork',checksum:master.masterHash,originalChecksum:master.originalHash,reference:{kind:'generated-source',artworkId:String(layer.id),project:id,jobId:saved.jobId,revision:saved.revision,checksum:saved.checksum,placement:placement}};
    }
    var descriptor=access.isPrivateArtwork(source)?await access.describePrivateArtwork(source,signal):null;
    var response=await access.sourceResponse(source,{signal:signal,redirect:'error'});
    if(!response.ok)throw Error('The approved source could not be retrieved.');
    var blob=await response.blob();if(!blob.size||blob.size>10*1024*1024)throw Error('The approved source exceeds its private upload limit.');
    var originalHash=await access.checksum(blob),vector=blob.type==='image/svg+xml',service;
    var imageSource=blob,svgDimensions;
    if(vector){
      var crop=placement.crop||{left:0,right:0,top:0,bottom:0};rasterTarget={width:Math.ceil(rasterTarget.width/(1-crop.left-crop.right)),height:Math.ceil(rasterTarget.height/(1-crop.top-crop.bottom))};
      var markup=await blob.text();
      // The same exact provider declaration exception as the accepted Golden
      // rasterizer. Unknown DTDs, external resources and active content fail.
      markup=markup.replace(/^(\uFEFF?\s*(?:<\?xml\s[^?]*\?>\s*)?)<!DOCTYPE\s+svg\s+PUBLIC\s+"-\/\/W3C\/\/DTD SVG 1\.1\/\/EN"\s+"http:\/\/www\.w3\.org\/Graphics\/SVG\/1\.1\/DTD\/svg11\.dtd"\s*>\s*/,'$1');
      var doc=new DOMParser().parseFromString(markup,'image/svg+xml'),root=doc.documentElement,vb=String(root.getAttribute('viewBox')||'').trim().split(/[\s,]+/).map(Number);
      if(/<!DOCTYPE|<!ENTITY/i.test(markup)||doc.querySelector('parsererror,script,foreignObject,image')||root.localName!=='svg'||vb.length!==4||!(vb[2]>0&&vb[3]>0)||!doc.querySelector('path,rect,circle,ellipse,line,polyline,polygon,text,use')||Array.from(doc.querySelectorAll('*')).some(function(node){return Array.from(node.attributes).some(function(a){return /^on/i.test(a.name)||/^(href|xlink:href)$/i.test(a.name)&&!/^#/.test(a.value)||Array.from(a.value.matchAll(/url\(([^)]*)\)/gi)).some(function(m){return !/^['"]?#[^'"\s]+['"]?$/.test(m[1].trim());});});})||Array.from(doc.querySelectorAll('style')).some(function(s){return /@import/i.test(s.textContent)||Array.from(s.textContent.matchAll(/url\(([^)]*)\)/gi)).some(function(m){return !/^['"]?#[^'"\s]+['"]?$/.test(m[1].trim());});}))throw Error('The vector contains unsupported external or active content.');
      svgDimensions={width:Math.ceil(parseFloat(root.getAttribute('width'))||vb[2]),height:Math.ceil(parseFloat(root.getAttribute('height'))||vb[3])};
      if(descriptor){if(descriptor.kind!=='vector'||descriptor.checksum!==originalHash||!descriptor.providerSource)throw Error('The private Vector lineage is unavailable.');service={artifactId:descriptor.id,sourceId:descriptor.source,preparedChecksum:descriptor.checksum,rawChecksum:descriptor.providerSource.checksum};}
      // Preserve the validated viewport and aspect ratio, rasterizing only an
      // explicit production derivative. The SVG/raw bytes remain unchanged.
      root.setAttribute('width',String(rasterTarget.width));root.setAttribute('height',String(rasterTarget.height));
      imageSource=new Blob([new XMLSerializer().serializeToString(doc)],{type:'image/svg+xml'});
    }else if(!['image/png','image/jpeg','image/webp','image/gif','image/bmp','image/x-ms-bmp'].includes(blob.type))throw Error('The approved source format is unsupported.');
    var result=await new Promise(function(resolve,reject){var url=URL.createObjectURL(imageSource),image=new Image();function finish(error,value){URL.revokeObjectURL(url);if(error)reject(error);else resolve(value);}image.onerror=function(){finish(Error('The approved source cannot be decoded.'));};image.onload=function(){try{
      var width=vector?rasterTarget.width:image.naturalWidth,height=vector?rasterTarget.height:image.naturalHeight;
      if(!Number.isSafeInteger(width)||!Number.isSafeInteger(height)||width<1||height<1||width>8400||height>8400||width*height>20*1024*1024)throw Error('The approved source dimensions exceed their resource limit.');
      var c=document.createElement('canvas');c.width=width;c.height=height;c.getContext('2d').drawImage(image,0,0,width,height);
      c.toBlob(function(png){if(!png)return finish(Error('The approved source derivative could not be preserved.'));finish(null,{blob:png,width:svgDimensions?svgDimensions.width:width,height:svgDimensions?svgDimensions.height:height});},'image/png');
    }catch(e){finish(e);}};image.src=url;});
    current(id);if(signal&&signal.aborted)throw Error('Proof preparation cancelled.');
    var preserved=await putBytes(slot,result.blob,32*1024*1024);
    return {id:String(layer.id),slot:slot,checksum:preserved.checksum,pixels:{width:vector?rasterTarget.width:result.width,height:vector?rasterTarget.height:result.height},version:vector?'Vector Artwork':layer.selectedProductionVersion==='background'?'Background Removed Artwork':'Original Artwork',originalChecksum:originalHash,placement:placement,service:service,normalization:{kind:'decoded-raster-to-png',original:{checksum:originalHash,mime:blob.type,width:result.width,height:result.height}}};
  }
  function transactionFor(currentProof){
    function check(plan,signal){current(plan.project);var now=currentProof();if(!now||now.project!==plan.project||now.revision!==plan.revision||now.fingerprint!==plan.fingerprint||signal&&signal.aborted)throw Error('The proof changed or was cancelled. Reconcile the saved operation before continuing.');}
    function input(plan,location){return {project:plan.project,projectRevision:plan.revision,location:location.location,proofFingerprint:plan.fingerprint,approvalId:plan.approvalId};}
    function verifyLocation(plan,location,row){
      if(row.state!=='approved-and-archived')return false;
      if(row.approvedAt!==plan.approvedAt||row.proofHash!==location.proofHash||row.productionHash!==location.productionHash||row.compositionHash!==location.compositionHash)throw Error('The archived proof differs from this approval. No local lock was applied.');
      return true;
    }
    async function inspect(plan,signal,previous){
      function stillCurrent(){if(previous){current(plan.project);if(signal&&signal.aborted)throw Error('Proof verification cancelled.');}else check(plan,signal);}
      stillCurrent();var found=[];
      // Sequential reads avoid multiplying the per-session artifact limit.
      for(var location of plan.locations){var row=await archiveRead(input(plan,location),signal);stillCurrent();if(verifyLocation(plan,location,row))found.push({location:location.location,locator:row.archiveLocator,proofHash:row.proofHash,productionHash:row.productionHash,compositionHash:row.compositionHash});}
      return found.length===plan.locations.length?{project:plan.project,revision:plan.revision,fingerprint:plan.fingerprint,operation:plan.operation,approvalId:plan.approvalId,approvedAt:plan.approvedAt,status:'approved-and-archived',ownershipVerified:true,locations:found}:{status:'not-found'};
    }
    async function submitImmutable(plan,signal){
      check(plan,signal);
      for(var location of plan.locations){
        var existing=await archiveRead(input(plan,location),signal);check(plan,signal);
        if(verifyLocation(plan,location,existing))continue;
        var references=location.resolvedReferences||[];
        if(!location.resolvedReferences){
        for(var source of location.sources){
          check(plan,signal);
          if(source.reference){references.push(source.reference);continue;}
          var bytes=await getBytes(source.slot,32*1024*1024);if(bytes.checksum!==source.checksum)throw Error('The approved source bytes changed.');
          // Layer IDs legitimately contain colons; operation IDs do not. Bind
          // the exact lineage into a deterministic digest, never relax the
          // server identifier guard or replace the original artwork identity.
          var uploadOperation='upload-'+await shaText(JSON.stringify([plan.project,plan.operation,location.location,source.id]));
          var uploaded=await saveUploadedArtwork(bytes.blob,plan.project,source.id,uploadOperation,source.normalization,signal,undefined,source.service);
          check(plan,signal);references.push(Object.assign({},uploaded.reference,{artworkId:source.id,placement:source.placement}));
        }
        }
        var proof=await getBytes(location.proofSlot,8*1024*1024),production=await getBytes(location.productionSlot,32*1024*1024);
        if(proof.checksum!==location.proofHash||production.checksum!==location.productionHash)throw Error('The preserved approval files changed.');
        var archive={contract:'nova-production-association-v2',project:plan.project,projectRevision:plan.revision,location:location.location,proofFingerprint:plan.fingerprint,approvalId:plan.approvalId,approvedAt:plan.approvedAt,expectedProofHash:location.proofHash,expectedProductionHash:location.productionHash,placement:location.composition,references:references};
        check(plan,signal);await archiveApprovedProof(proof.blob,production.blob,archive,plan.operation+'-'+location.location,signal);check(plan,signal);
      }
    }
    async function prepareImmutable(plan,signal){
      check(plan,signal);var resolved=JSON.parse(JSON.stringify(plan));
      for(var location of resolved.locations){
        var references=[],decisions=[];
        for(var source of location.sources){
          check(plan,signal);var reference=source.reference;
          if(!reference){var bytes=await getBytes(source.slot,32*1024*1024);if(bytes.checksum!==source.checksum)throw Error('The approved source bytes changed.');var op='upload-'+await shaText(JSON.stringify([plan.project,plan.operation,location.location,source.id]));var uploaded=await saveUploadedArtwork(bytes.blob,plan.project,source.id,op,source.normalization,signal,undefined,source.service);reference=Object.assign({},uploaded.reference,{artworkId:source.id,placement:source.placement});}
          references.push(reference);
          if(source.quality){if(!source.quality.review||source.quality.review.warningVersion!=='nova-low-resolution-v1')throw Error('Explicit current quality review is required.');decisions.push({warningVersion:'nova-low-resolution-v1',acknowledgedAt:source.quality.review.acknowledgedAt,project:plan.project,projectRevision:plan.revision,location:location.location,artworkId:source.id,sourceRevision:reference.revision,sourceChecksum:reference.checksum,placement:reference.placement,ppi:source.quality.ppi,widthIn:source.quality.widthIn,heightIn:source.quality.heightIn});}
        }
        location.resolvedReferences=references;
        if(decisions.length)location.composition=canonical(Object.assign({},location.composition,{qualityAcknowledgements:decisions}));
        location.compositionHash=await shaText(JSON.stringify(location.composition));
      }
      check(plan,signal);resolved.sourcesResolved=true;return resolved;
    }
    return createProofArchiveTransaction({current:currentProof,uuid:function(){return crypto.randomUUID();},now:function(){return new Date().toISOString();},
      store:{readPending:function(){return read('pending');},claimPending:claimPending,retirePending:retirePending,finalizePending:finalizePending,readApproval:function(){return read('approval');},writeApproval:function(id,value){current(id);return write('approval',value);},preserveHistory:function(id,value){current(id);return shaText(JSON.stringify(value)).then(function(hash){return write('history-'+hash,value);});}},
      server:{inspect:inspect,inspectPrevious:function(plan,signal){return inspect(plan,signal,true);},prepareImmutable:prepareImmutable,submitImmutable:submitImmutable}});
  }
// Pure construction after authenticated readback. This never writes a cart or
// promotes a historical local approval into a server-approved production job.
async function prepareAuthenticatedProofHandoff(items,cartContext){
  var gate=window.NovaCartApprovalGate,approval=gate&&gate.getVerifiedApproval&&gate.getVerifiedApproval();
  if(!approval||!approval.authenticatedArchive){
    if(gate&&gate.getArchiveVerificationState&&['checking','unverified'].indexOf(gate.getArchiveVerificationState())!==-1)throw Error('Verify the existing archived proof before continuing.');
    return items;
  }
  var plan=approval.authenticatedArchive.plan,id=project();
  if(!cartContext||cartContext.projectId!==id||id!==plan.project||!/^[A-Za-z0-9_-]{1,128}$/.test(cartContext.pairId||''))throw Error('The production handoff project or pair does not match the approved proof.');
  var expected=JSON.stringify(plan.garments),latest=await transactionFor(function(){
    var value=gate.getVerifiedApproval();
    return value&&value.approvalId===approval.approvalId?{project:id,revision:plan.revision,fingerprint:plan.fingerprint}:{project:id,revision:'changed',fingerprint:'changed'};
  }).reopen(id);
  if(!latest.lock||JSON.stringify(latest.approval)!==JSON.stringify(approval.authenticatedArchive))throw Error('The authenticated production handoff is not ready.');
  var copy=JSON.parse(JSON.stringify(items)),garments=[],decorations=[];
  copy.forEach(function(line){
    if(!Number.isSafeInteger(Number(line.id))||!Number.isSafeInteger(line.quantity)||line.quantity<1)throw Error('The ordered quantity is invalid.');
    var p=line.properties||(line.properties={}),kind=p._nova_line_type;
    if(!kind)kind=p._nova_service_key&&p['Professional Design Service']?'professional-service':p['Customization for']?'decoration':'merchandise';
    if(['merchandise','decoration','professional-service'].indexOf(kind)<0)throw Error('The production handoff contains an unknown line type.');
    p._nova_line_type=kind;p._nova_project_id=id;p._customization_pair_id=cartContext.pairId;
    if(kind==='merchandise')garments.push({variantId:String(line.id),quantity:line.quantity});
    if(kind==='decoration')decorations.push(line);
  });
  garments.sort(function(a,b){return a.variantId.localeCompare(b.variantId);});
  if(JSON.stringify(garments)!==expected||!decorations.length)throw Error('The ordered garments differ from the authenticated approved composition.');
  var association=gate.getProofArchiveAssociation(id,plan.locations.map(function(row){return row.location;}));
  if(!association||association.approvalId!==approval.approvalId)throw Error('The approved archive association changed.');
  var records=association.records.slice().sort(function(a,b){return a.location.localeCompare(b.location);});
  var group='nova-handoff-'+(await shaText(JSON.stringify([id,cartContext.pairId,approval.approvalId,records]))).slice(0,48);
  current(id);if(!gate.getVerifiedApproval()||gate.getVerifiedApproval().approvalId!==approval.approvalId)throw Error('The approved proof changed during handoff preparation.');
  copy.forEach(function(line){var p=line.properties;p['_NOVA Handoff Contract']='nova-proof-archive-v1';p['_NOVA Handoff Group']=group;p['_NOVA Handoff Project']=id;p['_NOVA Handoff Pair']=cartContext.pairId;p['_NOVA Handoff Member Count']=String(copy.length);});
  var carrier=decorations[0].properties;
  carrier['_NOVA Handoff Carrier']='proof-archive';carrier['_NOVA Proof Archive Associations']=JSON.stringify(records);
  carrier['_NOVA Approved Composition']=JSON.stringify(plan.locations.map(function(row){return {location:row.location,compositionHash:row.compositionHash,productionChecksum:row.productionHash};}));
  var artwork=[];plan.locations.forEach(function(location){(location.composition.artworkMetadata||[]).forEach(function(row){artwork.push(Object.assign({location:location.location,archiveLocator:records.find(function(r){return r.location===location.location;}).locator},row));});});
  copy.forEach(function(line){if(line.properties._nova_line_type!=='merchandise')return;var p=line.properties;
    Object.keys(p).forEach(function(k){if(/^Artwork [0-9]+ (Version|Location|Print Width|Print Height|Effective DPI|Production File|Print Quality|Background Removed|Enhanced Vector)$/.test(k))delete p[k];});
    artwork.forEach(function(row,index){var name='Artwork '+(index+1)+' ';p[name+'Version']=row.version;p[name+'Location']=row.location;p[name+'Print Width']=String(row.widthIn);p[name+'Print Height']=String(row.heightIn);p[name+'Effective DPI']=String(Math.floor(row.effectiveDpi));p[name+'Production File']='Approved archive '+row.archiveLocator;p[name+'Production Checksum']=records.find(function(r){return r.location===row.location;}).productionChecksum;p[name+'Source Checksum']=row.sourceChecksum;});
  });
  if(records.length===1){var row=records[0];carrier['_NOVA Proof Archive Locator']=row.locator;carrier['_NOVA Project Revision']=row.projectRevision;carrier['_NOVA Proof Fingerprint']=row.proofFingerprint;carrier['_NOVA Proof Hash']=row.proofHash;carrier['_NOVA Production Checksum']=row.productionChecksum;}
  return copy;
}

  access.proofService=Object.freeze({version:'private-proof-v1',handoff:prepareAuthenticatedProofHandoff,capabilities:proofArchiveCapabilities,read:archiveRead,transaction:transactionFor,
    canonical:canonical,hashText:shaText,prepareSource:prepareSource,preserveLocalApproval:preserveLocalApproval,
    hash:access.checksum,density:printPngDensity,upload:saveUploadedArtwork,archive:archiveApprovedProof,
    prepared:Object.freeze({read:loadPreparedArtwork,inspect:inspectPreparedArtwork,retain:savePreparedArtwork}),
    putBytes:putBytes,getBytes:getBytes,storage:{read:read,write:write,claimPending:claimPending}});
}

// Selection-only automatic service accounting. Called by the existing artwork
// and quote owners; it never processes pixels, approves a proof or submits a job.
function createBackgroundRemovalFees(access, selected) {
  var verified = new Map(), pending = new Map(), known = [], sequence = 0;
  var service = {variantId:70987465097469,sku:'NOVA-SVC-BG-15',priceCents:1500,title:'Professional Background Removal'};
  function project() { var owner=access.owner(),id=owner.getProjectId();owner.requirePersistedProjectId(id);return id; }
  function choices() {
    return selected().filter(function(row){return row && row.selected;});
  }
  // Keep references, not another potentially 100+ MiB JSON copy of data URLs.
  // These cache keys never replace the independently verified byte checksums.
  function identity(row) {
    var id=project(),key=known.find(function(k){return k.project===id&&k.original===row.original&&k.result===row.result;});
    if(!key){key={project:id,original:row.original,result:row.result,id:++sequence};known.push(key);}return key;
  }
  function selectionIdentity(){return choices().map(function(row){return identity(row).id;}).join('|');}
  async function bytes(reference) {
    var controller=new AbortController(),timer=setTimeout(function(){controller.abort();},20000);
    try {
      var response=await access.sourceResponse(reference,{redirect:'error',signal:controller.signal});
      if(!response.ok)throw Error('The selected background-removal artwork could not be verified. Your Original is unchanged.');
      var blob=await response.blob();
      if(!blob.size||blob.size>64*1024*1024)throw Error('The background-removal source exceeds its verification limit.');
      return blob;
    } finally { clearTimeout(timer); }
  }
  async function verify(row, fresh) {
    var id=project(),key=identity(row);
    if(!row.original||!row.result||row.result===row.original)throw Error('The background-removal result is not distinct from its Original.');
    if(!fresh&&verified.has(key))return verified.get(key);
    if(pending.has(key))return pending.get(key);
    var work=Promise.all([bytes(row.original),bytes(row.result)]).then(async function(blobs){
      var hashes=await Promise.all(blobs.map(function(blob){return access.checksum(blob);}));
      if(hashes[0]===hashes[1])throw Error('The background-removal result is unchanged.');
      if(project()!==id)throw Error('The background-removal project changed during verification.');
      var instance={serviceId:'background',billingServiceKey:'background-automatic',serviceInstanceId:'service-background-'+hashes[0]+'-'+hashes[1],
        variantId:service.variantId,priceCents:1500,sourceId:hashes[0],candidateId:hashes[1],checksum:hashes[1],status:'completed',title:service.title};
      verified.set(key,instance);return instance;
    });
    pending.set(key,work);return work.finally(function(){if(pending.get(key)===work)pending.delete(key);});
  }
  function snapshot() {
    var instances=[],missing=[],active=new Set();
    choices().forEach(function(row,index){var key=identity(row),instance=verified.get(key);
      active.add(key);
      if(!instance){missing.push('background-'+index);return;}
      if(!instances.some(function(other){return other.serviceInstanceId===instance.serviceInstanceId;}))instances.push(Object.assign({},instance,{variantId:service.variantId}));
    });
    known=known.filter(function(key){if(active.has(key)||pending.has(key))return true;verified.delete(key);return false;});
    instances.sort(function(a,b){return a.serviceInstanceId.localeCompare(b.serviceInstanceId);});
    var offering=instances.length?[Object.assign({},instances[0],{serviceInstanceId:'service-background-project-'+project(),billingKey:'background-project-service',artworkInstances:instances})]:[];
    return {instances:offering,cents:offering.length?1500:0,pending:missing.length>0,missing:missing};
  }
  async function restoreUsed() { for(var row of choices())await verify(row,false);return snapshot(); }
  async function catalog() {
    var root=window.Shopify&&window.Shopify.routes&&window.Shopify.routes.root||'/';
    var response=await fetch(root+'products/professional-design-services.js',{credentials:'same-origin',headers:{Accept:'application/json'}});
    if(!response.ok)throw Error('The $15 background-removal price could not be verified.');
    var product=await response.json(),matches=(product.variants||[]).filter(function(v){return Number(v.id)===service.variantId&&v.sku===service.sku;});
    var variant=matches.length===1?matches[0]:null;
    if(!variant||variant.title!==service.title||Number(variant.price)!==1500||variant.available===false)throw Error('The existing $15 background-removal service is not configured as expected.');
    service.variantId=Number(variant.id);
    return service;
  }
  async function getCartItems(context) {
    var id=project(),before=selectionIdentity();
    if(!context||context.projectId!==id)throw Error('The background-removal service belongs to another project.');
    for(var row of choices())await verify(row,true);var state=snapshot();
    if(state.pending)throw Error('Verify the selected background-removal result before continuing.');
    if(state.instances.length)await catalog();
    if(project()!==id||selectionIdentity()!==before)throw Error('The artwork selection changed while confirming its background-removal fee.');
    return state.instances.map(function(instance){return {id:service.variantId,quantity:1,properties:{
      _nova_project_id:id,_customization_pair_id:context.pairId||'',_nova_line_type:'professional-service',
      _nova_service_key:'background',_nova_service_instance_id:instance.serviceInstanceId,_nova_service_completion:'completed',
      _nova_background_artwork_instances:JSON.stringify(instance.artworkInstances),
      _nova_artwork_source_id:instance.sourceId,_nova_prepared_candidate_id:instance.candidateId,_nova_artwork_checksum:instance.checksum,
      'Professional Design Service':service.title,'Service for':context.parentProduct||''
    }};});
  }
  return Object.freeze({snapshot:snapshot,restoreUsed:restoreUsed,getCartItems:getCartItems});
}


function installSimpleBackgroundAccess(){
 if(window.NovaProjectArtworkAccess.background&&window.NovaProjectArtworkAccess.background.fees)return;
 var priorBackground=window.NovaProjectArtworkAccess.background,refused=new Set();
 var backgroundRefusals={has:function(hash){return refused.has(hash)||!!(priorBackground&&priorBackground.isRejected&&priorBackground.isRejected(hash));},add:function(hash){refused.add(hash);if(priorBackground&&priorBackground.reject)priorBackground.reject(hash);}};
  var BACKGROUND_REFUSAL = 'This tool removes mostly solid or simple backgrounds. It can’t reliably separate subjects from detailed scenes such as gravel, grass or furniture. Your original image has not been changed. Upload artwork with a simpler background or continue with the Original.';
  function backgroundUnsupportedError() {
    var error = new Error(BACKGROUND_REFUSAL);
    error.errorClass = 'background_unsupported_input';
    return error;
  }
  async function pixelDigest(pixels) {
    var digest = await crypto.subtle.digest('SHA-256', pixels);
    return Array.from(new Uint8Array(digest), function (value) { return value.toString(16).padStart(2, '0'); }).join('');
  }

  function clamp(value, minimum, maximum) {
    return Math.max(
      minimum,
      Math.min(
        maximum,
        value
      )
    );
  }

  function roundToTwo(value) {
    return Math.round(
      Number(value || 0) * 100
    ) / 100;
  }

  function rgbToHex(
    red,
    green,
    blue
  ) {
    function component(value) {
      return clamp(
        Math.round(value),
        0,
        255
      )
        .toString(16)
        .padStart(2, '0');
    }

    return (
      '#' +
      component(red) +
      component(green) +
      component(blue)
    );
  }

  function colorDistance(
    red,
    green,
    blue,
    target
  ) {
    var redDifference =
      red - target.red;

    var greenDifference =
      green - target.green;

    var blueDifference =
      blue - target.blue;

    return Math.sqrt(
      redDifference *
        redDifference +
      greenDifference *
        greenDifference +
      blueDifference *
        blueDifference
    );
  }

  function buildEdgeConnectedBackgroundMask(
    imageData,
    width,
    height,
    options
  ) {
    options =
      options || {};

    var data =
      imageData &&
      imageData.data;

    if (
      !data ||
      !width ||
      !height ||
      data.length !==
        width *
        height *
        4
    ) {
      throw new Error(
        'The artwork pixels could not be inspected for background removal.'
      );
    }

    var pixelCount =
      width *
      height;

    var stripWidth =
      clamp(
        Math.round(
          Math.min(
            width,
            height
          ) *
            0.003
        ),
        2,
        4
      );

    var samples = [];

    var edgeTotals = {
      top: 0,
      right: 0,
      bottom: 0,
      left: 0
    };

    function addSample(
      x,
      y,
      edge
    ) {
      var index =
        y *
          width +
        x;

      var offset =
        index *
        4;

      if (
        data[offset + 3] <
        16
      ) {
        return;
      }

      samples.push({
        index: index,
        edge: edge,
        red: data[offset],
        green: data[offset + 1],
        blue: data[offset + 2]
      });

      edgeTotals[edge] +=
        1;
    }

    for (
      var depth = 0;
      depth < stripWidth;
      depth += 1
    ) {
      for (
        var horizontal = 0;
        horizontal < width;
        horizontal += 1
      ) {
        addSample(
          horizontal,
          depth,
          'top'
        );

        addSample(
          horizontal,
          height -
            1 -
            depth,
          'bottom'
        );
      }

      for (
        var vertical = stripWidth;
        vertical <
          height -
            stripWidth;
        vertical += 1
      ) {
        addSample(
          depth,
          vertical,
          'left'
        );

        addSample(
          width -
            1 -
            depth,
          vertical,
          'right'
        );
      }
    }

    if (
      samples.length <
      16
    ) {
      throw backgroundUnsupportedError();
    }

    var buckets =
      Object.create(
        null
      );

    samples.forEach(
      function (sample) {
        var key =
          Math.floor(
            sample.red /
              32
          ) +
          ':' +
          Math.floor(
            sample.green /
              32
          ) +
          ':' +
          Math.floor(
            sample.blue /
              32
          );

        var bucket =
          buckets[key];

        if (!bucket) {
          bucket = {
            count: 0,
            red: 0,
            green: 0,
            blue: 0
          };

          buckets[key] =
            bucket;
        }

        bucket.count +=
          1;

        bucket.red +=
          sample.red;

        bucket.green +=
          sample.green;

        bucket.blue +=
          sample.blue;
      }
    );

    var bucketList =
      Object.keys(
        buckets
      ).map(
        function (key) {
          var bucket =
            buckets[key];

          return {
            count:
              bucket.count,
            red:
              bucket.red /
              bucket.count,
            green:
              bucket.green /
              bucket.count,
            blue:
              bucket.blue /
              bucket.count
          };
        }
      );

    bucketList.sort(
      function (
        first,
        second
      ) {
        return second.count -
          first.count;
      }
    );

    var selectedBucket =
      bucketList[0];

    var preferredTarget =
      options.preferredTarget;

    if (
      options.preferTarget &&
      preferredTarget
    ) {
      var maximumPreferredDistance =
        Math.max(
          48,
          Number(
            options.tolerance ||
              32
          ) *
            1.5
        );

      var preferredBuckets =
        bucketList.filter(
          function (bucket) {
            return (
              bucket.count /
                samples.length >=
                0.03 &&
              colorDistance(
                bucket.red,
                bucket.green,
                bucket.blue,
                preferredTarget
              ) <=
                maximumPreferredDistance
            );
          }
        );

      if (
        preferredBuckets.length
      ) {
        selectedBucket =
          preferredBuckets[0];
      } else {
        throw new Error(
          'A confident exterior background matching the selected color could not be detected.'
        );
      }
    }

    var model = {
      red:
        selectedBucket.red,
      green:
        selectedBucket.green,
      blue:
        selectedBucket.blue
    };

    var cluster = [];

    for (
      var refinement = 0;
      refinement < 2;
      refinement += 1
    ) {
      cluster =
        samples.filter(
          function (sample) {
            return colorDistance(
              sample.red,
              sample.green,
              sample.blue,
              model
            ) <=
              30;
          }
        );

      if (!cluster.length) {
        break;
      }

      model = {
        red:
          cluster.reduce(
            function (
              total,
              sample
            ) {
              return total +
                sample.red;
            },
            0
          ) /
          cluster.length,

        green:
          cluster.reduce(
            function (
              total,
              sample
            ) {
              return total +
                sample.green;
            },
            0
          ) /
          cluster.length,

        blue:
          cluster.reduce(
            function (
              total,
              sample
            ) {
              return total +
                sample.blue;
            },
            0
          ) /
          cluster.length
      };
    }

    if (!cluster.length) {
      throw backgroundUnsupportedError();
    }

    var variance =
      cluster.reduce(
        function (
          total,
          sample
        ) {
          var distance =
            colorDistance(
              sample.red,
              sample.green,
              sample.blue,
              model
            );

          return total +
            distance *
            distance;
        },
        0
      ) /
      cluster.length;

    var standardDeviation =
      Math.sqrt(
        variance
      );

    // This is color-based exterior removal, not semantic subject segmentation.
    // The old confidence test measured only a selected color cluster, allowing
    // textured photographs to pass and lose scattered patches of background.
    // A conservative near-uniform color boundary must run before any alpha
    // changes, preview replacement or stored-file upload. Increasing the user's
    // tolerance must not turn a complex scene into a claimed safe cutout.
    if (standardDeviation > 12) {
      throw backgroundUnsupportedError();
    }

    var edgeMatches = {
      top: 0,
      right: 0,
      bottom: 0,
      left: 0
    };

    cluster.forEach(
      function (sample) {
        edgeMatches[sample.edge] +=
          1;
      }
    );

    var edgeCoverage = {};

    Object.keys(
      edgeTotals
    ).forEach(
      function (edge) {
        edgeCoverage[edge] =
          edgeTotals[edge]
            ? edgeMatches[edge] /
              edgeTotals[edge]
            : 0;
      }
    );

    var coverage =
      cluster.length /
      samples.length;

    var substantialEdgeCount =
      Object.keys(
        edgeCoverage
      ).filter(
        function (edge) {
          return edgeCoverage[edge] >=
            0.2;
        }
      ).length;

    var minimumCoverage =
      options.preferTarget
        ? 0.12
        : 0.25;

    if (
      coverage <
        minimumCoverage ||
      standardDeviation >
        24 ||
      substantialEdgeCount <
        2
    ) {
      throw backgroundUnsupportedError();
    }

    function distanceAt(
      pixelIndex
    ) {
      var offset =
        pixelIndex *
        4;

      return colorDistance(
        data[offset],
        data[offset + 1],
        data[offset + 2],
        model
      );
    }

    if (options.assessmentOnly) return { supported: true, standardDeviation: standardDeviation, borderCoverage: coverage };

    var requestedTolerance =
      clamp(
        Number(
          options.tolerance ||
            32
        ),
        8,
        64
      );

    var seedTolerance =
      clamp(
        standardDeviation *
          2.5 +
          10,
        18,
        Math.max(
          22,
          requestedTolerance
        )
      );

    var growthTolerance =
      clamp(
        Math.max(
          requestedTolerance,
          seedTolerance +
            8,
          standardDeviation *
            4 +
            16
        ),
        seedTolerance +
          8,
        56
      );

    var maximumSeedCount =
      width *
        2 +
      Math.max(
        0,
        height -
          2
      ) *
        2;

    var seeds =
      new Int32Array(
        maximumSeedCount
      );

    var seedCount =
      0;

    function addSeed(
      pixelIndex
    ) {
      if (
        distanceAt(
          pixelIndex
        ) >
        seedTolerance
      ) {
        return;
      }

      seeds[seedCount] =
        pixelIndex;

      seedCount +=
        1;
    }

    for (
      var seedX = 0;
      seedX < width;
      seedX += 1
    ) {
      addSeed(
        seedX
      );

      addSeed(
        (
          height -
            1
        ) *
          width +
          seedX
      );
    }

    for (
      var seedY = 1;
      seedY <
        height -
          1;
      seedY += 1
    ) {
      addSeed(
        seedY *
          width
      );

      addSeed(
        seedY *
          width +
          width -
          1
      );
    }

    if (
      seedCount <
      Math.max(
        8,
        Math.floor(
          maximumSeedCount *
            0.05
        )
      )
    ) {
      throw backgroundUnsupportedError();
    }

    var visited =
      new Uint8Array(
        pixelCount
      );

    var queue =
      new Int32Array(
        pixelCount
      );

    var mask =
      new Uint8Array(
        pixelCount
      );

    var largestComponentSize =
      0;

    for (
      var seedIndex = 0;
      seedIndex < seedCount;
      seedIndex += 1
    ) {
      var componentSeed =
        seeds[seedIndex];

      if (
        visited[componentSeed]
      ) {
        continue;
      }

      var queueHead =
        0;

      var queueTail =
        0;

      visited[componentSeed] =
        1;

      queue[queueTail] =
        componentSeed;

      queueTail +=
        1;

      while (
        queueHead <
        queueTail
      ) {
        var current =
          queue[queueHead];

        queueHead +=
          1;

        var currentX =
          current %
          width;

        var currentY =
          Math.floor(
            current /
              width
          );

        var neighborCount =
          0;

        var neighbors = [
          0,
          0,
          0,
          0
        ];

        if (
          currentX > 0
        ) {
          neighbors[neighborCount] =
            current -
            1;

          neighborCount +=
            1;
        }

        if (
          currentX +
            1 <
          width
        ) {
          neighbors[neighborCount] =
            current +
            1;

          neighborCount +=
            1;
        }

        if (
          currentY > 0
        ) {
          neighbors[neighborCount] =
            current -
            width;

          neighborCount +=
            1;
        }

        if (
          currentY +
            1 <
          height
        ) {
          neighbors[neighborCount] =
            current +
            width;

          neighborCount +=
            1;
        }

        for (
          var neighborIndex = 0;
          neighborIndex <
            neighborCount;
          neighborIndex += 1
        ) {
          var neighbor =
            neighbors[neighborIndex];

          if (
            visited[neighbor] ||
            distanceAt(
              neighbor
            ) >
              growthTolerance
          ) {
            continue;
          }

          visited[neighbor] =
            1;

          queue[queueTail] =
            neighbor;

          queueTail +=
            1;
        }
      }

      if (
        queueTail >
        largestComponentSize
      ) {
        mask.fill(
          0
        );

        for (
          var componentIndex = 0;
          componentIndex <
            queueTail;
          componentIndex += 1
        ) {
          mask[
            queue[componentIndex]
          ] =
            1;
        }

        largestComponentSize =
          queueTail;
      }
    }

    var minimumMaskSize =
      Math.max(
        16,
        Math.floor(
          pixelCount *
            0.01
        )
      );

    if (
      largestComponentSize <
      minimumMaskSize
    ) {
      throw backgroundUnsupportedError();
    }

    var connectedEdgeCounts = {
      top: 0,
      right: 0,
      bottom: 0,
      left: 0
    };

    for (
      var connectedX = 0;
      connectedX < width;
      connectedX += 1
    ) {
      if (
        mask[connectedX]
      ) {
        connectedEdgeCounts.top +=
          1;
      }

      if (
        mask[
          (
            height -
              1
          ) *
            width +
            connectedX
        ]
      ) {
        connectedEdgeCounts.bottom +=
          1;
      }
    }

    for (
      var connectedY = 1;
      connectedY <
        height -
          1;
      connectedY += 1
    ) {
      if (
        mask[
          connectedY *
            width
        ]
      ) {
        connectedEdgeCounts.left +=
          1;
      }

      if (
        mask[
          connectedY *
            width +
            width -
            1
        ]
      ) {
        connectedEdgeCounts.right +=
          1;
      }
    }

    var connectedEdgeCoverage = {
      top:
        connectedEdgeCounts.top /
        width,
      right:
        connectedEdgeCounts.right /
        Math.max(
          1,
          height -
            2
        ),
      bottom:
        connectedEdgeCounts.bottom /
        width,
      left:
        connectedEdgeCounts.left /
        Math.max(
          1,
          height -
            2
        )
    };

    var connectedEdgeCount =
      Object.keys(
        connectedEdgeCoverage
      ).filter(
        function (edge) {
          return connectedEdgeCoverage[edge] >=
            0.1;
        }
      ).length;

    if (
      connectedEdgeCount <
      2
    ) {
      throw backgroundUnsupportedError();
    }

    var holeFillCount =
      0;

    for (
      var holePass = 0;
      holePass < 2;
      holePass += 1
    ) {
      var additions = [];

      for (
        var holeY = 1;
        holeY <
          height -
            1;
        holeY += 1
      ) {
        for (
          var holeX = 1;
          holeX <
            width -
              1;
          holeX += 1
        ) {
          var holeIndex =
            holeY *
              width +
            holeX;

          if (
            mask[holeIndex]
          ) {
            continue;
          }

          var matchingNeighbors =
            mask[
              holeIndex -
                1
            ] +
            mask[
              holeIndex +
                1
            ] +
            mask[
              holeIndex -
                width
            ] +
            mask[
              holeIndex +
                width
            ];

          if (
            matchingNeighbors >=
              3 &&
            distanceAt(
              holeIndex
            ) <=
              growthTolerance +
                12
          ) {
            additions.push(
              holeIndex
            );
          }
        }
      }

      additions.forEach(
        function (pixelIndex) {
          mask[pixelIndex] =
            1;
        }
      );

      holeFillCount +=
        additions.length;
    }

    var removedPixelCount =
      0;

    var proposedRemovalCount = 0;
    for (var proposedIndex = 0; proposedIndex < pixelCount; proposedIndex += 1) {
      if (mask[proposedIndex]) proposedRemovalCount += 1;
    }
    if (pixelCount - proposedRemovalCount < Math.max(4, Math.floor(pixelCount * 0.01))) {
      var missingForeground = new Error('A distinct foreground could not be preserved. Your original artwork has not been changed.');
      missingForeground.errorClass = 'result_mismatch';
      missingForeground.novaArtworkValidationRule = 'background_foreground';
      throw missingForeground;
    }

    for (
      var maskedIndex = 0;
      maskedIndex < pixelCount;
      maskedIndex += 1
    ) {
      if (
        !mask[maskedIndex]
      ) {
        continue;
      }

      data[
        maskedIndex *
          4 +
          3
      ] =
        0;

      removedPixelCount +=
        1;
    }

    var featherRadius =
      clamp(
        Math.round(
          Number(
            options.cleanup ||
              0
          )
        ),
        0,
        2
      );

    var featheredPixelCount =
      0;

    var featherFrontier =
      mask.slice();

    for (
      var featherPass = 0;
      featherPass <
        featherRadius;
      featherPass += 1
    ) {
      var nextFrontier =
        new Uint8Array(
          pixelCount
        );

      for (
        var featherIndex = 0;
        featherIndex < pixelCount;
        featherIndex += 1
      ) {
        if (
          mask[featherIndex]
        ) {
          continue;
        }

        var featherX =
          featherIndex %
          width;

        var featherY =
          Math.floor(
            featherIndex /
              width
          );

        var touchesFrontier =
          (
            featherX > 0 &&
            featherFrontier[
              featherIndex -
                1
            ]
          ) ||
          (
            featherX +
              1 <
              width &&
            featherFrontier[
              featherIndex +
                1
            ]
          ) ||
          (
            featherY > 0 &&
            featherFrontier[
              featherIndex -
                width
            ]
          ) ||
          (
            featherY +
              1 <
              height &&
            featherFrontier[
              featherIndex +
                width
            ]
          );

        if (!touchesFrontier) {
          continue;
        }

        var featherDistance =
          distanceAt(
            featherIndex
          );

        var featherLimit =
          growthTolerance +
          14 +
          featherPass *
            6;

        if (
          featherDistance >
          featherLimit
        ) {
          continue;
        }

        var featherAlpha =
          clamp(
            Math.round(
              64 +
              (
                featherDistance -
                  growthTolerance
              ) /
                Math.max(
                  1,
                  featherLimit -
                    growthTolerance
                ) *
                191
            ),
            64,
            255
          );

        var alphaOffset =
          featherIndex *
            4 +
          3;

        if (
          featherAlpha <
          data[alphaOffset]
        ) {
          data[alphaOffset] =
            featherAlpha;

          featheredPixelCount +=
            1;

          nextFrontier[featherIndex] =
            1;
        }
      }

      featherFrontier =
        nextFrontier;
    }

    return {
      backgroundColor:
        rgbToHex(
          model.red,
          model.green,
          model.blue
        ),
      backgroundRgb: {
        red:
          roundToTwo(
            model.red
          ),
        green:
          roundToTwo(
            model.green
          ),
        blue:
          roundToTwo(
            model.blue
          )
      },
      stripWidth:
        stripWidth,
      borderSampleCount:
        samples.length,
      clusterSampleCount:
        cluster.length,
      borderCoverage:
        roundToTwo(
          coverage *
            100
        ),
      variance:
        roundToTwo(
          variance
        ),
      standardDeviation:
        roundToTwo(
          standardDeviation
        ),
      edgeCoverage: {
        top:
          roundToTwo(
            edgeCoverage.top *
              100
          ),
        right:
          roundToTwo(
            edgeCoverage.right *
              100
          ),
        bottom:
          roundToTwo(
            edgeCoverage.bottom *
              100
          ),
        left:
          roundToTwo(
            edgeCoverage.left *
              100
          )
      },
      connectedEdgeCoverage: {
        top:
          roundToTwo(
            connectedEdgeCoverage.top *
              100
          ),
        right:
          roundToTwo(
            connectedEdgeCoverage.right *
              100
          ),
        bottom:
          roundToTwo(
            connectedEdgeCoverage.bottom *
              100
          ),
        left:
          roundToTwo(
            connectedEdgeCoverage.left *
              100
          )
      },
      substantialEdgeCount:
        substantialEdgeCount,
      connectedEdgeCount:
        connectedEdgeCount,
      seedTolerance:
        roundToTwo(
          seedTolerance
        ),
      growthTolerance:
        roundToTwo(
          growthTolerance
        ),
      seedCount:
        seedCount,
      connectedRemovedPixelCount:
        largestComponentSize,
      removedPixelCount:
        removedPixelCount,
      holeFillCount:
        holeFillCount,
      featheredPixelCount:
        featheredPixelCount,
      confidence:
        true
    };
  }

 async function assessBackgroundPixels(bytes,imageData,width,height){
   var hash=await pixelDigest(bytes);
   try{if(backgroundRefusals.has(hash))throw backgroundUnsupportedError();buildEdgeConnectedBackgroundMask(imageData,width,height,{assessmentOnly:true,tolerance:32,cleanup:1});return{sourceHash:hash,unsupported:false};}
   catch(error){if(error.errorClass==='background_unsupported_input')backgroundRefusals.add(hash);error.sourceHash=hash;throw error;}
 }
 var access=window.NovaProjectArtworkAccess,adapterSelections={};
 function selectedBackgrounds(){
   var rows=[],api=window.NovaImprintSurfaceAPI,layers=window.NovaArtworkLayerAPI,live=layers&&layers.getState&&layers.getState();
   function add(layer){if(layer&&layer.selectedProductionVersion==='background')rows.push({selected:true,original:layer.originalDataUrl,result:layer.dataUrl});}
   if(api&&api.getSelectedSurfaceIds&&api.getAllSurfaceStates){var saved=api.getAllSurfaceStates();api.getSelectedSurfaceIds().forEach(function(id){var spec=api.getSurfaceSpec(id),list=id===api.getActiveSurfaceId()&&live&&spec?live[spec.view]:saved[id]&&saved[id].artworkLayers;(list||[]).forEach(add);});}
   else if(live)Object.keys(live).forEach(function(view){if(Array.isArray(live[view]))live[view].forEach(add);});
   // In the garment editor, actual selected surface layers are authoritative.
   // Legacy card-radio mirrors must not retain a fee after the editor selects
   // Original. Standalone/card-only consumers still use their own selection.
   if(!api||!layers)Object.keys(adapterSelections).forEach(function(slot){rows.push(adapterSelections[slot]);});return rows;
 }
 var fees=createBackgroundRemovalFees(access,selectedBackgrounds);
 function notifyBackground(){
   var current=fees.snapshot();
   document.querySelectorAll('form[action*="/cart/add"]').forEach(function(form){
     [['_nova_background_service_instances',JSON.stringify(current.instances)],['Background Removal Service',current.instances.map(function(i){return 'Completed — '+i.serviceInstanceId;}).join(', ')]].forEach(function(pair){
       var input=form.querySelector('input[name="properties['+pair[0]+']"]');if(!input){input=document.createElement('input');input.type='hidden';input.name='properties['+pair[0]+']';form.appendChild(input);}input.value=pair[1];
     });
   });
   document.dispatchEvent(new CustomEvent('nova:automatic-vector-services-changed'));
 }
 window.NovaProjectArtworkAccess.background=Object.freeze({fees:fees,select:function(slot,result,original){adapterSelections[slot]={selected:!!result,result:result,original:original};notifyBackground();return fees.restoreUsed().then(notifyBackground);},assessBackgroundPixels:assessBackgroundPixels,mask:buildEdgeConnectedBackgroundMask,digest:pixelDigest,refusal:BACKGROUND_REFUSAL,unsupported:backgroundUnsupportedError,isRejected:function(hash){return backgroundRefusals.has(hash);},reject:function(hash){if(/^[a-f0-9]{64}$/.test(hash))backgroundRefusals.add(hash);}});
 // A second client can load after an older client installed the shared access
 // owner. Upgrade only its fee facade, retaining its existing Vector/AI ledger.
 var previous=access.vectorFees;
 if(previous&&!previous.backgroundOnUse)access.vectorFees=Object.freeze(Object.assign({},previous,{backgroundOnUse:true,
   snapshot:function(){var old=previous.snapshot(),bg=fees.snapshot();return{instances:old.instances.concat(bg.instances),cents:old.cents+bg.cents,pending:old.pending||bg.pending,missing:old.missing.concat(bg.missing)};},
   getCartItems:function(context){return Promise.all([previous.getCartItems(context),fees.getCartItems(context)]).then(function(groups){return groups[0].concat(groups[1]);});}
 }));
 ['nova:artwork-layers-changed','nova:project-state-restored','nova:imprint-surface-state-change','nova:imprint-history-restored','nova:authoritative-view-settled','nova:imprint-surface-change'].forEach(function(type){document.addEventListener(type,function(){notifyBackground();fees.restoreUsed().then(notifyBackground).catch(function(error){document.dispatchEvent(new CustomEvent('nova:artwork-display-error',{detail:{message:error.message}}));});});});
}


function installCurrentProcessingAccess(){
 var access=window.NovaProjectArtworkAccess;if(access.processing)return;
 var processingTab=crypto.randomUUID(),processingActive=new Map();
 function processingPendingKey(kind){return context+'::'+owner().getProjectId()+'::'+kind+'-pending-job';}
 function processingClaimKey(kind){return recordKey('processing-'+kind);}
 async function processingReleasePreDispatch(kind){
   var database=await db();await new Promise(function(resolve,reject){var tx=database.transaction('records','readwrite'),store=tx.objectStore('records'),request=store.get(processingClaimKey(kind));request.onsuccess=function(){var row=request.result;if(row&&row.tab===processingTab&&!row.pending){store.put(Object.assign({},row,{key:recordKey('processing-not-dispatched-'+row.requestJobId),state:'not-dispatched'}));store.delete(row.key);}};tx.oncomplete=resolve;tx.onabort=tx.onerror=reject;});
 }
 async function processingClaim(kind,identity,signal){
   var id=owner().getProjectId();owner().requirePersistedProjectId(id);
   if(signal&&signal.aborted)throw new DOMException('Artwork action cancelled.','AbortError');
   var database=await db();return new Promise(function(resolve,reject){
     var tx=database.transaction('records','readwrite'),store=tx.objectStore('records'),result,request=store.get(processingClaimKey(kind));
     request.onsuccess=function(){try{var prior=request.result;
       if(prior&&prior.project!==id)throw Error('The pending artwork operation belongs to another project.');
       if(prior&&!prior.accepted){
         if(prior.identity!==identity)throw Error('An earlier artwork request is unresolved. Check that same result before submitting another.');
         result=prior;
       }else{result={key:processingClaimKey(kind),project:id,identity:identity,tab:processingTab,requestJobId:crypto.randomUUID(),pending:null,accepted:false,previousJobId:prior&&prior.requestJobId||null};store.put(result);}
     }catch(error){reject(error);tx.abort();}};
     tx.oncomplete=function(){resolve(result);};tx.onabort=tx.onerror=function(){reject(Error('The processing identity could not be preserved. No new job was submitted.'));};
   });
 }
 async function processingPreservePending(kind,pending){
   var id=owner().getProjectId(),database=await db();
   await new Promise(function(resolve,reject){var tx=database.transaction('records','readwrite'),store=tx.objectStore('records'),request=store.get(processingClaimKey(kind));request.onsuccess=function(){try{var row=request.result;if(!row||row.project!==id||row.tab!==processingTab||row.requestJobId!==pending.id||row.accepted)throw Error('The processing operation changed before dispatch.');row.pending=JSON.parse(JSON.stringify(pending));store.put(row);}catch(error){reject(error);tx.abort();}};tx.oncomplete=resolve;tx.onabort=tx.onerror=function(){reject(Error('The existing job identity could not be persisted. No dispatch was requested.'));};});
   var saved=await transaction('readonly',function(store){return store.get(processingClaimKey(kind));});
   if(!saved||saved.project!==id||JSON.stringify(saved.pending)!==JSON.stringify(pending))throw Error('Pending-job readback failed. No dispatch was requested.');
 }
 async function processingComplete(kind,jobId){
   var id=owner().getProjectId(),database=await db(),claim=await transaction('readonly',function(store){return store.get(processingClaimKey(kind));});
   if(!claim||claim.project!==id||claim.requestJobId!==jobId||!claim.pending||claim.pending.id!==jobId)throw Error('The completed artwork does not match the preserved job.');
   var api=window.NovaImprintSurfaceAPI;if(!api||!api.saveActiveSurface)throw Error('The selected artwork cannot be durably verified.');api.saveActiveSurface({preserveReview:true});
   var raw=JSON.parse(localStorage.getItem('nova-imprint-surface-state-2e9zs::'+location.pathname+'::'+(new URLSearchParams(location.search).get('view')||'default'))||'null');
   var layers=Object.values(raw&&raw.surfaces||{}).flatMap(function(s){return s.artworkLayers||[];}),layer=layers.find(function(l){return l.printMaster&&l.printMaster.jobId===jobId&&access.preparedArtifacts.is(l.dataUrl);});
   if(!layer)throw Error('The selected result is not yet durably saved. Keep this page open and check the same job.');
   var descriptor=await access.preparedArtifacts.record(layer.dataUrl);if(descriptor.project!==id||descriptor.kind!==kind||descriptor.master.masterHash!==layer.printMaster.masterHash)throw Error('The saved insertion does not match its retained master.');
   owner().requirePersistedProjectId(id);
   await new Promise(function(resolve,reject){var tx=database.transaction('records','readwrite'),store=tx.objectStore('records'),request=store.get(claim.key);request.onsuccess=function(){var current=request.result;if(!current||current.requestJobId!==jobId||current.identity!==claim.identity){reject(Error('The processing operation changed.'));tx.abort();return;}current.accepted=true;store.put(current);store.put(Object.assign({},current,{key:recordKey('processing-accepted-'+jobId)}));};tx.oncomplete=resolve;tx.onabort=tx.onerror=reject;});
   var saved=await transaction('readonly',function(store){return store.get(claim.key);});if(!saved||!saved.accepted||saved.requestJobId!==jobId)throw Error('Completed-job readback failed.');
   var pending=JSON.parse(sessionStorage.getItem(processingPendingKey(kind))||'null');if(pending&&pending.id===jobId)sessionStorage.removeItem(processingPendingKey(kind));
 }
 async function processingCloseTerminal(kind,terminal){
   if(!terminal||!['failed','canceled'].includes(terminal.state))throw Error('The processing outcome is not confirmed.');
   var id=owner().getProjectId(),database=await db();owner().requirePersistedProjectId(id);
   await new Promise(function(resolve,reject){var tx=database.transaction('records','readwrite'),store=tx.objectStore('records'),request=store.get(processingClaimKey(kind));request.onsuccess=function(){var row=request.result;if(!row||row.project!==id||row.requestJobId!==terminal.jobId||!row.pending||row.pending.id!==terminal.jobId){reject(Error('The terminal job does not match this preserved request.'));tx.abort();return;}row.accepted=true;row.terminal=terminal.state;store.put(row);store.put(Object.assign({},row,{key:recordKey('processing-terminal-'+terminal.jobId)}));};tx.oncomplete=resolve;tx.onabort=tx.onerror=reject;});
   var saved=await transaction('readonly',function(store){return store.get(processingClaimKey(kind));});if(!saved||saved.requestJobId!==terminal.jobId||saved.terminal!==terminal.state)throw Error('Terminal-job readback failed.');
   var pending=JSON.parse(sessionStorage.getItem(processingPendingKey(kind))||'null');if(pending&&pending.id===terminal.jobId)sessionStorage.removeItem(processingPendingKey(kind));
 }
 function dataUrlToBlob(value){var m=/^data:([^;,]+);base64,(.*)$/.exec(value);if(!m)throw Error('The generated preview is unavailable.');var raw=atob(m[2]);return new Blob([Uint8Array.from(raw,function(c){return c.charCodeAt(0);})],{type:m[1]});}
 function authorizedAiFetch(payload,signal,current,onProgress){
   var base=ENDPOINT.replace(/\/generate$/,'');
   return aiSecurityJson(base+'/security-config',{method:'GET',signal:signal}).then(function(config){
     if(!config.durableJobs||!config.printMasterRequired)throw Error('The current authenticated artwork preparation service is unavailable. No generation was submitted.');
     if(payload.paidFinishing===false&&config.paidFinishingRestriction!==true)throw Error('The server cannot confirm the no-paid-finishing restriction. No generation was submitted.');
     payload.printTarget=resolveAiPrintTarget(current);return durableAiFetch(base,config,payload,signal,current,onProgress);
   }).then(function(result){if(!result||!result.durableResponse)throw Error('The authenticated job response is unavailable.');return result.durableResponse;});
 }
  function getPendingAiJob() {
    try { return JSON.parse(window.sessionStorage.getItem(processingPendingKey('ai')) || 'null'); } catch (error) { return null; }
  }

  function acceptPreparedAiResult(jobId) {
    var pending=getPendingAiJob();
    if(pending && pending.id===jobId) {
      try {window.sessionStorage.removeItem(processingPendingKey('ai'));} catch (error) {}
    }
  }

  function getPendingUpscaleJob() {
    try { return JSON.parse(sessionStorage.getItem(processingPendingKey('upscale')) || 'null'); } catch (error) { return null; }
  }

  function acceptPreparedUpscaleResult(jobId) {
    try {
      var pending = JSON.parse(sessionStorage.getItem(processingPendingKey('upscale')) || 'null');
      if (pending && pending.id === jobId) sessionStorage.removeItem(processingPendingKey('upscale'));
    } catch (error) { /* Retaining an old recovery locator is safer than resubmission. */ }
  }

  function resolveAiPrintTarget(context) {
    var surfaces = window.NovaImprintSurfaceAPI, sizes = window.NovaPrintSizeAPI;
    var id = context && context.targetSurfaceId;
    if (!id && surfaces && typeof surfaces.getSelectedSurfaceIds === 'function') {
      var selected = surfaces.getSelectedSurfaceIds();
      if (selected.length === 1) id = selected[0];
    }
    var spec = id && surfaces && surfaces.getSurfaceSpec(id);
    var size = id && sizes && sizes.getSize(id);
    if (!spec) {
      // The native mobile path intentionally does not initialize the desktop
      // canvas/surface owner. Read its existing live location and size owners;
      // never fabricate a surface spec or substitute maximum dimensions.
      var mobile = !surfaces && window.NovaMobileServiceAPI;
      var project = mobile && typeof mobile.getProjectContext === 'function' ? mobile.getProjectContext() : null;
      var selectedIds = project && Array.isArray(project.locationIds) ? project.locationIds : [];
      if (!id && selectedIds.length === 1) id = selectedIds[0];
      function invalidMobileTarget(message) {
        var error = new Error(message);
        error.errorClass = 'print_target_required';
        error.novaArtworkStage = 'service-source';
        throw error;
      }
      if (!id || selectedIds.indexOf(id) === -1) invalidMobileTarget('Select the intended print location before generating artwork.');
      if (!sizes || typeof sizes.getSize !== 'function' || typeof sizes.validateCustomSize !== 'function') invalidMobileTarget('The selected print size is unavailable.');
      if (typeof sizes.hasPendingEdits === 'function' && sizes.hasPendingEdits()) invalidMobileTarget('Apply the edited print size before generating artwork.');
      size = sizes.getSize(id);
      if (!size || size.valid === false) invalidMobileTarget('Finish the selected print size before generating artwork.');
      var mobileWidth = Number(size.width), mobileHeight = Number(size.height);
      if (!(Number.isFinite(mobileWidth) && Number.isFinite(mobileHeight) && mobileWidth > 0 && mobileHeight > 0) ||
          !sizes.validateCustomSize(id, mobileWidth, mobileHeight).valid) invalidMobileTarget('The selected print size is unavailable.');
      return {location:id,width:mobileWidth,height:mobileHeight,unit:'in',revision:'selected-fit-v1'};
    }
    // An invalid custom size is not permission to substitute the location cap.
    // Reject before authorization/admission; preserve the owner's entered size.
    if (size && size.valid === false) throw new Error('Finish the selected print size before generating artwork.');
    var width = size ? Number(size.width) : Number(spec.maxWidthIn);
    var height = size ? Number(size.height) : Number(spec.maxHeightIn);
    if (!(Number.isFinite(width) && Number.isFinite(height) && width > 0 && height > 0)) throw new Error('The selected print size is unavailable.');
    return {location:id,width:width,height:height,unit:'in',revision:'selected-fit-v1'};
  }

  function durableAiFetch(base, config, payload, signal, context, onProgress, retrieveOnly) {
    var proof = '', pending = null;
    function requestAi(path, init) {
      var owner = window.NovaUpscaleSafeDiagnostics, stage = 'ai-' + path.slice(1).replace(/\//g, '-');
      function capture(detail) { if (owner && owner.enabled) owner.capture(stage, Object.assign({tool:'ai-generation',jobId:pending && pending.id}, detail || {})); }
      capture();
      return aiSecurityJson(base + path, init, capture).then(function (data) {
        capture({state:data.state,errorClass:data.errorClass}); return data;
      }, function (error) {
        capture({event:'failed',status:error.status || error.novaSecurityStatus,errorClass:error.errorClass,code:error.novaSecurityCode}); throw error;
      });
    }
    function progress(stage, detail) {
      if (typeof onProgress !== 'function') return;
      try { onProgress(stage, detail); } catch (error) { /* Presentation cannot alter the accepted job. */ }
    }
    progress('checking');
    var started = Date.now(), key = processingPendingKey('ai'), finishingWakeRequested = false;
    function save() {
      try { window.sessionStorage.setItem(key, JSON.stringify(pending)); if(window.sessionStorage.getItem(key)!==JSON.stringify(pending))throw Error('pending identity readback failed'); }
      catch (error) { throw new Error('Browser recovery storage is unavailable. No generation job was submitted.'); }
    }
    function clear() { try { window.sessionStorage.removeItem(key); } catch (error) {} }
    function active() { if (signal && signal.aborted) throw new Error('Generation canceled. Accepted work may already have been dispatched; no automatic refund.'); }
    function readJob(recover) {
      active();
      return requestAi(recover === true ? '/jobs/recover' : '/jobs/status', { method: 'POST', headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ ownerSessionProof: proof, jobId: pending.id }), signal: signal }).catch(function (error) {
          error.novaAiStatusReadFailed = true;
          error.novaArtworkStage = 'service-response';
          throw error;
        }).then(function (job) {
        active();
        if (payload.paidFinishing === false && job.paidFinishing !== false) throw new Error('The existing job did not confirm its no-paid-finishing restriction. Stop and reconcile this job; do not generate again.');
        progress(job.state, {statusRead:true});
        if (job.state === 'preparation_failed' && job.errorClass === 'paid_finishing_prohibited' &&
            job.finishingAuthorization && job.finishingAuthorization.state === 'authorized' &&
            Number.isSafeInteger(job.finishingAuthorization.expiresAt) && job.finishingAuthorization.expiresAt > Date.now() / 1000 && !finishingWakeRequested) {
          finishingWakeRequested = true;
          return readJob(true); // Same authenticated job; never authorize or submit a generation.
        }
        if (job.state === 'preparation_failed') {
          var preparation = new Error(job.errorClass === 'paid_finishing_prohibited' ? 'Your generated image is preserved, but this print size needs paid finishing, which is prohibited for this job. No paid finishing was submitted.' : 'Your image was generated and preserved, but print PNG preparation did not finish. No new generation was started.');
          preparation.errorClass = job.errorClass || 'preparation_failed'; preparation.novaArtworkStage = 'service-processing'; throw preparation;
        }
        if (job.state === 'ready') {
          if (job.printMaster) {
            progress('downloading');
            return artworkReadWithRateLimit(base + '/jobs/artifact', {method:'POST',redirect:'error',headers:{'Content-Type':'application/json'},signal:signal,
              body:JSON.stringify({ownerSessionProof:proof,jobId:pending.id,kind:'preview'})},function(detail){progress('read-rate-limit',detail);},started+300000).then(function (response) {
              if (!response.ok || response.headers.get('Content-Type') !== 'image/png') throw new Error('The print master could not be retrieved. Your existing job is retained.');
              return response.blob();
            }).then(function (blob) {
              active();
              progress('validating');
              if (!blob.size || blob.size > 2 * 1024 * 1024) throw new Error('The display preview exceeds the supported delivery limit. Your existing job is retained.');
              return blob.arrayBuffer().then(function(bytes){return crypto.subtle.digest('SHA-256',bytes);}).then(function(digest){var actual=Array.from(new Uint8Array(digest),function(b){return b.toString(16).padStart(2,'0');}).join('');if(!job.printMaster.preview||actual!==job.printMaster.preview.hash){var mismatch=Error('The display preview did not match its verified artifact. The existing job is preserved; do not generate again.');mismatch.errorClass='preview_checksum_mismatch';throw mismatch;}return {durableResponse:{printArtifact:blob,printMaster:Object.assign({},job.printMaster,{jobId:pending.id}),filename:job.filename,jobId:pending.id}};});
            });
          }
          clear(); return { durableResponse: Response.json(job) };
        }
        if (['failed','canceled','uncertain'].indexOf(job.state) !== -1) {
          if(!retrieveOnly)clear();var stopped=new Error(job.state==='uncertain'?'The request outcome could not be confirmed. Your Original, prompt and existing job are preserved. Check this same result; do not generate again.':job.error||'This request ended without a usable image. Your artwork and prompt are preserved.');if(['failed','canceled'].indexOf(job.state)!==-1)stopped.novaConfirmedTerminal={jobId:pending.id,state:job.state};throw stopped;
        }
        if (job.state === 'temporarily_unavailable') throw new Error('The existing image could not be loaded or saved. Your job is retained; another explicit click can check recovery without regeneration.');
        if (Date.now() - started > 300000) throw new Error('Your job is saved. Retrieve the existing artwork again to check its status; no new generation is needed.');
        return new Promise(function (resolve) { window.setTimeout(resolve, 7500); }).then(readJob);
      }).catch(function (error) { if (error.status === 404 && !retrieveOnly) clear(); throw error; });
    }
    function cancelJob() {
      if (!pending || !proof) return;
      // This is cancellation of the existing logical job, never a generation retry.
      aiSecurityJson(base + '/jobs/cancel', {method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify({ownerSessionProof:proof,jobId:pending.id})}).catch(function () {});
    }
    if (signal && !retrieveOnly) signal.addEventListener('abort', cancelJob, { once: true });
    return Promise.resolve().then(function () {
      try { pending = JSON.parse(window.sessionStorage.getItem(key) || 'null'); } catch (error) {}
      if (retrieveOnly && !pending) throw new Error('The existing job reference is unavailable. No generation was requested.');
      if (!pending && config.enabled === false) throw new Error('AI generation is temporarily disabled. Your prompt and artwork are unchanged.');
      if (pending && JSON.stringify(pending.context || {}) !== JSON.stringify(context || {})) throw new Error('Return to the original product and print location to recover the pending AI image.');
      if (pending && JSON.stringify(pending.payload) !== JSON.stringify(payload)) throw new Error('An earlier AI job is pending. Restore its prompt and style to recover it before requesting a different image.');
      var previousProof = readAiSession();
      var sessionGuard = aiSessionWriteGuard();
      if (retrieveOnly && !previousProof) throw new Error('The existing job needs its original authorized recovery session. No new identity or generation was created.');
      if (config.ownerQaRequired) return retrieveOnly ? previousProof : enrollAiOwner(base, signal, true);
      return runAiSecurityChallenge(config, signal).then(function (token) {
        return requestAi('/session', {method:'POST',headers:{'Content-Type':'application/json'},signal:signal,body:JSON.stringify({previousProof:previousProof,turnstileToken:token})});
      }).then(function (session) { return writeAiSession(session.ownerSessionProof, previousProof, sessionGuard); });
    }).then(function (session) {
      proof = session; active();
      if (pending) return readJob(retrieveOnly ? false : true);
      if (retrieveOnly) throw new Error('The existing job reference is unavailable. No generation was requested.');
      var id = context.requestJobId;
      return runAiSecurityChallenge(config, signal).then(function (token) {
        return requestAi('/authorize', {method:'POST',headers:{'Content-Type':'application/json'},signal:signal,
          body:JSON.stringify(Object.assign({},payload,{jobId:id,ownerSessionProof:proof,turnstileToken:token}))});
      }).then(function (auth) {
        active(); pending = {id:id,payload:payload,context:context || {}}; save();
        return processingPreservePending('ai',pending).then(function(){return requestAi('/jobs', {method:'POST',headers:{'Content-Type':'application/json',Authorization:'Bearer '+auth.grant},signal:signal,
          body:JSON.stringify(Object.assign({},payload,{jobId:id}))});});
      }).catch(function (error) { if ([400,403,429].indexOf(error.status) !== -1) clear(); throw error; }).then(readJob);
    }).finally(function () { if (signal) signal.removeEventListener('abort',cancelJob); });
  }

  function aiGenerationPayload(options) {
    if (options.paidFinishing !== undefined && options.paidFinishing !== false) throw new Error('The paid-finishing restriction is invalid. No generation was submitted.');
    // URL/debug leftovers are not product policy. An explicit bounded caller may
    // still sign paidFinishing:false; existing durable restrictions are untouched.
    var payload = { prompt: String(options.prompt || '').trim(), style: String(options.style || 'clean') };
    if (options.paidFinishing === false) payload.paidFinishing = false;
    return payload;
  }

  function requestGeneratedImage(options) {
    options = options || {};
    var prompt = String(options.prompt || '').trim();
    var style = String(options.style || 'clean');

    if (aiSecurityBusy) return Promise.reject(new Error('An AI generation request is already in progress.'));
    aiSecurityBusy = true;
    return Promise.resolve().then(function () {
      if(options.retrieveOnly){
        var pending=getPendingAiJob(),base=ENDPOINT.replace(/\/(generate|generate-and-store)\/?$/, '');
        if(!pending||!pending.payload)throw new Error('The existing job reference is unavailable. No generation was requested.');
        return aiSecurityJson(base+'/security-config',{method:'GET',signal:options.signal}).then(function(config){
          if(!config.durableJobs)throw new Error('Existing-job retrieval is unavailable. No generation was requested.');
          return durableAiFetch(base,config,pending.payload,options.signal,options.context,options.onProgress,true);
        }).then(function(result){return result.durableResponse;});
      }
      return authorizedAiFetch(aiGenerationPayload(options), options.signal, options.context, options.onProgress);
    })
      .then(function (response) {
        if (response.printArtifact) return new Promise(function (resolve,reject) {
          var reader=new FileReader();reader.onerror=function () {reject(new Error('The print master could not be opened.'));};
          reader.onload=function () {resolve({imageDataUrl:reader.result,blob:response.printArtifact,printMaster:response.printMaster,filename:response.filename,jobId:response.jobId});};
          reader.readAsDataURL(response.printArtifact);
        });
        return response.json().then(function (data) {
          if (!response.ok || !data.ok) {
            throw new Error(
              data && data.error
                ? data.error
                : 'The AI image could not be generated.'
            );
          }

          return data;
        });
      })
      .then(function (data) {
        if (options.signal && options.signal.aborted) throw new Error('Generation cancelled.');
        var blob = data.blob || dataUrlToBlob(data.imageDataUrl);
        return {
          blob: blob,
          dataUrl: data.imageDataUrl,
          fileName: data.filename || 'nova-ai-' + Date.now() + '.png',
          mimeType: blob.type || data.mimeType || 'image/png',
          printMaster: data.printMaster || null,
          jobId: data.jobId || '',
          prompt: prompt,
          style: style,
          retrievedExisting: options.retrieveOnly === true
        };
      }).finally(function () { aiSecurityBusy = false; });
  }

  function blobDataUrl(blob) {
    return new Promise(function (resolve, reject) {
      var reader = new FileReader();
      reader.onerror = function () { reject(new Error('The selected artwork could not be read.')); };
      reader.onload = function () { resolve(String(reader.result || '')); };
      reader.readAsDataURL(blob);
    });
  }

  function rasterBlobDimensions(blob) {
    return new Promise(function (resolve, reject) {
      var url = URL.createObjectURL(blob), image = new Image(), settled = false;
      var timer = window.setTimeout(function () { finish(new Error('The selected artwork could not be decoded.')); }, 15000);
      function finish(error, value) {
        if (settled) return;
        settled = true;
        window.clearTimeout(timer);
        URL.revokeObjectURL(url);
        if (error) reject(error); else resolve(value);
      }
      image.onload = function () {
        var width = image.naturalWidth, height = image.naturalHeight;
        finish(width && height ? null : new Error('The selected artwork has invalid dimensions.'), { width: width, height: height });
      };
      image.onerror = function () { finish(new Error('The selected artwork could not be decoded.')); };
      image.src = url;
    });
  }

  function jpegBlobToOpaquePng(blob) {
    // The original Blob stays in the existing artwork candidate. Prepare only
    // the service input; PNG alpha must not inherit the JPG white background.
    var pngSource = blob.type === 'image/png';
    return new Promise(function (resolve, reject) {
      var url = URL.createObjectURL(blob), image = new Image(), settled = false;
      var timer = window.setTimeout(function () { finish(new Error('The selected artwork could not be decoded.')); }, 15000);
      function finish(error, value) {
        if (settled) return;
        settled = true;
        window.clearTimeout(timer);
        URL.revokeObjectURL(url);
        if (error) reject(error); else resolve(value);
      }
      image.onload = function () {
        var width = image.naturalWidth, height = image.naturalHeight;
        if (!width || !height || width > 8400 || height > 8400 || width * height > 24 * 1024 * 1024) {
          finish(new Error('The selected artwork is outside the supported processing bounds.'));
          return;
        }
        try {
        var canvas = document.createElement('canvas'); canvas.width = width; canvas.height = height;
        var context = canvas.getContext('2d', { alpha: pngSource });
        if (!context) { finish(new Error('The selected artwork could not be prepared.')); return; }
        if (!pngSource) { context.fillStyle = '#fff'; context.fillRect(0, 0, width, height); }
        context.drawImage(image, 0, 0);
        canvas.toBlob(function (png) {
          finish(png ? null : new Error('The artwork could not be prepared without changing its background.'), png);
        }, 'image/png');
        } catch (error) { finish(new Error('The selected artwork could not be prepared.')); }
      };
      image.onerror = function () { finish(new Error('The selected artwork could not be decoded.')); };
      image.src = url;
    });
  }

  function rasterSource(options) {
    var reference = String(options.sourceReference || '');
    var source = options.blob instanceof Blob
      ? Promise.resolve(options.blob)
      : (/^(?:blob:|data:image\/)/.test(reference) ? fetch(reference).then(function (response) {
          if (!response.ok) throw new Error('The selected artwork could not be loaded.');
          return response.blob();
        }) : Promise.reject(new Error('Select a local PNG or JPG artwork source first.')));
    return source.then(function (blob) {
      if (!blob.size || blob.size > 8 * 1024 * 1024 || !/^image\/(?:png|jpeg)$/.test(blob.type)) {
        throw new Error('Upscaling supports a selected PNG or JPG up to 8 MB.');
      }
      if (blob.type === 'image/png') return blob.slice(0, 33).arrayBuffer().then(function (header) {
        var bytes = new Uint8Array(header), signature = [137,80,78,71,13,10,26,10];
        if (bytes.length !== 33 || !signature.every(function (value, index) { return bytes[index] === value; }) ||
          new DataView(header).getUint32(8) !== 13 || String.fromCharCode.apply(null, bytes.subarray(12,16)) !== 'IHDR')
          throw new Error('The selected PNG header is invalid.');
        // iPhone screenshots may be 16-bit RGB/RGBA. The service contract is
        // 8-bit RGB/RGBA: decode at unchanged natural dimensions BEFORE hashing,
        // authorization and submission. Never weaken the server PNG validator.
        return bytes[24] === 16 && (bytes[25] === 2 || bytes[25] === 6) &&
          bytes[26] === 0 && bytes[27] === 0 && bytes[28] === 0 ? jpegBlobToOpaquePng(blob) : blob;
      });
      return jpegBlobToOpaquePng(blob);
    }).then(function (blob) {
      if (!blob.size || blob.size > 8 * 1024 * 1024 || blob.type !== 'image/png')
        throw new Error('The prepared artwork exceeds the supported PNG processing bounds.');
      return Promise.all([blob.arrayBuffer(), rasterBlobDimensions(blob)]).then(function (values) {
        var bytes = values[0], dimensions = values[1], width = dimensions.width, height = dimensions.height;
        if (!width || !height || width > 8400 || height > 8400 || width * height > 24 * 1024 * 1024) throw new Error('The selected artwork is outside the supported processing bounds.');
        return crypto.subtle.digest('SHA-256', bytes).then(function (digest) {
          return { blob: blob, bytes: bytes, width: width, height: height, hash: Array.from(new Uint8Array(digest), function (value) { return value.toString(16).padStart(2, '0'); }).join('') };
        });
      });
    });
  }

  function createUpscaleDiagnosticCapture() {
    var owner = window.NovaUpscaleSafeDiagnostics;
    return owner && owner.enabled ? owner.capture : function () {};
  }

  function standaloneUpscaleFailure(job) {
    var errorClass = String(job && (job.errorClass || job.state) || 'upscale_failed');
    var message;
    if (errorClass === 'canceled') message = 'Upscaling was cancelled. The original artwork remains unchanged; no automatic retry was made.';
    else if (errorClass === 'enhancement_dispatch_uncertain') message = 'The upscale request could not be confirmed. The original artwork remains unchanged; check this same result before trying again.';
    else if (errorClass === 'enhancement_deadline') message = 'Upscaling did not finish within the supported time. The original artwork remains unchanged; no automatic retry was made.';
    else if (errorClass === 'enhancement_scale_unavailable') message = 'The selected artwork is too small to reach print-ready resolution at this print size in one safe upscale. Choose a smaller print size or upload a larger original. The original remains selected; no provider enhancement was submitted and no automatic retry was made.';
    else if (errorClass === 'enhancement_geometry' || errorClass === 'enhancement_background_changed') message = 'The returned upscale did not preserve the original artwork. The original remains selected; no automatic retry was made.';
    else if (/^(?:finishing_|production_|print_master_|print_preview_|print_checkpoint_|production_source_|retained_source_|print_target_)/.test(errorClass)) message = 'The enhanced artwork was preserved, but its print-ready file could not be completed. The original remains selected; no automatic retry was made.';
    else if (/storage/.test(errorClass)) message = 'The upscaled artwork could not be safely stored. The original remains selected; no automatic retry was made.';
    else message = 'Upscaling stopped. The original artwork remains unchanged; no automatic retry was made.';
    var failure = new Error(message);
    failure.errorClass = errorClass;
    return failure;
  }

  function upscaleArtwork(options) {
    options = options || {};
    var plan = {getService:function(){return options.verifiedService;}};
    var diagnostic=createUpscaleDiagnosticCapture(), diagnosticStage='service-preflight';
    diagnostic(diagnosticStage);
    var service = plan && typeof plan.getService === 'function' ? plan.getService('upscale') : null;
    if (!service || service.available === false || Number(service.priceCents) !== 500) { diagnostic(diagnosticStage,{event:'failed',code:'service_unavailable'}); return Promise.reject(new Error('Upscaling is unavailable until the exact approved $5 Shopify service variant is configured.')); }
    if (!options.projectId || !options.sourceId || !options.printTarget) { diagnostic(diagnosticStage,{event:'failed',code:'source_identity_unavailable'}); return Promise.reject(new Error('The selected project, artwork, or print target is unavailable.')); }
    if (typeof options.onProgress === 'function') {
      try { options.onProgress('validating'); } catch (error) {}
    }
    var base=ENDPOINT.replace(/\/(generate|generate-and-store)\/?$/, ''),signal=options.signal;
    var operationId=String(options.operationId||crypto.randomUUID()),pendingKey=processingPendingKey('upscale');
    var proof='',pending=null,reconcilePending=false,cancelRequested=false,startedAt=Date.now();
    function stage(value) {
      diagnosticStage=value; diagnostic(value,{jobId:pending && pending.id});
      if (/^(source-validation|session-verification|upscale-verification|artifact-download|artifact-integrity|artifact-ready)$/.test(value) && typeof options.onProgress === 'function') {
        try { options.onProgress(value); } catch (error) { /* Presentation cannot alter processing. */ }
      }
    }
    function request(path, init) {
      stage(path.slice(1).replace(/\//g,'-'));
      // Same parser and same validation; only allowlisted response metadata is observed.
      var requestStage=diagnosticStage;
      return aiSecurityJson(base+path,init,function(meta){if(meta.rateLimited && typeof options.onProgress==='function')options.onProgress('read-rate-limit',meta);else diagnostic(requestStage,meta);},startedAt+300000).then(function(data){ diagnostic(requestStage,{state:data.state,errorClass:data.errorClass,jobId:pending && pending.id}); return data; },function(error){ diagnostic(requestStage,{status:error.status || error.novaSecurityStatus,code:error.novaSecurityCode,errorClass:error.errorClass}); throw error; });
    }
    var securityFlow=createAiSecurityChallengeFlow({operation:'upscale',label:'Upscale artwork security verification',cancelMessage:'Upscaling cancelled.',onDiagnostic:function(detail){diagnostic(diagnosticStage,detail);}});
    stage('source-validation');
    function cancelAcceptedJob() {
      if (cancelRequested || !proof || !pending || !pending.id) return;
      cancelRequested = true;
      fetch(base+'/jobs/cancel',{method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify({ownerSessionProof:proof,jobId:pending.id})}).catch(function () {});
    }
    if(signal)signal.addEventListener('abort',cancelAcceptedJob,{once:true});
    var sourceRequest;
    function readUpscaleArtifact(response) {
      var limit = 64 * 1024 * 1024, rawTotal = response.headers.get('Content-Length');
      var total = rawTotal && /^\d+$/.test(rawTotal) ? Number(rawTotal) : null;
      if (total !== null && (!Number.isSafeInteger(total) || total < 1 || total > limit)) {
        if(response.body)response.body.cancel().catch(function () {});
        throw new Error('The full-resolution upscaled artwork exceeds the supported size.');
      }
      var loaded = 0, reportedAt = 0;
      function incompleteTransfer() {
        var error = new Error('The full-resolution upscaled artwork transfer is incomplete.');
        error.novaUpscaleRetrievalInterrupted = true; return error;
      }
      function report(final) {
        if (typeof options.onProgress !== 'function' || (!final && Date.now() - reportedAt < 250)) return;
        reportedAt = Date.now();
        try { options.onProgress('artifact-download', { loaded: loaded, total: total }); } catch (ignored) {}
      }
      if (!response.body || typeof response.body.getReader !== 'function') return response.blob().then(function (blob) {
        if (blob.size > limit) throw new Error('The full-resolution upscaled artwork exceeds the supported size.');
        if (!blob.size || total && blob.size !== total) throw incompleteTransfer();
        loaded = blob.size; report(true); return blob;
      });
      var reader = response.body.getReader(), chunks = [];
      function read() {
        return reader.read().then(function (part) {
          if (part.done) {
            if (!loaded || total && loaded !== total) throw incompleteTransfer();
            report(true); return new Blob(chunks, { type: 'image/png' });
          }
          loaded += part.value.byteLength;
          if (loaded > limit || total && loaded > total) {
            reader.cancel().catch(function () {});
            throw new Error('The full-resolution upscaled artwork exceeds the supported size.');
          }
          chunks.push(part.value); report(false); return read();
        });
      }
      return read().catch(function (error) {
        if (error && error.name === 'TypeError') error.novaUpscaleRetrievalInterrupted = true;
        throw error;
      }).finally(function () { reader.releaseLock(); });
    }
    if (options.recoverOnly) {
      var retained=getPendingUpscaleJob(),bound=retained && retained.payload;
      if (!bound || !/^[a-f0-9-]{36}$/.test(retained.id || '') || bound.projectId !== String(options.projectId) ||
          bound.sourceId !== String(options.sourceId) || JSON.stringify(bound.printTarget) !== JSON.stringify(options.printTarget) ||
          !/^[a-f0-9]{64}$/.test(bound.sourceHash || '') || !Number.isSafeInteger(bound.sourceBytes) || bound.sourceBytes<1 || bound.sourceBytes>8*1024*1024 ||
          !Number.isSafeInteger(bound.sourceWidth) || !Number.isSafeInteger(bound.sourceHeight) || bound.sourceWidth<1 || bound.sourceHeight<1 || bound.sourceWidth*bound.sourceHeight>24*1024*1024 || bound.sourceMime!=='image/png') {
        sourceRequest=Promise.reject(new Error('The retained upscale identity does not match this project, source and print size. No processing was requested.'));
      } else {
        // Recovery reads the already accepted, server-owned source. These are
        // descriptor checks, not a claim that a fresh file was revalidated.
        // This branch cannot reach authorization/admission for a new prediction.
        sourceRequest=Promise.resolve({hash:bound.sourceHash,blob:{size:bound.sourceBytes},width:bound.sourceWidth,height:bound.sourceHeight});
      }
    } else sourceRequest=rasterSource(options);
    return sourceRequest.then(function (source) {
      var payload={operationId:operationId,projectId:String(options.projectId),sourceId:String(options.sourceId),sourceHash:source.hash,sourceBytes:source.blob.size,sourceWidth:source.width,sourceHeight:source.height,sourceMime:'image/png',printTarget:options.printTarget};
      try{pending=JSON.parse(sessionStorage.getItem(pendingKey)||'null');}catch(error){}
      if(pending){
        reconcilePending=true;
        // A UI retry has a new local operation ID, not permission for a second
        // paid job. Recover the retained job only for the unchanged bound source.
        var retainedPayload=pending.payload,retainedOperation=retainedPayload&&retainedPayload.operationId;
        if(!retainedPayload||typeof retainedOperation!=='string'||!/^[A-Za-z0-9:_-]{1,160}$/.test(retainedOperation)||
          JSON.stringify(retainedPayload)!==JSON.stringify(Object.assign({},payload,{operationId:retainedOperation})))
          throw new Error('A different upscale operation is pending. Check that result before starting another.');
        operationId=retainedOperation;payload=retainedPayload;
      }
      function progress(stage,detail){if(typeof options.onProgress==='function')try{options.onProgress(stage,detail);}catch(error){}}
      function readJob(){
        if(signal&&signal.aborted)throw new Error('Upscaling canceled. Accepted work may already be processing; no automatic retry was made.');
        if(Date.now()-startedAt>300000){var waiting=new Error('The latest processing outcome is not confirmed. Check the same retained job later; do not submit another.');waiting.errorClass='status_stale';throw waiting;}
        var statusPath=reconcilePending?'/jobs/recover':'/jobs/status';reconcilePending=false;
        return request(statusPath,{method:'POST',headers:{'Content-Type':'application/json'},signal:signal,body:JSON.stringify({ownerSessionProof:proof,jobId:pending.id})}).then(function(job){
          progress(job.state,{statusRead:true});
          if(job.state==='ready'&&job.printMaster){if(job.printMaster.originalHash!==payload.sourceHash)throw new Error('The retained upscale source identity changed. The original artwork remains unchanged.');stage('artifact-download');return artworkReadWithRateLimit(base+'/jobs/artifact',{method:'POST',headers:{'Content-Type':'application/json'},signal:signal,body:JSON.stringify({ownerSessionProof:proof,jobId:pending.id,kind:'master',revision:job.printMaster.revisionHash,checksum:job.printMaster.masterHash})},function(detail){progress('read-rate-limit',detail);},startedAt+300000).then(function(response){diagnostic('artifact-download',{status:response.status,requestId:response.headers.get('x-request-id'),jobId:pending.id});if(!response.ok||response.headers.get('Content-Type')!=='image/png'){if(response.body)response.body.cancel().catch(function(){});throw new Error('The full-resolution upscaled artwork is unavailable. The original artwork remains unchanged.');}return readUpscaleArtifact(response);}).then(function(masterBlob){
            stage('artifact-integrity');
            if(!masterBlob.size||masterBlob.size>64*1024*1024)throw new Error('The full-resolution upscaled artwork exceeds the supported size. The original artwork remains unchanged.');
            return masterBlob.arrayBuffer().then(function(bytes){return crypto.subtle.digest('SHA-256',bytes);}).then(function(digest){
              var actual=Array.from(new Uint8Array(digest),function(value){return value.toString(16).padStart(2,'0');}).join('');
              if(actual!==job.printMaster.masterHash)throw new Error('The full-resolution upscaled artwork identity changed. The original artwork remains unchanged.');
              return blobDataUrl(masterBlob);
            }).then(function(dataUrl){
              // Keep recovery until authenticated download, checksum and Blob readback
              // succeed. A failure must not invite a duplicate provider job.
              if (!options.retainUntilAccepted) acceptPreparedUpscaleResult(pending.id);
              return {jobId:pending.id,operationId:operationId,sourceId:payload.sourceId,originalReference:options.sourceReference||'',previewReference:dataUrl,fileReference:dataUrl,productionFile:dataUrl,fileType:'PNG',width:job.printMaster.width,height:job.printMaster.height,transparent:job.printMaster.alpha&&job.printMaster.alpha.alphaValid===true,printMaster:Object.assign({},job.printMaster,{jobId:pending.id})};
            });
          }).then(function(result){stage('artifact-ready');return result;});}
          if(['failed','canceled','uncertain','preparation_failed'].indexOf(job.state)!==-1)throw standaloneUpscaleFailure(job);
          return new Promise(function(resolve){setTimeout(resolve,7500);}).then(readJob);
        },function(error){
          // A failed status read is not evidence that processing has failed.
          // Retain the existing pending identity; never dispatch another job here.
          if (!error.novaArtworkReadLimited) error.message = 'The latest job status could not be retrieved. Your image may still be processing. Check this same result; please don’t submit again.';
          error.novaUpscaleStatusReadFailed = true;
          throw error;
        });
      }
      var activeConfig;
      return request('/security-config',{method:'GET',signal:signal}).then(function(config){
        activeConfig=config;
        if(!config.enabled||!config.standaloneUpscale)throw new Error('Standalone upscaling is not enabled. The original artwork remains unchanged.');
        var previous=readAiSession();
        var sessionGuard=aiSessionWriteGuard();
        if(config.ownerQaRequired)return enrollAiOwner(base,signal,true);
        progress('verifying');
        stage('session-verification');
        return securityFlow.verify(config,signal).then(function(token){return request('/session',{method:'POST',headers:{'Content-Type':'application/json'},signal:signal,body:JSON.stringify({previousProof:previous,turnstileToken:token})});}).then(function(session){return writeAiSession(session.ownerSessionProof,previous,sessionGuard);});
      }).then(function(sessionProof){
        proof=sessionProof;
        if(pending)return readJob();
        if(options.recoverOnly)throw new Error('The existing upscale reference is unavailable. No new processing was submitted.');
        var jobId=options.requestJobId;
        progress('verifying');
        stage('upscale-verification');
        return securityFlow.verify(activeConfig,signal).then(function(token){
          diagnostic('job-proposed',{jobId:jobId});
          return request('/upscale/authorize',{method:'POST',headers:{'Content-Type':'application/json'},signal:signal,body:JSON.stringify(Object.assign({ownerSessionProof:proof,turnstileToken:token,jobId:jobId},payload))});
        }).then(function(auth){
          pending={id:jobId,payload:payload};sessionStorage.setItem(pendingKey,JSON.stringify(pending));if(sessionStorage.getItem(pendingKey)!==JSON.stringify(pending))throw Error('Recovery identity could not be preserved. No upscale was submitted.');progress('uploading');
          return processingPreservePending('upscale',pending).then(function(){return request('/upscale/jobs',{method:'POST',headers:{'Content-Type':'image/png','Authorization':'Bearer '+auth.grant},body:source.blob,signal:signal}).catch(function(error){
            if(error.status&&error.status<500){try{sessionStorage.removeItem(pendingKey);}catch(storageError){}throw error;}
            return null;
          }).then(readJob);});
        });
      });
    }).catch(function(error){if(diagnosticStage==='artifact-download'&&error&&(error.name==='TypeError'||error.novaArtworkReadLimited))error.novaUpscaleRetrievalInterrupted=true;if(typeof options.onProgress==='function')try{options.onProgress('stopped',{cancelled:Boolean(signal&&signal.aborted),recoverable:Boolean(error&&(error.novaUpscaleStatusReadFailed||error.novaUpscaleRetrievalInterrupted))});}catch(ignored){}diagnostic(diagnosticStage,{event:'failed',code:error.novaSecurityCode,errorClass:error.errorClass,turnstileCode:error.novaTurnstileCode,status:error.status || error.novaSecurityStatus,jobId:pending && pending.id});throw error;}).finally(function(){securityFlow.destroy();if(signal)signal.removeEventListener('abort',cancelAcceptedJob);});
  }

 async function catalog(kind){
   var definitions={ai:{sku:'NOVA-SVC-AI-5',title:'AI Artwork Creation'},upscale:{sku:'NOVA-SVC-UPSCALE-5',title:'Standalone Artwork Upscaling'}},definition=definitions[kind];
   var root=window.Shopify&&Shopify.routes&&Shopify.routes.root||'/',response=await fetch(root+'products/professional-design-services.js',{credentials:'same-origin',headers:{Accept:'application/json'}});
   if(!response.ok)throw Error('The selected $5 artwork service could not be verified.');var product=await response.json(),matches=(product.variants||[]).filter(function(v){return v.sku===definition.sku;});
   if(matches.length!==1||matches[0].title!==definition.title||Number(matches[0].price)!==500||matches[0].available===false)throw Error('The exact $5 artwork service is unavailable. No processing was submitted.');
   return {variantId:Number(matches[0].id),sku:definition.sku,title:definition.title,priceCents:500,available:true};
 }
 function run(kind,options){
   options=options||{};var id=owner().getProjectId(),activeKey=id+'::'+kind;
   if(processingActive.has(activeKey))return Promise.reject(Error('This artwork operation is already active. No second request was submitted.'));
   var target;try{target=resolveAiPrintTarget(options.context||{targetSurfaceId:options.printTarget&&options.printTarget.location});}catch(error){return Promise.reject(error);}
   var current={projectId:id,targetSurfaceId:target.location},expected=JSON.stringify([id,kind,target,kind==='ai'?aiGenerationPayload(options):{sourceId:options.sourceId,sourceHash:options.sourceHash}]);
   var task=Promise.resolve().then(async function(){
     owner().requirePersistedProjectId(id);var verifiedService=await catalog(kind),claim=await processingClaim(kind,expected,options.signal);
     owner().requirePersistedProjectId(id);if(owner().getProjectId()!==id)throw Error('The artwork project changed.');
     current.requestJobId=claim.requestJobId;
     if(!claim.pending){var oldPending=JSON.parse(sessionStorage.getItem(processingPendingKey(kind))||'null');if(oldPending){if(oldPending.id!==claim.previousJobId)throw Error('An unconfirmed earlier browser job must be reconciled first. No new processing was submitted.');sessionStorage.removeItem(processingPendingKey(kind));}}
     if((options.retrieveOnly||options.recoverOnly)&&!claim.pending)throw Error('No preserved job is available to retrieve. No processing was submitted.');
     if(claim.pending){sessionStorage.setItem(processingPendingKey(kind),JSON.stringify(claim.pending));if(sessionStorage.getItem(processingPendingKey(kind))!==JSON.stringify(claim.pending))throw Error('The existing recovery reference could not be preserved.');}
     else if(claim.tab!==processingTab)throw Error('Another tab owns the unfinished dispatch. Keep it open; do not submit again.');
     var args=Object.assign({},options,{projectId:id,requestJobId:claim.requestJobId,context:current,verifiedService:verifiedService,printTarget:target,retainUntilAccepted:true});
     if(kind==='ai'){if(claim.pending)args.retrieveOnly=true;return requestGeneratedImage(args);}
     if(claim.pending)args.recoverOnly=true;return upscaleArtwork(args);
   });
   processingActive.set(activeKey,task);return task.catch(async function(error){if(error.novaConfirmedTerminal)await processingCloseTerminal(kind,error.novaConfirmedTerminal);else await processingReleasePreDispatch(kind).catch(function(){});if(error.errorClass==='upscale_unnecessary')error.message='This Original already has enough pixels for the selected print size. Keep Original; no upscale was submitted.';throw error;}).finally(function(){if(processingActive.get(activeKey)===task)processingActive.delete(activeKey);});
 }
 access.processing=Object.freeze({generate:function(options){return run('ai',options);},upscale:function(options){return run('upscale',options);},complete:processingComplete,pendingKey:processingPendingKey,catalog:catalog});
}

// Descriptor-only persistence for signed job masters. Locators are not URLs or
// access grants; every display/read still uses the authenticated artifact API.
function installPreparedArtworkAccess(){
  var access=window.NovaProjectArtworkAccess;if(access.preparedArtifacts)return;
  var loaded={},registrations=new Map(),projectLoaded='',restore=null;
  function project(){var p=owner(),id=p.getProjectId();p.requirePersistedProjectId(id);return id;}
  function parse(source){return /^(nova-ai|nova-upscale):([a-f0-9-]{36}):([a-f0-9]{64})$/.exec(String(source||''));}
  function key(source){return recordKey('prepared-descriptor-'+source);}
  function assertRow(row,source){
    var match=parse(source),id=project(),m=row&&row.master,r=m&&m.savedReference;
    if(!match||!row||row.project!==id||row.reference!==source||row.kind!==(match[1]==='nova-ai'?'ai':'upscale')||!m||m.incidentAccess||m.jobId!==match[2]||m.revisionHash!==match[3]||!/^[a-f0-9]{64}$/.test(m.masterHash||'')||!r||r.project!==id||r.jobId!==m.jobId||r.checksum!==m.masterHash||r.revision!==m.revisionHash||!(Number.isSafeInteger(m.width)&&Number.isSafeInteger(m.height)&&m.width>0&&m.height>0&&m.width*m.height<=24*1024*1024)||!Number.isSafeInteger(m.savedUntil)||m.savedUntil<=Date.now()/1000||!Number.isSafeInteger(row.bytes)||row.bytes<1||row.bytes>64*1024*1024)throw Error('The saved prepared artwork does not match this project or its retention limit.');
    return row;
  }
  async function readRecord(source){var row=await transaction('readonly',function(store){return store.get(key(source));});assertRow(row,source);if(projectLoaded!==row.project){loaded={};projectLoaded=row.project;}loaded[source]=row;return row;}
  async function describe(source,signal){var row=await readRecord(source),m=await inspectPreparedArtwork(row.master,signal);assertRow(row,source);if(m.masterHash!==row.master.masterHash||m.revisionHash!==row.master.revisionHash||m.width!==row.master.width||m.height!==row.master.height)throw Error('The retained master identity or dimensions changed.');return {id:m.jobId,reference:source,project:row.project,kind:row.kind,state:'ready',checksum:m.masterHash,bytes:row.bytes,mime:'image/png',expiresAt:row.master.savedUntil};}
  async function read(source,signal){var row=await readRecord(source),blob=await loadPreparedArtwork(row.master,signal);assertRow(row,source);if(blob.size!==row.bytes)throw Error('The retained master length changed.');return blob;}
  async function register(kind,master,blob,signal){
    if(['ai','upscale'].indexOf(kind)<0||!master||!master.jobId||!(blob instanceof Blob)||blob.type!=='image/png'||!blob.size||blob.size>64*1024*1024)throw Error('The verified prepared result is incomplete.');
    var id=project(),source=(kind==='ai'?'nova-ai:':'nova-upscale:')+master.jobId+':'+master.revisionHash,identity=id+'::'+source;
    if(registrations.has(identity))return registrations.get(identity);
    var task=Promise.resolve().then(async function(){
      var claim=await transaction('readonly',function(store){return store.get(recordKey('processing-'+kind));});
      if(!claim||claim.project!==id||claim.requestJobId!==master.jobId||!claim.pending||claim.pending.id!==master.jobId)throw Error('The service lineage is not bound to this project’s authenticated job. No artwork was inserted.');
      var checksum=await access.checksum(blob);if(checksum!==master.masterHash)throw Error('The insertion bytes do not match their own master checksum.');
      var dimensions=await decodeDimensions(blob,signal);if(dimensions.width!==master.width||dimensions.height!==master.height)throw Error('The insertion bytes do not match their own master dimensions.');
      var verified=await inspectPreparedArtwork(master,signal);if(verified.width!==master.width||verified.height!==master.height)throw Error('The authenticated master dimensions changed.');
      var service=await access.processing.catalog(kind),operation='retain-'+await access.checksum(new Blob([JSON.stringify([id,kind,master.jobId,master.revisionHash,master.masterHash])]));
      if(signal&&signal.aborted)throw new DOMException('Artwork insertion cancelled.','AbortError');
      var retained=await savePreparedArtwork(master,id,operation),row={key:key(source),project:id,reference:source,kind:kind,master:retained,bytes:blob.size,service:service};
      assertRow(row,source);await db().then(function(database){return new Promise(function(resolve,reject){var tx=database.transaction('records','readwrite'),store=tx.objectStore('records'),request=store.get(row.key);request.onsuccess=function(){try{if(request.result&&JSON.stringify(request.result)!==JSON.stringify(row))throw Error('The saved prepared descriptor has a conflicting identity.');if(!request.result)store.put(row);}catch(error){reject(error);tx.abort();}};tx.oncomplete=resolve;tx.onabort=tx.onerror=function(){reject(Error('Prepared descriptor persistence failed.'));};});});
      var saved=await readRecord(source);if(JSON.stringify(saved)!==JSON.stringify(row))throw Error('Prepared descriptor readback failed.');
      document.dispatchEvent(new CustomEvent('nova:automatic-vector-services-changed'));return row;
    });registrations.set(identity,task);return task.finally(function(){if(registrations.get(identity)===task)registrations.delete(identity);});
  }
  function decodeDimensions(blob,signal){return new Promise(function(resolve,reject){var url=URL.createObjectURL(blob),image=new Image(),done=false,timer=setTimeout(function(){finish(Error('Verified master decoding timed out.'));},15000);function finish(error,value){if(done)return;done=true;clearTimeout(timer);URL.revokeObjectURL(url);if(signal)signal.removeEventListener('abort',abort);if(error)reject(error);else resolve(value);}function abort(){finish(new DOMException('Artwork insertion cancelled.','AbortError'));}if(signal){signal.addEventListener('abort',abort,{once:true});if(signal.aborted){abort();return;}}image.onload=function(){finish(null,{width:image.naturalWidth,height:image.naturalHeight});};image.onerror=function(){finish(Error('The verified master could not be decoded.'));};image.src=url;});}
  function references(){var api=window.NovaImprintSurfaceAPI,state=api&&api.getAllSurfaceStates&&api.getAllSurfaceStates(),layerApi=window.NovaArtworkLayerAPI,live=layerApi&&layerApi.getState&&layerApi.getState(),out=[];if(api&&state&&api.getSelectedSurfaceIds)api.getSelectedSurfaceIds().forEach(function(id){var spec=api.getSurfaceSpec(id),layers=id===api.getActiveSurfaceId()&&live&&spec?live[spec.view]:state[id]&&state[id].artworkLayers;(layers||[]).forEach(function(layer){if(parse(layer.dataUrl)&&!out.some(function(r){return r.reference===layer.dataUrl&&r.location===id;}))out.push({reference:layer.dataUrl,location:id});});});return out;}
  async function restoreUsed(){if(restore)return restore;var id=project(),task=Promise.resolve().then(async function(){for(var used of references())await readRecord(used.reference);if(project()!==id)throw Error('The artwork project changed.');});restore=task;return task.finally(function(){if(restore===task)restore=null;});}
  function snapshot(){var id=project();if(projectLoaded!==id)loaded={};var instances=[],missing=[];references().forEach(function(used){var row=loaded[used.reference];if(!row){missing.push(used.reference);return;}assertRow(row,used.reference);var billing=row.kind==='upscale'?'upscale-location-'+used.location:'ai-job-'+row.master.jobId;if(instances.some(function(i){return i.billingKey===billing;}))return;instances.push({serviceId:row.kind,billingKey:billing,serviceInstanceId:'service-'+row.kind+'-'+row.master.jobId,variantId:row.service.variantId,priceCents:500,candidateId:row.master.jobId,checksum:row.master.masterHash,reference:row.reference,location:used.location,title:row.service.title});});return{instances:instances,cents:instances.length*500,pending:missing.length>0,missing:missing};}
  async function getCartItems(cartContext){var id=project();if(cartContext.projectId!==id)throw Error('Artwork service project mismatch.');await restoreUsed();var start=JSON.stringify(references()),state=snapshot();for(var instance of state.instances){await describe(instance.reference);var service=await access.processing.catalog(instance.serviceId);if(service.variantId!==instance.variantId)throw Error('The selected service variant changed.');}if(state.pending||project()!==id||JSON.stringify(references())!==start)throw Error('The selected prepared service changed. Review the current artwork.');return state.instances.map(function(i){return{id:i.variantId,quantity:1,properties:{_nova_project_id:id,_customization_pair_id:cartContext.pairId||'',_nova_line_type:'professional-service',_nova_service_key:i.serviceId,_nova_service_instance_id:i.serviceInstanceId,_nova_service_completion:'completed',_nova_prepared_candidate_id:i.candidateId,_nova_artwork_checksum:i.checksum,'Professional Design Service':i.title,'Service for':cartContext.parentProduct||''}};});}
  access.preparedArtifacts=Object.freeze({is:parse,describe:describe,read:read,register:register,record:readRecord,restoreUsed:restoreUsed,snapshot:snapshot,getCartItems:getCartItems});
  var oldPrivate=access.isPrivateArtwork,oldRead=access.readPrivateArtwork,oldDescribe=access.describePrivateArtwork,oldResponse=access.sourceResponse;
  function priorReader(reader,args){if(typeof reader!=='function'){var error=Error('The secure display update is incomplete. Your artwork is unchanged. Keep this page open until its preservation is confirmed.');error.code='private_display_upgrade_required';return Promise.reject(error);}return reader.apply(access,args);}
  access.isPrivateArtwork=function(source){return !!parse(source)||typeof oldPrivate==='function'&&oldPrivate(source);};
  access.readPrivateArtwork=function(source,signal){return parse(source)?read(source,signal):priorReader(oldRead,[source,signal]);};
  access.describePrivateArtwork=function(source,signal){return parse(source)?describe(source,signal):priorReader(oldDescribe,[source,signal]);};
  access.sourceResponse=function(source,options){return parse(source)?read(source,options&&options.signal).then(function(blob){return new Response(blob);}):priorReader(oldResponse,[source,options]);};
}

  // One shared automatic-Vector service ledger, owned by the existing project
// access API. No submission, ownership, artwork geometry or approval mutation.
function installAutomaticVectorFees() {
  var access = window.NovaProjectArtworkAccess;
  if (!access || access.vectorFees || !access.owner || !access.describePrivateArtwork || !access.readPrivateArtwork) return;
  var records = {}, selections = {}, nonVectors = {}, failures = new Set(), loadedProject = '', pending = Promise.resolve(), registrations = new Map(), reconciliation = null;
  var service = {variantId:71683857809661, sku:'NOVA-SVC-VECTOR-5', title:'Standalone Artwork Vectorization', priceCents:500};
  function project() { return access.owner().getProjectId(); }
  function key() { return context + '::' + project() + '::automatic-vector-services'; }
  function valid(artifact, reference) {
    var ref = privateArtworkReference(reference);
    if (!ref || !artifact || artifact.project !== project() || artifact.id !== ref[3] || artifact.checksum !== ref[4] ||
        artifact.kind !== 'vector' || artifact.state !== 'ready' || artifact.mime !== 'image/svg+xml' ||
        !/^[a-f0-9]{64}$/.test(artifact.source || '') || !artifact.providerSource ||
        !/^[a-f0-9]{64}$/.test(artifact.providerSource.checksum || '') ||
        !Number.isSafeInteger(artifact.expiresAt) || artifact.expiresAt <= Math.floor(Date.now()/1000)) {
      throw Error('The existing vector service provenance or access has expired. Keep your artwork; do not vectorize again.');
    }
    return artifact;
  }
  function notify() {
    document.dispatchEvent(new CustomEvent('nova:automatic-vector-services-changed'));
  }
  function load() {
    var id = project();
    return transaction('readonly', function(store) { return store.get(key()); }).then(function(saved) {
      if (id !== project()) throw Error('The artwork project changed while reading its vector service.');
      if (saved && (saved.project !== id || saved.context !== context)) throw Error('The saved vector service belongs to another project.');
      records = saved && saved.artifacts || {}; loadedProject = id;
      return records;
    });
  }
  function ensureCatalog() {
    var root = window.Shopify && Shopify.routes && Shopify.routes.root || '/';
    return fetch(root + 'products/professional-design-services.js', {credentials:'same-origin', headers:{Accept:'application/json'}})
      .then(function(response) { if (!response.ok) throw Error('The $5 vector service price could not be verified.'); return response.json(); })
      .then(function(product) {
        var variant = (product.variants || []).find(function(v) { return Number(v.id) === service.variantId; });
        if (!variant || variant.sku !== service.sku || variant.title !== service.title || Number(variant.price) !== 500 || variant.available === false) {
          throw Error('The $5 vector service is not configured as expected. No new processing was requested.');
        }
        return service;
      });
  }
  function registerVerified(reference) {
    var id = project();
    // The same authenticated descriptor and byte reader used by display remain
    // the authority. Never manufacture lineage from a URL, filename or UI label.
    return Promise.all([ensureCatalog(), access.describePrivateArtwork(reference), access.readPrivateArtwork(reference)])
      .then(function(results) {
        var artifact = valid(results[1], reference);
        if (id !== project()) throw Error('The artwork project changed; the vector was not applied.');
        pending = pending.catch(function() {}).then(function() {
          return db().then(function(database) { return new Promise(function(resolve,reject) {
            var tx = database.transaction('records','readwrite'), store = tx.objectStore('records');
            var request = store.get(key());
            request.onsuccess = function() {
              try {
                var saved = request.result || {key:key(),context:context,project:id,artifacts:{}};
                if (saved.project !== id || saved.context !== context || project() !== id) throw Error('Vector service project conflict.');
                var previous = saved.artifacts[reference];
                if (previous && JSON.stringify(previous) !== JSON.stringify(artifact)) throw Error('Vector service integrity conflict.');
                saved.artifacts[reference] = artifact; store.put(saved);
              } catch(error) { reject(error); tx.abort(); }
            };
            tx.oncomplete = resolve;
            tx.onerror = tx.onabort = function() { reject(Error('Vector service preservation failed. Keep this page open.')); };
          }); });
        }).then(load).then(function() { notify(); return artifact; });
        return pending;
      });
  }
  function register(reference) {
    var identity = project() + '::' + reference;
    if (registrations.has(identity)) return registrations.get(identity);
    var work = registerVerified(reference);
    registrations.set(identity,work);
    return work.finally(function() { if (registrations.get(identity) === work) registrations.delete(identity); });
  }
  function has(reference) {
    if (loadedProject !== project() || !records[reference]) return false;
    valid(records[reference],reference);return true;
  }
  function select(slot, reference) { selections[slot] = reference || ''; notify(); }
  function references() {
    var result = [];
    function add(value) { if (privateArtworkReference(value) && result.indexOf(value) < 0) result.push(value); }
    var api = window.NovaArtworkLayerAPI, state = api && api.getState && api.getState(), surfaces = window.NovaImprintSurfaceAPI;
    if (surfaces && surfaces.getAllSurfaceStates && surfaces.getSelectedSurfaceIds) {
      var saved = surfaces.getAllSurfaceStates(), active = surfaces.getActiveSurfaceId();
      surfaces.getSelectedSurfaceIds().forEach(function(id) {
        var spec = surfaces.getSurfaceSpec(id), layers = id === active && state && spec && Array.isArray(state[spec.view])
          ? state[spec.view] : saved[id] && saved[id].artworkLayers || [];
        layers.forEach(function(layer) { add(layer.dataUrl); });
      });
    } else if (state) Object.keys(state).forEach(function(view) { if (Array.isArray(state[view])) state[view].forEach(function(layer) { add(layer.dataUrl); }); });
    // Adapter/standalone selection is reported by their actual selection
    // handlers, not persisted booleans or existence of a generated result.
    Object.keys(selections).forEach(function(slot) { add(selections[slot]); });
    return result;
  }
  function snapshot() {
    if (loadedProject !== project()) { records = {}; loadedProject = ''; }
    var instances = [], missing = [];
    references().forEach(function(reference) {
      var artifact = records[reference];
      if (!artifact) { if (nonVectors[reference] !== project()) missing.push(reference); return; }
      valid(artifact,reference);
      if (instances.some(function(item) { return item.artifactId === artifact.id; })) return;
      instances.push({serviceInstanceId:'service-vector-'+artifact.id,serviceId:'vector',billingServiceKey:'vector-prepared',
        variantId:service.variantId,priceCents:500,sourceId:artifact.source,candidateId:artifact.id,artifactId:artifact.id,
        checksum:artifact.checksum,providerChecksum:artifact.providerSource.checksum,status:'completed',reference:reference});
    });
    return {instances:instances,cents:instances.length*500,pending:missing.length>0,missing:missing};
  }
  function reconcileUsed() {
    if (reconciliation) return reconciliation;
    var id = project();
    var work = (loadedProject === id ? Promise.resolve() : load()).then(function() {
      return Promise.all(references().filter(function(ref) { return !records[ref] && nonVectors[ref] !== id && !failures.has(id+'::'+ref); }).map(function(ref) {
        return access.describePrivateArtwork(ref).then(function(artifact) {
          if (id !== project() || artifact.project !== id) throw Error('The selected artwork project changed.');
          if (artifact.kind === 'vector') return register(ref);
          // The descriptor, never a label or filename, distinguishes a
          // privately stored Original from a completed automatic Vector.
          nonVectors[ref] = id;
        }).catch(function(error) {
          failures.add(id+'::'+ref);
          document.dispatchEvent(new CustomEvent('nova:artwork-display-error',{detail:{message:error.message}}));
        });
      }));
    }).then(notify);
    reconciliation = work;
    return work.finally(function() { if (reconciliation === work) reconciliation = null; });
  }
  function syncProperties() {
    var state;
    try { state = snapshot(); } catch(error) { return; }
    document.querySelectorAll('form[action*="/cart/add"]').forEach(function(form) {
      [['_nova_vector_service_instances',JSON.stringify(state.instances)],['Vectorization Service',state.instances.map(function(i) { return 'Completed — '+i.serviceInstanceId; }).join(', ')]].forEach(function(pair) {
        var input = form.querySelector('input[name="properties['+pair[0]+']"]');
        if (!input) { input = document.createElement('input'); input.type='hidden';input.name='properties['+pair[0]+']';form.appendChild(input); }
        input.value = pair[1];
      });
    });
  }
  function getCartItems(cartContext) {
    var id = project(), current = references().sort().join('|');
    if (!cartContext || cartContext.projectId !== id) return Promise.reject(Error('Vector service project identity could not be confirmed.'));
    // Original-only and other services must not acquire a new dependency on
    // automatic Vector catalog availability when no private result is used.
    if (!references().length) return Promise.resolve([]);
    return load().then(reconcileUsed).then(function() {
      var state = snapshot();
      if (state.pending) throw Error('The selected vector service must be verified before continuing. No new vectorization is needed.');
      if (!state.instances.length) return [];
      return ensureCatalog().then(function() { return Promise.all(state.instances.map(function(instance) { return access.describePrivateArtwork(instance.reference).then(function(a) {
        valid(a,instance.reference);
        if (a.checksum !== instance.checksum || a.source !== instance.sourceId || a.providerSource.checksum !== instance.providerChecksum) throw Error('Vector service integrity changed.');
        return instance;
      }); })); });
    }).then(function(instances) {
      if (project() !== id || references().sort().join('|') !== current) throw Error('Artwork selection changed while confirming its service. Review the current design.');
      return instances.map(function(instance) { return {id:service.variantId,quantity:1,properties:{
        _nova_project_id:id,_customization_pair_id:cartContext.pairId || '',_nova_line_type:'professional-service',
        _nova_service_key:'vector',_nova_service_instance_id:instance.serviceInstanceId,_nova_service_completion:'completed',
        _nova_artwork_source_id:instance.sourceId,_nova_prepared_candidate_id:instance.candidateId,
        _nova_artwork_artifact_id:instance.artifactId,_nova_artwork_checksum:instance.checksum,_nova_provider_source_checksum:instance.providerChecksum,
        'Professional Design Service':service.title,'Service for':cartContext.parentProduct || ''
      }}; });
    });
  }
  function disclose(button) {
    if (!button || button.hasAttribute('data-nova-vector-fee-disclosed')) return;
    var note=document.createElement('p');
    var index=1;
    while(document.getElementById('nova-vector-fee-'+index))index++;
    note.id='nova-vector-fee-'+index;
    note.setAttribute('data-nova-vector-fee-disclosure','');
    note.textContent='$5 when you use this Vector result in your design. No service fee for unused results.';
    note.style.fontWeight='400';note.style.fontSize='12px';note.style.lineHeight='1.4';note.style.margin='4px 0';
    button.insertAdjacentElement('afterend',note);
    button.setAttribute('aria-describedby',((button.getAttribute('aria-describedby') || '')+' '+note.id).trim());
    button.setAttribute('data-nova-vector-fee-disclosed','true');
  }
  function allAutomaticSnapshot(){return [access.preparedArtifacts&&access.preparedArtifacts.snapshot(),access.background&&access.background.fees.snapshot()].filter(Boolean).reduce(function(total,next){return{instances:total.instances.concat(next.instances),cents:total.cents+next.cents,pending:total.pending||next.pending,missing:total.missing.concat(next.missing)};},snapshot());}
  function allAutomaticCartItems(cartContext){return Promise.all([getCartItems(cartContext),access.preparedArtifacts?access.preparedArtifacts.getCartItems(cartContext):[],access.background?access.background.fees.getCartItems(cartContext):[]]).then(function(groups){return groups[0].concat(groups[1],groups[2]);});}
  access.vectorFees = Object.freeze({backgroundOnUse:true,register:register,has:has,select:select,snapshot:allAutomaticSnapshot,load:load,ensureCatalog:ensureCatalog,getCartItems:allAutomaticCartItems,disclose:disclose});
  ['nova:artwork-layers-changed','nova:project-state-restored','nova:artwork-preview-ready','nova:automatic-vector-services-changed','nova:imprint-surface-state-change','nova:imprint-history-restored','nova:authoritative-view-settled','nova:imprint-surface-change'].forEach(function(type) { document.addEventListener(type,syncProperties); });
  ['nova:artwork-layers-changed','nova:project-state-restored','nova:imprint-surface-state-change','nova:imprint-history-restored','nova:authoritative-view-settled','nova:imprint-surface-change'].forEach(function(type) { document.addEventListener(type,function() { Promise.all([reconcileUsed(),access.preparedArtifacts?access.preparedArtifacts.restoreUsed():null]).then(notify).catch(function(error) { document.dispatchEvent(new CustomEvent('nova:artwork-display-error',{detail:{message:error.message}})); }); }); });
  load().then(notify).catch(function(error) { document.dispatchEvent(new CustomEvent('nova:artwork-display-error',{detail:{message:error.message}})); });
}

  function installPrivateArtworkDisplay(){
    if(!window.NovaProjectArtworkAccess||window.NovaProjectArtworkAccess.bindArtworkDisplay)return;
    function novaPrivateArtworkImage(source, loader) {
  return novaAcquireArtworkDisplay(source).then(function (lease) {
    return Promise.resolve().then(function () { return loader(lease.url); }).finally(lease.release);
  });
}
// One ephemeral resource owner for existing private-artwork consumers. Durable
// records keep their private locators/checksums, never these browser blob URLs.
var novaArtworkDisplayReads = new Map(), novaArtworkDisplayBindings = new Map();
var novaArtworkDisplayObserver = null;
function novaArtworkDisplayPrivate(source) {
  // Recognize the locator shape even before API initialization. Missing or
  // wrong-origin authorization must fail closed, never become an ordinary GET.
  if(/^(nova-ai|nova-upscale):[a-f0-9-]{36}:[a-f0-9]{64}$/.test(String(source||'')))return true;
  try { return /^\/artwork\/files\/[a-f0-9]{64}\/[a-f0-9]{64}$/.test(new URL(source).pathname); }
  catch (error) { return false; }
}
function novaArtworkDisplayAbort() { return new DOMException('Artwork display cancelled.', 'AbortError'); }
function novaArtworkDisplayExpired() { var error = new Error('This saved artwork has reached its retention deadline. Your project record is unchanged.'); error.code = 'private_artwork_expired'; return error; }
function novaAcquireArtworkDisplay(source, options) {
  options = options || {};
  var api = window.NovaProjectArtworkAccess, owner = api && api.owner && api.owner(), project;
  try {
    if (!api || !api.describePrivateArtwork) { var upgrade = new Error('The secure display update is incomplete. Your artwork is unchanged. Keep this page open until its preservation is confirmed.'); upgrade.code = 'private_display_upgrade_required'; throw upgrade; }
    if (!novaArtworkDisplayPrivate(source) || !owner || !api.isPrivateArtwork || !api.isPrivateArtwork(source)) throw new Error('Authorized artwork display is unavailable.');
    project = owner.getProjectId(); owner.requirePersistedProjectId(project);
    if (options.signal && options.signal.aborted) throw novaArtworkDisplayAbort();
  } catch (error) { return Promise.reject(error); }
  var key = project + '|' + source, entry = novaArtworkDisplayReads.get(key);
  if (entry && entry.artifact && entry.artifact.expiresAt * 1000 <= Date.now()) entry = null;
  if (entry && entry.releaseTimer) { window.clearTimeout(entry.releaseTimer); entry.releaseTimer = 0; }
  if (!entry) {
    entry = { key: key, source: source, project: project, refs: 0, url: '', controller: new AbortController(), artifact: null };
    novaArtworkDisplayReads.set(key, entry);
    entry.deadlineTimer = window.setTimeout(function () { entry.controller.abort(); }, 65000);
    entry.promise = Promise.resolve().then(function () { return api.describePrivateArtwork(source, entry.controller.signal); }).then(function (artifact) {
      owner.requirePersistedProjectId(project);
      if (!(artifact.expiresAt * 1000 > Date.now())) throw novaArtworkDisplayExpired();
      var prepared=api.preparedArtifacts&&api.preparedArtifacts.is(source);
      if (owner.getProjectId() !== project || artifact.project !== project || artifact.state !== 'ready' ||
          !(artifact.bytes > 0 && artifact.bytes <= (prepared?64*1024*1024:10485760)) ||
          (prepared?artifact.reference!==source:source.slice(-65) !== '/' + artifact.checksum || source.indexOf('/' + artifact.id + '/') < 0)) {
        throw new Error('The saved artwork identity or access has expired. Your project is unchanged.');
      }
      entry.artifact = artifact;
      if (entry.controller.signal.aborted) throw novaArtworkDisplayAbort();
      return api.readPrivateArtwork(source, entry.controller.signal);
    }).then(function (blob) {
      owner.requirePersistedProjectId(project);
      if (owner.getProjectId() !== project || entry.controller.signal.aborted) throw novaArtworkDisplayAbort();
      if (blob.size !== entry.artifact.bytes || blob.type.split(';')[0] !== entry.artifact.mime || !/^image\/(svg\+xml|png|jpeg|webp)$/.test(entry.artifact.mime)) {
        throw new Error('The saved artwork response does not match its verified artifact.');
      }
      // The reader checks the original bytes. This existing SVG declaration
      // normalization is display-only and never replaces either saved checksum.
      return entry.artifact.mime === 'image/svg+xml' ? blob.text().then(function (text) {
        return new Blob([novaNormalizeSvgDeclaration(text)], { type: entry.artifact.mime });
      }) : blob;
    }).then(function (blob) {
      if (!entry.refs || entry.controller.signal.aborted) throw novaArtworkDisplayAbort();
      if (entry.artifact.expiresAt * 1000 <= Date.now()) throw novaArtworkDisplayExpired();
      entry.url = URL.createObjectURL(blob); return entry;
    }).catch(function (error) {
      if (novaArtworkDisplayReads.get(key) === entry) novaArtworkDisplayReads.delete(key);
      throw error;
    }).finally(function () { window.clearTimeout(entry.deadlineTimer); });
  }
  entry.refs += 1;
  return new Promise(function (resolve, reject) {
    var released = false;
    function release() {
      if (released) return; released = true;
      if (options.signal) options.signal.removeEventListener('abort', abort);
      entry.refs -= 1;
      if (!entry.refs) {
        function collect() {
          if (entry.refs) return;
          entry.controller.abort();
          if (entry.url) { URL.revokeObjectURL(entry.url); entry.url = ''; }
          if (novaArtworkDisplayReads.get(key) === entry) novaArtworkDisplayReads.delete(key);
        }
        // One bounded handoff turn lets a decoded source transfer to the DOM
        // without downloading it twice. Pending/expired reads abort immediately.
        if (entry.url && entry.artifact.expiresAt * 1000 > Date.now()) entry.releaseTimer = window.setTimeout(collect, 100);
        else collect();
      }
    }
    function abort() { release(); reject(novaArtworkDisplayAbort()); }
    if (options.signal) options.signal.addEventListener('abort', abort, { once: true });
    entry.promise.then(function () {
      if (released) return;
      try { owner.requirePersistedProjectId(project); if (owner.getProjectId() !== project) throw novaArtworkDisplayAbort(); }
      catch (error) { release(); reject(error); return; }
      resolve({ url: entry.url, artifact: entry.artifact, release: release });
    }, function (error) { release(); reject(error); });
  });
}
function novaReleaseArtworkDisplay(image) {
  var binding = novaArtworkDisplayBindings.get(image);
  if (!binding) return;
  novaArtworkDisplayBindings.delete(image); binding.controller.abort();
  window.clearTimeout(binding.timer); window.clearTimeout(binding.expiryTimer);
  if (binding.lease) binding.lease.release();
  if (binding.cancelDecode) binding.cancelDecode();
}
function novaBindArtworkDisplay(image, source, options) {
  options = options || {}; source = String(source || '');
  if (!image) return Promise.resolve(false);
  var access = window.NovaProjectArtworkAccess, owner = access && access.owner && access.owner(), project = owner && owner.getProjectId && owner.getProjectId();
  var previous = novaArtworkDisplayBindings.get(image);
  if (previous && previous.source === source && previous.project === project && previous.api === window.NovaProjectArtworkAccess && !options.retry) return previous.promise;
  novaReleaseArtworkDisplay(image);
  if (!novaArtworkDisplayPrivate(source)) {
    image.removeAttribute('data-nova-private-artwork-reference'); image.removeAttribute('data-nova-artwork-display-state');
    image.removeAttribute('aria-busy'); if (image.getAttribute('src') !== source) image.src = source;
    return Promise.resolve(true);
  }
  var binding = { source: source, project: project, api: window.NovaProjectArtworkAccess, controller: new AbortController(), lease: null, timer: 0, expiryTimer: 0 };
  novaArtworkDisplayBindings.set(image, binding);
  image.setAttribute('data-nova-private-artwork-reference', source);
  image.setAttribute('data-nova-artwork-display-state', 'loading'); image.setAttribute('aria-busy', 'true'); image.removeAttribute('src');
  function current() { return novaArtworkDisplayBindings.get(image) === binding && !binding.controller.signal.aborted; }
  function fail(error) {
    if (!current()) return false;
    window.clearTimeout(binding.timer); window.clearTimeout(binding.expiryTimer);
    image.removeAttribute('src'); image.setAttribute('aria-busy', 'false'); image.setAttribute('data-nova-artwork-display-state', 'error');
    if (binding.lease) { binding.lease.release(); binding.lease = null; }
    image.setAttribute('title', error && (error.code === 'private_artwork_expired' || error.code === 'private_display_upgrade_required') ? error.message : 'Artwork could not be displayed. Your saved artwork is unchanged. Reopen its preview to retrieve it securely.');
    image.dispatchEvent(new CustomEvent('nova:artwork-display-error', { bubbles: true, detail: { code: error && error.code === 'private_artwork_expired' ? error.code : error && error.name === 'AbortError' ? 'display_cancelled' : 'private_display_unavailable' } }));
    return false;
  }
  binding.timer = window.setTimeout(function () { fail(new Error('Artwork display timed out.')); binding.controller.abort(); }, 65000);
  binding.promise = novaAcquireArtworkDisplay(source, { signal: binding.controller.signal }).then(function (lease) {
    if (!current() || !image.isConnected) { lease.release(); return false; }
    binding.lease = lease;
    return new Promise(function (resolve, reject) {
      function stop() { image.removeEventListener('load', loaded); image.removeEventListener('error', failed); binding.cancelDecode = null; }
      function loaded() {
        if (!current()) { stop(); resolve(false); return; }
        if (!owner || owner.getProjectId() !== binding.project) { failed(); return; }
        if (!(image.naturalWidth > 0 && image.naturalHeight > 0)) { failed(); return; }
        stop(); resolve(true);
      }
      function failed() { stop(); reject(new Error('The verified artwork could not be decoded.')); }
      binding.cancelDecode = function () { stop(); resolve(false); };
      image.addEventListener('load', loaded); image.addEventListener('error', failed); image.src = lease.url;
      if (image.complete && image.naturalWidth > 0) loaded();
    });
  }).then(function (ready) {
    if (!ready || !current()) return false;
    window.clearTimeout(binding.timer); image.setAttribute('aria-busy', 'false'); image.removeAttribute('title'); image.setAttribute('data-nova-artwork-display-state', 'ready');
    function expire() {
      if (!current()) return;
      var remaining = binding.lease.artifact.expiresAt * 1000 - Date.now();
      if (remaining <= 0) { fail(novaArtworkDisplayExpired()); return; }
      binding.expiryTimer = window.setTimeout(expire, Math.min(remaining, 2147483647));
    }
    expire(); return true;
  }).catch(fail);
  return binding.promise;
}
function novaArtworkDisplayMarkup(source, alt) {
  function escape(value) { return String(value || '').replace(/&/g, '&amp;').replace(/"/g, '&quot;').replace(/</g, '&lt;').replace(/>/g, '&gt;'); }
  return '<img ' + (novaArtworkDisplayPrivate(source) ? 'data-nova-private-artwork-reference="' : 'src="') + escape(source) + '" alt="' + escape(alt) + '">';
}
function novaObserveArtworkDisplays() {
  if (novaArtworkDisplayObserver || !document.documentElement) return;
  function scan(node) {
    if (!node || node.nodeType !== 1) return;
    if (node.matches('img[data-nova-private-artwork-reference]')) novaBindArtworkDisplay(node, node.getAttribute('data-nova-private-artwork-reference'));
    node.querySelectorAll('img[data-nova-private-artwork-reference]').forEach(function (image) { novaBindArtworkDisplay(image, image.getAttribute('data-nova-private-artwork-reference')); });
  }
  novaArtworkDisplayObserver = new MutationObserver(function (records) {
    // Bind additions before releasing detached predecessors so re-rendered
    // thumbnails retain a shared lease rather than restarting the same read.
    records.forEach(function (record) { record.addedNodes.forEach(scan); });
    novaArtworkDisplayBindings.forEach(function (binding, image) { if (!image.isConnected) novaReleaseArtworkDisplay(image); });
  });
  novaArtworkDisplayObserver.observe(document.documentElement, { childList: true, subtree: true }); scan(document.documentElement);
  window.addEventListener('pagehide', function () {
    novaArtworkDisplayBindings.forEach(function (binding, image) { novaReleaseArtworkDisplay(image); image.removeAttribute('src'); });
    novaArtworkDisplayReads.forEach(function (entry) {
      window.clearTimeout(entry.releaseTimer); entry.controller.abort();
      if (entry.url) { URL.revokeObjectURL(entry.url); entry.url = ''; }
    });
    novaArtworkDisplayReads.clear();
  });
  window.addEventListener('pageshow', function () { scan(document.documentElement); });
}
function novaNormalizeSvgDeclaration(text) {
  // Vectorizer's fixed SVG 1.1 declaration is export metadata, not artwork.
  // Strip only that exact public declaration before parsing. Unknown DTDs,
  // internal subsets and entities remain for the existing guards to reject.
  return String(text || '').replace(/^(\uFEFF?\s*(?:<\?xml\s[^?]*\?>\s*)?)<!DOCTYPE\s+svg\s+PUBLIC\s+"-\/\/W3C\/\/DTD SVG 1\.1\/\/EN"\s+"http:\/\/www\.w3\.org\/Graphics\/SVG\/1\.1\/DTD\/svg11\.dtd"\s*>\s*/, '$1');
}

var novaDisplayAccess = window.NovaProjectArtworkAccess;
if (novaDisplayAccess) {
  var novaPriorImageReader = novaDisplayAccess.image;
  novaDisplayAccess.acquirePrivateArtworkDisplay = novaAcquireArtworkDisplay;
  novaDisplayAccess.bindArtworkDisplay = novaBindArtworkDisplay;
  novaDisplayAccess.releaseArtworkDisplay = novaReleaseArtworkDisplay;
  novaDisplayAccess.artworkDisplayMarkup = novaArtworkDisplayMarkup;
  novaDisplayAccess.image = function (source, loader) {
    return novaArtworkDisplayPrivate(source) ? novaPrivateArtworkImage(source, loader) : novaPriorImageReader(source, loader);
  };
  novaObserveArtworkDisplays();
}

  }
})();

(function () {
  'use strict';

  var initializedStudios = new WeakSet();

  var SUPPORTED_RASTER_TYPES = [
    'image/png',
    'image/jpeg',
    'image/webp',
    'image/gif',
    'image/bmp'
  ];

  var MAX_FILE_SIZE =
    10 * 1024 * 1024;

  function query(root, selector) {
    return root
      ? root.querySelector(selector)
      : null;
  }

  function queryAll(root, selector) {
    return root
      ? Array.prototype.slice.call(
          root.querySelectorAll(selector)
        )
      : [];
  }

  function setHidden(element, hidden) {
    if (!element) return;

    element.hidden =
      Boolean(hidden);
  }

  function setText(element, value) {
    if (!element) return;

    element.textContent =
      value;
  }

  function setInputValue(element, value) {
    if (!element) return;

    element.value =
      value === null ||
      value === undefined
        ? ''
        : String(value);
  }

  function clamp(value, minimum, maximum) {
    return Math.max(
      minimum,
      Math.min(
        maximum,
        value
      )
    );
  }

  function roundToTwo(value) {
    return Math.round(
      Number(value || 0) * 100
    ) / 100;
  }

  function formatFileSize(bytes) {
    var size =
      Number(bytes || 0);

    if (size < 1024) {
      return size + ' B';
    }

    if (
      size <
      1024 * 1024
    ) {
      return (
        size / 1024
      ).toFixed(1) + ' KB';
    }

    return (
      size /
      (
        1024 *
        1024
      )
    ).toFixed(1) + ' MB';
  }

  function getFileExtension(fileName) {
    var parts =
      String(
        fileName || ''
      ).split('.');

    return parts.length > 1
      ? parts.pop().toLowerCase()
      : '';
  }

  function isSvgFile(file) {
    if (!file) return false;

    return (
      file.type ===
        'image/svg+xml' ||
      getFileExtension(
        file.name
      ) === 'svg'
    );
  }

  function isSupportedRaster(file) {
    if (!file) return false;

    return (
      SUPPORTED_RASTER_TYPES.indexOf(
        file.type
      ) !== -1
    );
  }

  function createObjectUrl(fileOrBlob) {
    try {
      return URL.createObjectURL(
        fileOrBlob
      );
    } catch (error) {
      console.error(
        'Artwork preview URL error:',
        error
      );

      return '';
    }
  }

  function revokeObjectUrl(url) {
    if (!url) return;

    try {
      URL.revokeObjectURL(url);
    } catch (error) {
      console.error(
        'Artwork preview cleanup error:',
        error
      );
    }
  }

  function hexToRgb(hex) {
    var clean =
      String(hex || '')
        .replace('#', '');

    if (clean.length === 3) {
      clean =
        clean
          .split('')
          .map(function (character) {
            return character +
              character;
          })
          .join('');
    }

    var parsed =
      parseInt(clean, 16);

    if (
      Number.isNaN(parsed)
    ) {
      return {
        red: 255,
        green: 255,
        blue: 255
      };
    }

    return {
      red:
        (
          parsed >> 16
        ) & 255,

      green:
        (
          parsed >> 8
        ) & 255,

      blue:
        parsed & 255
    };
  }

  function rgbToHex(
    red,
    green,
    blue
  ) {
    function component(value) {
      return clamp(
        Math.round(value),
        0,
        255
      )
        .toString(16)
        .padStart(2, '0');
    }

    return (
      '#' +
      component(red) +
      component(green) +
      component(blue)
    );
  }

  function colorDistance(
    red,
    green,
    blue,
    target
  ) {
    var redDifference =
      red - target.red;

    var greenDifference =
      green - target.green;

    var blueDifference =
      blue - target.blue;

    return Math.sqrt(
      redDifference *
        redDifference +
      greenDifference *
        greenDifference +
      blueDifference *
        blueDifference
    );
  }

  function loadImageFromUrl(url) {
    if(window.NovaProjectArtworkAccess.isPrivateArtwork(url))return window.NovaProjectArtworkAccess.image(url,loadImageFromUrl);
    return new Promise(
      function (resolve, reject) {
        var image =
          new Image();

        image.onload =
          function () {
            resolve(image);
          };

        image.onerror =
          function () {
            reject(
              new Error(
                'The artwork preview could not be opened.'
              )
            );
          };

        image.src =
          url;
      }
    );
  }

  function canvasToBlob(
    canvas,
    type,
    quality
  ) {
    return new Promise(
      function (resolve, reject) {
        canvas.toBlob(
          function (blob) {
            if (!blob) {
              reject(
                new Error(
                  'The prepared artwork file could not be created.'
                )
              );

              return;
            }

            resolve(blob);
          },
          type || 'image/png',
          quality || 0.95
        );
      }
    );
  }

  function getProductForm(studio) {
    var section =
      studio.closest(
        '[id^="ProductSection-"]'
      );

    return section
      ? section.querySelector(
          'form[action*="/cart/add"]'
        )
      : null;
  }

  function movePropertiesIntoProductForm(
    studio
  ) {
    var form =
      getProductForm(studio);

    if (!form) return;

    if (!form.id) {
      form.id =
        'TwistedSwagProductForm-' +
        Math.random()
          .toString(36)
          .slice(2);
    }

    queryAll(
      studio,
      '.ts-artwork-card__order-properties input'
    ).forEach(
      function (input) {
        /*
          Keep each artwork property input inside its original card
          so the uploader, analyzer, background remover, vectorizer,
          and version selector can continue updating the correct field.

          The HTML form attribute connects the input to Shopify's
          product form without physically moving it out of the card.
        */
        input.setAttribute(
          'form',
          form.id
        );
      }
    );
  }

  function initializeStudio(studio) {
    if (
      !studio ||
      initializedStudios.has(
        studio
      )
    ) {
      return;
    }

    initializedStudios.add(
      studio
    );

    var workerUrl =
      String(
        studio.getAttribute(
          'data-worker-url'
        ) || ''
      ).replace(
        /\/vectorize\/?$/,
        ''
      );

    var vectorEndpoint =
      workerUrl +
      '/vectorize';

    var storageEndpoint =
      workerUrl +
      '/store-file';

    var cards =
      queryAll(
        studio,
        '[data-ts-artwork-card]'
      );

    var studioStatus =
      query(
        studio,
        '[data-ts-studio-status]'
      );

    var fileCount =
      query(
        studio,
        '[data-ts-file-count]'
      );

    var choiceCount =
      query(
        studio,
        '[data-ts-choice-count]'
      );

    var modal =
      document.querySelector(
        '[data-ts-studio-modal]'
      );

    var modalImage =
      query(
        modal,
        '[data-ts-modal-image]'
      );

    var modalTitle =
      query(
        modal,
        '[data-ts-modal-title]'
      );

    var modalClose =
      query(
        modal,
        '[data-ts-modal-close]'
      );

    var previousFocusedElement =
      null;

    var states = cards.map(
      function (card) {
        window.NovaProjectArtworkAccess.vectorFees.disclose(query(card,'[data-ts-create-vector]'));
        return {
          card:
            card,

          number:
            Number(
              card.getAttribute(
                'data-artwork-number'
              ) || 1
            ),

          file:
            null,

          originalUrl:
            '',

          currentPreviewUrl:
            '',

          backgroundUrl:
            '',

          vectorUrl:
            '',

          originalStoredUrl:
            '',

          backgroundStoredUrl:
            '',

          naturalWidth:
            0,

          naturalHeight:
            0,

          aspectRatio:
            1,

          isVector:
            false,

          isLocked:
            true,

          selectedVersion:
            'original',

          backgroundBlob:
            null,

          analysis:
            null,

          progressTimer:
            null
        };
      }
    );

    function getStateFromElement(element) {
      var card =
        element.closest(
          '[data-ts-artwork-card]'
        );

      if (!card) return null;

      return states.find(
        function (state) {
          return (
            state.card ===
            card
          );
        }
      ) || null;
    }

    function closeAllTooltips(
      exceptButton
    ) {
      queryAll(
        studio,
        '[data-ts-tooltip-button]'
      ).forEach(
        function (button) {
          if (
            exceptButton &&
            button ===
              exceptButton
          ) {
            return;
          }

          button.setAttribute(
            'aria-expanded',
            'false'
          );

          var tooltip =
            button.parentElement
              ? query(
                  button.parentElement,
                  '[data-ts-tooltip]'
                )
              : null;

          setHidden(
            tooltip,
            true
          );
        }
      );
    }

    function toggleTooltip(button) {
      var tooltip =
        button.parentElement
          ? query(
              button.parentElement,
              '[data-ts-tooltip]'
            )
          : null;

      if (!tooltip) return;

      var isOpening =
        button.getAttribute(
          'aria-expanded'
        ) !== 'true';

      closeAllTooltips(
        isOpening
          ? button
          : null
      );

      button.setAttribute(
        'aria-expanded',
        isOpening
          ? 'true'
          : 'false'
      );

      setHidden(
        tooltip,
        !isOpening
      );
    }

    function openModal(
      imageUrl,
      title
    ) {
      if (
        !modal ||
        !modalImage ||
        !imageUrl
      ) {
        return;
      }

      previousFocusedElement =
        document.activeElement;

      modalImage.src =
        imageUrl;

      modalImage.alt =
        title ||
        'Artwork preview';

      setText(
        modalTitle,
        title ||
        'Artwork Preview'
      );

      modal.classList.add(
        'is-open'
      );

      modal.setAttribute(
        'aria-hidden',
        'false'
      );

      document.body.classList.add(
        'ts-studio-modal-open'
      );

      if (modalClose) {
        modalClose.focus();
      }
    }

    function closeModal() {
      if (!modal) return;

      modal.classList.remove(
        'is-open'
      );

      modal.setAttribute(
        'aria-hidden',
        'true'
      );

      document.body.classList.remove(
        'ts-studio-modal-open'
      );

      if (modalImage) {
        modalImage.removeAttribute(
          'src'
        );
      }

      if (
        previousFocusedElement &&
        typeof previousFocusedElement.focus ===
          'function'
      ) {
        previousFocusedElement.focus();
      }
    }

    function activateNextCard(state) {
      var nextState =
        states[state.number];

      if (
        nextState &&
        !nextState.card.classList.contains(
          'is-active'
        )
      ) {
        nextState.card.classList.add(
          'is-active'
        );
      }
    }

    function updateSummary() {
      var populated =
        states.filter(
          function (state) {
            return Boolean(
              state.file
            );
          }
        );

      var completedChoices =
        populated.filter(
          function (state) {
            return Boolean(
              state.selectedVersion
            );
          }
        );

      setText(
        fileCount,
        populated.length +
          ' of 8'
      );

      setText(
        choiceCount,
        String(
          completedChoices.length
        )
      );

      if (
        populated.length === 0
      ) {
        setText(
          studioStatus,
          'Waiting for artwork'
        );
      } else if (
        populated.length === 1
      ) {
        setText(
          studioStatus,
          '1 artwork file ready'
        );
      } else {
        setText(
          studioStatus,
          populated.length +
            ' artwork files ready'
        );
      }
    }

    function clearProgressTimer(state) {
      if(state.vectorAnimation){state.vectorAnimation.cancel();state.vectorAnimation=null;}
      if (
        state.progressTimer
      ) {
        window.clearInterval(
          state.progressTimer
        );

        state.progressTimer =
          null;
      }
    }

    function resetStateUrls(state) {
      revokeObjectUrl(
        state.originalUrl
      );

      if (
        state.currentPreviewUrl &&
        state.currentPreviewUrl !==
          state.originalUrl
      ) {
        revokeObjectUrl(
          state.currentPreviewUrl
        );
      }

      if (
        state.backgroundUrl &&
        state.backgroundUrl !==
          state.originalUrl &&
        state.backgroundUrl !==
          state.currentPreviewUrl
      ) {
        revokeObjectUrl(
          state.backgroundUrl
        );
      }

      state.originalUrl =
        '';

      state.currentPreviewUrl =
        '';

      state.backgroundUrl =
        '';
    }

    function clearCardUi(state) {
      var card =
        state.card;

      clearProgressTimer(
        state
      );

      resetStateUrls(
        state
      );

      state.file =
        null;

      state.backgroundBlob =
        null;

      state.vectorUrl =
        '';

      state.originalStoredUrl =
        '';

      state.backgroundStoredUrl =
        '';

      state.naturalWidth =
        0;

      state.naturalHeight =
        0;

      state.aspectRatio =
        1;

      state.isVector =
        false;

      state.isLocked =
        true;

      state.selectedVersion =
        'original';

      state.analysis =
        null;

      card.classList.remove(
        'has-file'
      );

      var input =
        query(
          card,
          '[data-ts-artwork-input]'
        );

      if (input) {
        input.value =
          '';
      }

      setHidden(
        query(
          card,
          '[data-ts-artwork-workspace]'
        ),
        true
      );

      setHidden(
        query(
          card,
          '[data-ts-upload-area]'
        ),
        false
      );

      setText(
        query(
          card,
          '[data-ts-file-status]'
        ),
        'No file selected'
      );

      setText(
        query(
          card,
          '[data-ts-artwork-title]'
        ),
        state.number === 1
          ? 'Choose your first artwork file'
          : 'Additional artwork'
      );

      setText(
        query(
          card,
          '[data-ts-upload-button-text]'
        ),
        'Choose Artwork ' +
          state.number
      );

      [
        '[data-ts-artwork-preview-image]',
        '[data-ts-version-original-image]',
        '[data-ts-version-background-image]',
        '[data-ts-version-vector-image]'
      ].forEach(
        function (selector) {
          var image =
            query(
              card,
              selector
            );

          if (image) {
            image.removeAttribute(
              'src'
            );
          }
        }
      );

      setText(
        query(
          card,
          '[data-ts-file-type]'
        ),
        '—'
      );

      setText(
        query(
          card,
          '[data-ts-file-size]'
        ),
        '—'
      );

      setText(
        query(
          card,
          '[data-ts-pixel-dimensions]'
        ),
        '—'
      );

      setText(
        query(
          card,
          '[data-ts-transparency-status]'
        ),
        '—'
      );

      setText(
        query(
          card,
          '[data-ts-dominant-colors]'
        ),
        '—'
      );

      setText(
        query(
          card,
          '[data-ts-printable-colors]'
        ),
        '—'
      );

      setInputValue(
        query(
          card,
          '[data-ts-print-width]'
        ),
        ''
      );

      setInputValue(
        query(
          card,
          '[data-ts-print-height]'
        ),
        ''
      );

      var locationSelect =
        query(
          card,
          '[data-ts-location-select]'
        );

      if (locationSelect) {
        locationSelect.value =
          '';
      }

      var lockButton =
        query(
          card,
          '[data-ts-aspect-lock]'
        );

      if (lockButton) {
        lockButton.classList.add(
          'is-locked'
        );

        lockButton.setAttribute(
          'aria-pressed',
          'true'
        );
      }

      setText(
        query(
          card,
          '[data-ts-aspect-lock-text]'
        ),
        'Locked'
      );

      setText(
        query(
          card,
          '[data-ts-effective-dpi]'
        ),
        '—'
      );

      setText(
        query(
          card,
          '[data-ts-maximum-size]'
        ),
        '—'
      );

      updateQuality(
        state,
        'waiting',
        'Waiting',
        '',
        ''
      );

      setHidden(
        query(
          card,
          '[data-ts-version-option="background_removed"]'
        ),
        true
      );

      setHidden(
        query(
          card,
          '[data-ts-version-option="vector"]'
        ),
        true
      );

      setHidden(
        query(
          card,
          '[data-ts-vector-progress]'
        ),
        true
      );

      setHidden(
        query(
          card,
          '[data-ts-vector-error]'
        ),
        true
      );

      var restoreButton =
        query(
          card,
          '[data-ts-restore-original]'
        );

      if (restoreButton) {
        restoreButton.disabled =
          true;
      }

      selectVersion(
        state,
        'original'
      );

      clearProperties(
        state
      );

      updateSummary();
    }

    function clearProperties(state) {
      var card =
        state.card;

      [
        '[data-ts-property-original-file]',
        '[data-ts-property-production-file]',
        '[data-ts-property-location]',
        '[data-ts-property-width]',
        '[data-ts-property-height]',
        '[data-ts-property-dpi]',
        '[data-ts-property-quality]',
        '[data-ts-property-vector-url]'
      ].forEach(
        function (selector) {
          setInputValue(
            query(
              card,
              selector
            ),
            ''
          );
        }
      );

      setInputValue(
        query(
          card,
          '[data-ts-property-version]'
        ),
        'Original Artwork'
      );

      setInputValue(
        query(
          card,
          '[data-ts-property-background-status]'
        ),
        'No'
      );
    }

    async function uploadStoredFile(state,blobOrFile,versionType,fileName) {
      var selectedAtDispatch=state.file;
      var result=await window.NovaProjectArtworkAccess.submit('stored-'+state.number+'-'+versionType,blobOrFile,false,{version:versionType,name:fileName||state.file&&state.file.name||'artwork'});
      if(state.file!==selectedAtDispatch)throw Error('The selected source changed. The verified private file was retained but not applied.');
      return result.fileUrl;
    }
    async function storeOriginalFile(state) {
      if (
        !state.file ||
        state.originalStoredUrl
      ) {
        return;
      }

      try {
        state.originalStoredUrl =
          await uploadStoredFile(
            state,
            state.file,
            'original',
            state.file.name
          );

        setInputValue(
          query(
            state.card,
            '[data-ts-property-original-file]'
          ),
          state.originalStoredUrl
        );

        if (
          state.selectedVersion ===
          'original'
        ) {
          setInputValue(
            query(
              state.card,
              '[data-ts-property-production-file]'
            ),
            state.originalStoredUrl
          );
        }
      } catch (error) {
        console.error(
          'Original artwork storage error:',
          error
        );
      }
    }


    function artworkSelection(state){return {version:state.selectedVersion,originalStoredUrl:state.originalStoredUrl||'',backgroundStoredUrl:state.backgroundStoredUrl||'',vectorUrl:state.vectorUrl||'',width:query(state.card,'[data-ts-print-width]')&&query(state.card,'[data-ts-print-width]').value||'',height:query(state.card,'[data-ts-print-height]')&&query(state.card,'[data-ts-print-height]').value||'',location:query(state.card,'[data-ts-location-select]')&&query(state.card,'[data-ts-location-select]').value||''};}
    function preserveArtworkState(state){
      if(!state.file||state.restoringPrivateArtwork)return Promise.resolve();
      state.preservation=(state.preservation||Promise.resolve()).catch(function(){}).then(function(){
        var service=window.NovaProjectArtworkAccess;
        return (state.backgroundBlob?service.checksum(state.file).then(function(original){return service.preserve('adapter-background-'+state.number,state.backgroundBlob,{original:original});}):Promise.resolve()).then(function(){return service.preserve('adapter-'+state.number,state.file,artworkSelection(state));});
      });
      state.preservation.catch(function(error){setText(query(state.card,'[data-ts-vector-error-message]'),error.message);setHidden(query(state.card,'[data-ts-vector-error]'),false);});return state.preservation;
    }
    function restoreArtworkState(state){
      if(state.file)return Promise.resolve(false);
      var service=window.NovaProjectArtworkAccess;
      return service.restore('adapter-'+state.number,function(record){
        if(state.file)throw Error('New artwork is already selected; the preserved record was not applied.');
        state.restoringPrivateArtwork=true;
        return handleFileSelection(state,record.file,true).then(function(){return service.load('adapter-background-'+state.number);}).then(function(background){
          if(state.file!==record.file)throw Error('New artwork was selected during restoration. The newer artwork was not replaced.');
          var saved=record.selection;
          if(background&&background.selection.original===record.checksum){state.backgroundBlob=background.file;state.backgroundUrl=createObjectUrl(background.file);var img=query(state.card,'[data-ts-version-background-image]');if(img)img.src=state.backgroundUrl;setHidden(query(state.card,'[data-ts-version-option="background_removed"]'),false);}else if(saved.version==='background_removed')throw Error('The preserved background result does not match this Original. Keep the older page open.');
          state.originalStoredUrl=saved.originalStoredUrl;state.backgroundStoredUrl=saved.backgroundStoredUrl;state.vectorUrl=saved.vectorUrl;
          [['[data-ts-print-width]',saved.width],['[data-ts-print-height]',saved.height],['[data-ts-location-select]',saved.location]].forEach(function(pair){var node=query(state.card,pair[0]);if(node)node.value=pair[1];});
          var preview=state.vectorUrl?service.vectorFees.register(state.vectorUrl).then(function(){return service.sourceResponse(state.vectorUrl);}).then(function(r){if(!r.ok)throw Error('The preserved vector cannot be retrieved. Keep the earlier page open.');return r.blob();}).then(function(blob){state.restoredVectorPreview=createObjectUrl(blob);var img=query(state.card,'[data-ts-version-vector-image]');if(img)img.src=state.restoredVectorPreview;setHidden(query(state.card,'[data-ts-version-option="vector"]'),false);}):Promise.resolve();
          return preview.then(function(){selectVersion(state,saved.version);});
        }).finally(function(){state.restoringPrivateArtwork=false;});
      },function(){return artworkSelection(state);});
    }

    function selectVersion(
      state,
      version
    ) {
      var card =
        state.card;

      state.selectedVersion =
        version;

      queryAll(
        card,
        '[data-ts-version-option]'
      ).forEach(
        function (option) {
          var optionVersion =
            option.getAttribute(
              'data-ts-version-option'
            );

          option.classList.toggle(
            'is-selected',
            optionVersion ===
              version
          );

          var input =
            query(
              option,
              '[data-ts-version-choice]'
            );

          if (input) {
            input.checked =
              optionVersion ===
              version;
          }
        }
      );

      var versionLabel =
        'Original Artwork';

      var productionUrl =
        state.originalStoredUrl ||
        '';

      if (
        version ===
        'background_removed'
      ) {
        versionLabel =
          'Background Removed';

        productionUrl =
          state.backgroundStoredUrl ||
          '';
      }

      if (
        version ===
        'vector'
      ) {
        versionLabel =
          'Enhanced Vector';

        productionUrl =
          state.vectorUrl ||
          '';
      }

      setText(
        query(
          card,
          '[data-ts-selected-version]'
        ),
        versionLabel
      );

      setInputValue(
        query(
          card,
          '[data-ts-property-version]'
        ),
        versionLabel
      );

      setInputValue(
        query(
          card,
          '[data-ts-property-production-file]'
        ),
        productionUrl
      );

      window.NovaProjectArtworkAccess.vectorFees.select('adapter-'+state.number, version==='vector'?state.vectorUrl:'');
      window.NovaProjectArtworkAccess.background.select('adapter-'+state.number,version==='background_removed'?state.backgroundStoredUrl||state.backgroundUrl:'',state.originalStoredUrl||state.originalUrl).catch(function(error){setText(query(state.card,'[data-ts-vector-error-message]'),error.message);setHidden(query(state.card,'[data-ts-vector-error]'),false);});
      updateSummary();
      preserveArtworkState(state);
    }

    function updateQuality(
      state,
      level,
      label,
      title,
      description
    ) {
      var card =
        state.card;

      var pill =
        query(
          card,
          '[data-ts-quality-pill]'
        );

      var message =
        query(
          card,
          '[data-ts-quality-message]'
        );

      if (pill) {
        pill.classList.remove(
          'is-success',
          'is-info',
          'is-warning',
          'is-danger'
        );

        if (
          level ===
          'success'
        ) {
          pill.classList.add(
            'is-success'
          );
        } else if (
          level ===
          'info'
        ) {
          pill.classList.add(
            'is-info'
          );
        } else if (
          level ===
          'warning'
        ) {
          pill.classList.add(
            'is-warning'
          );
        } else if (
          level ===
          'danger'
        ) {
          pill.classList.add(
            'is-danger'
          );
        }

        pill.textContent =
          label;
      }

      if (message) {
        message.classList.remove(
          'is-success',
          'is-info'
        );

        if (
          level ===
          'success'
        ) {
          message.classList.add(
            'is-success'
          );
        }

        if (
          level ===
          'info'
        ) {
          message.classList.add(
            'is-info'
          );
        }

        setHidden(
          message,
          !title
        );
      }

      setText(
        query(
          card,
          '[data-ts-quality-title]'
        ),
        title
      );

      setText(
        query(
          card,
          '[data-ts-quality-description]'
        ),
        description
      );

      setInputValue(
        query(
          card,
          '[data-ts-property-quality]'
        ),
        label
      );
    }

    function updateSizeAndQuality(state) {
      var card =
        state.card;

      var widthInput =
        query(
          card,
          '[data-ts-print-width]'
        );

      var heightInput =
        query(
          card,
          '[data-ts-print-height]'
        );

      var width =
        parseFloat(
          widthInput
            ? widthInput.value
            : ''
        );

      var height =
        parseFloat(
          heightInput
            ? heightInput.value
            : ''
        );

      if (
        !width ||
        !height ||
        width <= 0 ||
        height <= 0
      ) {
        setText(
          query(
            card,
            '[data-ts-effective-dpi]'
          ),
          '—'
        );

        updateQuality(
          state,
          'waiting',
          'Waiting',
          '',
          ''
        );

        return;
      }

      var dpi;

      if (
        state.isVector
      ) {
        dpi =
          Infinity;
      } else {
        dpi =
          Math.min(
            state.naturalWidth /
              width,
            state.naturalHeight /
              height
          );
      }

      setText(
        query(
          card,
          '[data-ts-effective-dpi]'
        ),
        state.isVector
          ? 'Scalable'
          : Math.round(dpi) +
            ' DPI'
      );

      setInputValue(
        query(
          card,
          '[data-ts-property-width]'
        ),
        roundToTwo(width) +
          ' in'
      );

      setInputValue(
        query(
          card,
          '[data-ts-property-height]'
        ),
        roundToTwo(height) +
          ' in'
      );

      setInputValue(
        query(
          card,
          '[data-ts-property-dpi]'
        ),
        state.isVector
          ? 'Vector / Scalable'
          : Math.round(dpi) +
            ' DPI'
      );

      var locationSelect =
        query(
          card,
          '[data-ts-location-select]'
        );

      var selectedOption =
        locationSelect &&
        locationSelect.selectedIndex >= 0
          ? locationSelect.options[
              locationSelect.selectedIndex
            ]
          : null;

      var maxWidth =
        selectedOption
          ? parseFloat(
              selectedOption.getAttribute(
                'data-max-width'
              )
            )
          : 0;

      var maxHeight =
        selectedOption
          ? parseFloat(
              selectedOption.getAttribute(
                'data-max-height'
              )
            )
          : 0;

      var exceedsLocation =
        Boolean(
          (
            maxWidth &&
            width >
              maxWidth
          ) ||
          (
            maxHeight &&
            height >
              maxHeight
          )
        );

      if (
        exceedsLocation
      ) {
        updateQuality(
          state,
          'warning',
          'Exceeds location',
          'Selected print size is too large',
          'Reduce the width or height to fit the standard maximum for the selected imprint location.'
        );

        return;
      }

      if (
        state.isVector
      ) {
        updateQuality(
          state,
          'success',
          'Vector artwork',
          'Ready for print production',
          'Vector artwork can scale cleanly without losing edge sharpness.'
        );

        return;
      }

      if (
        dpi >= 250
      ) {
        updateQuality(
          state,
          'success',
          'Print-ready resolution',
          'Ready for print production',
          'This artwork has sufficient resolution for the entered print size.'
        );
      } else if (
        dpi >= 150
      ) {
        updateQuality(
          state,
          'info',
          'Usable resolution',
          'This artwork may be usable',
          'A larger or vector file may produce a sharper result, especially for fine details.'
        );
      } else if (
        dpi >= 100
      ) {
        updateQuality(
          state,
          'warning',
          'Low resolution',
          'Higher-resolution artwork recommended',
          'This artwork may lose sharpness at the entered print size.'
        );
      } else {
        updateQuality(
          state,
          'danger',
          'Very low resolution',
          'This artwork may print blurry',
          'This file may appear pixelated at the entered print size. Upload a larger image or create an enhanced vector.'
        );
      }
    }

    function setDefaultPrintSize(state) {
      var card =
        state.card;

      var widthInput =
        query(
          card,
          '[data-ts-print-width]'
        );

      var heightInput =
        query(
          card,
          '[data-ts-print-height]'
        );

      if (
        !state.naturalWidth ||
        !state.naturalHeight
      ) {
        return;
      }

      var maximumWidth =
        11;

      var maximumHeight =
        14;

      var scale =
        Math.min(
          maximumWidth /
            state.naturalWidth,
          maximumHeight /
            state.naturalHeight
        );

      var width =
        state.naturalWidth *
        scale;

      var height =
        state.naturalHeight *
        scale;

      setInputValue(
        widthInput,
        roundToTwo(width)
      );

      setInputValue(
        heightInput,
        roundToTwo(height)
      );

      setText(
        query(
          card,
          '[data-ts-maximum-size]'
        ),
        state.isVector
          ? 'Scalable'
          : roundToTwo(
              state.naturalWidth /
              150
            ) +
            ' × ' +
            roundToTwo(
              state.naturalHeight /
              150
            ) +
            ' in'
      );

      updateSizeAndQuality(
        state
      );
    }

    function analyzeImageData(
      imageData
    ) {
      var data =
        imageData.data;

      var pixels =
        0;

      var transparentPixels =
        0;

      var clusters =
        [];

      var step =
        Math.max(
          1,
          Math.floor(
            Math.sqrt(
              (
                imageData.width *
                imageData.height
              ) /
              18000
            )
          )
        );

      function addCluster(
        red,
        green,
        blue
      ) {
        var match =
          null;

        var smallestDistance =
          Infinity;

        clusters.forEach(
          function (cluster) {
            var distance =
              colorDistance(
                red,
                green,
                blue,
                cluster
              );

            if (
              distance <
              smallestDistance
            ) {
              smallestDistance =
                distance;

              match =
                cluster;
            }
          }
        );

        if (
          match &&
          smallestDistance <= 70
        ) {
          var newCount =
            match.count + 1;

          match.red =
            (
              match.red *
                match.count +
              red
            ) / newCount;

          match.green =
            (
              match.green *
                match.count +
              green
            ) / newCount;

          match.blue =
            (
              match.blue *
                match.count +
              blue
            ) / newCount;

          match.count =
            newCount;
        } else {
          clusters.push({
            red:
              red,

            green:
              green,

            blue:
              blue,

            count:
              1
          });
        }
      }

      for (
        var y = 0;
        y < imageData.height;
        y += step
      ) {
        for (
          var x = 0;
          x < imageData.width;
          x += step
        ) {
          var index =
            (
              y *
              imageData.width +
              x
            ) * 4;

          var alpha =
            data[index + 3];

          if (
            alpha < 245
          ) {
            transparentPixels +=
              1;
          }

          if (
            alpha < 70
          ) {
            continue;
          }

          pixels +=
            1;

          addCluster(
            data[index],
            data[index + 1],
            data[index + 2]
          );
        }
      }

      var minimumCluster =
        Math.max(
          4,
          Math.floor(
            pixels *
            0.018
          )
        );

      var dominant =
        clusters
          .filter(
            function (cluster) {
              return (
                cluster.count >=
                minimumCluster
              );
            }
          )
          .sort(
            function (
              first,
              second
            ) {
              return (
                second.count -
                first.count
              );
            }
          );

      return {
        dominantColors:
          Math.max(
            1,
            dominant.length
          ),

        printableColors:
          dominant.length > 8
            ? 9
            : Math.max(
                1,
                dominant.length
              ),

        hasTransparency:
          transparentPixels > 0
      };
    }

    async function analyzeFile(state) {
      var card =
        state.card;

      if (
        state.isVector
      ) {
        state.naturalWidth =
          1000;

        state.naturalHeight =
          1000;

        state.aspectRatio =
          1;

        state.analysis = {
          dominantColors:
            1,

          printableColors:
            1,

          hasTransparency:
            true
        };

        setText(
          query(
            card,
            '[data-ts-pixel-dimensions]'
          ),
          'Vector artwork'
        );

        setText(
          query(
            card,
            '[data-ts-transparency-status]'
          ),
          'Supported'
        );

        setText(
          query(
            card,
            '[data-ts-dominant-colors]'
          ),
          'Vector artwork'
        );

        setText(
          query(
            card,
            '[data-ts-printable-colors]'
          ),
          'Production review'
        );

        setDefaultPrintSize(
          state
        );

        return;
      }

      var image =
        await loadImageFromUrl(
          state.originalUrl
        );

      state.naturalWidth =
        image.naturalWidth;

      state.naturalHeight =
        image.naturalHeight;

      state.aspectRatio =
        state.naturalWidth /
        state.naturalHeight;

      var maximumSize =
        300;

      var scale =
        Math.min(
          1,
          maximumSize /
            Math.max(
              state.naturalWidth,
              state.naturalHeight
            )
        );

      var canvas =
        document.createElement(
          'canvas'
        );

      canvas.width =
        Math.max(
          1,
          Math.round(
            state.naturalWidth *
            scale
          )
        );

      canvas.height =
        Math.max(
          1,
          Math.round(
            state.naturalHeight *
            scale
          )
        );

      var context =
        canvas.getContext(
          '2d',
          {
            willReadFrequently:
              true
          }
        );

      context.drawImage(
        image,
        0,
        0,
        canvas.width,
        canvas.height
      );

      var imageData =
        context.getImageData(
          0,
          0,
          canvas.width,
          canvas.height
        );

      state.analysis =
        analyzeImageData(
          imageData
        );

      setText(
        query(
          card,
          '[data-ts-pixel-dimensions]'
        ),
        state.naturalWidth +
          ' × ' +
          state.naturalHeight +
          ' px'
      );

      setText(
        query(
          card,
          '[data-ts-transparency-status]'
        ),
        state.analysis.hasTransparency
          ? 'Detected'
          : 'Solid background'
      );

      setText(
        query(
          card,
          '[data-ts-dominant-colors]'
        ),
        state.analysis.dominantColors > 8
          ? 'Full color / blended'
          : state.analysis.dominantColors +
            (
              state.analysis.dominantColors === 1
                ? ' color'
                : ' colors'
            )
      );

      setText(
        query(
          card,
          '[data-ts-printable-colors]'
        ),
        state.analysis.printableColors > 8
          ? 'Full color'
          : state.analysis.printableColors +
            (
              state.analysis.printableColors === 1
                ? ' color'
                : ' colors'
            )
      );

      setDefaultPrintSize(
        state
      );
    }

    async function handleFileSelection(
      state,
      file,
      restoring
    ) {
      var card =
        state.card;

      if (!file) return;

      if (
        file.size >
        MAX_FILE_SIZE
      ) {
        window.alert(
          'This artwork file is larger than the 10 MB limit.'
        );

        return;
      }

      if (
        !isSvgFile(file) &&
        !isSupportedRaster(file)
      ) {
        window.alert(
          'Choose a PNG, JPG, JPEG, WebP, GIF, BMP, or SVG artwork file.'
        );

        return;
      }

      var selectionToken=(state.backgroundSelectionToken||0)+1;state.backgroundSelectionToken=selectionToken;
      var sourceByteHash=await pixelDigest(await file.arrayBuffer());
      if(state.backgroundSelectionToken!==selectionToken)return;
      state.sourceByteHash=sourceByteHash;card.setAttribute('data-ts-background-source-sha256',sourceByteHash);syncBackgroundRefusal(state);
      resetStateUrls(
        state
      );

      state.file =
        file;

      state.isVector =
        isSvgFile(
          file
        );

      state.originalUrl =
        createObjectUrl(
          file
        );

      state.currentPreviewUrl =
        state.originalUrl;

      state.backgroundUrl =
        '';

      state.vectorUrl =
        '';

      state.originalStoredUrl =
        '';

      state.backgroundStoredUrl =
        '';

      state.backgroundBlob =
        null;

      state.selectedVersion =
        'original';

      card.classList.add(
        'has-file'
      );

      setHidden(
        query(
          card,
          '[data-ts-upload-area]'
        ),
        true
      );

      setHidden(
        query(
          card,
          '[data-ts-artwork-workspace]'
        ),
        false
      );

      setText(
        query(
          card,
          '[data-ts-artwork-title]'
        ),
        file.name
      );

      setText(
        query(
          card,
          '[data-ts-file-status]'
        ),
        'File selected'
      );

      setText(
        query(
          card,
          '[data-ts-file-type]'
        ),
        state.isVector
          ? 'SVG'
          : (
              file.type ||
              getFileExtension(
                file.name
              ).toUpperCase()
            )
      );

      setText(
        query(
          card,
          '[data-ts-file-size]'
        ),
        formatFileSize(
          file.size
        )
      );

      [
        '[data-ts-artwork-preview-image]',
        '[data-ts-version-original-image]'
      ].forEach(
        function (selector) {
          var image =
            query(
              card,
              selector
            );

          if (image) {
            image.src =
              state.originalUrl;
          }
        }
      );

      setHidden(
        query(
          card,
          '[data-ts-version-option="background_removed"]'
        ),
        true
      );

      setHidden(
        query(
          card,
          '[data-ts-version-option="vector"]'
        ),
        true
      );

      var vectorButton =
        query(
          card,
          '[data-ts-create-vector]'
        );

      if (vectorButton) {
        vectorButton.disabled =
          state.isVector;

        setText(
          query(
            card,
            '[data-ts-create-vector-text]'
          ),
          state.isVector
            ? 'Artwork Is Already Vector'
            : 'Create Enhanced Vector — $5'
        );
      }

      selectVersion(
        state,
        'original'
      );

      activateNextCard(
        state
      );

      updateSummary();

      try {
        await analyzeFile(
          state
        );
      } catch (error) {
        console.error(
          'Artwork analysis error:',
          error
        );
      }

      if(!restoring){await preserveArtworkState(state);storeOriginalFile(state);}
    }

    async function detectBackgroundColor(
      state
    ) {
      if (
        !state.file ||
        state.isVector
      ) {
        return;
      }

      try {
        var image =
          await loadImageFromUrl(
            state.originalUrl
          );

        var canvas =
          document.createElement(
            'canvas'
          );

        canvas.width =
          image.naturalWidth;

        canvas.height =
          image.naturalHeight;

        var context =
          canvas.getContext(
            '2d',
            {
              willReadFrequently:
                true
            }
          );

        context.drawImage(
          image,
          0,
          0
        );

        var points = [
          [0, 0],
          [canvas.width - 1, 0],
          [0, canvas.height - 1],
          [canvas.width - 1, canvas.height - 1]
        ];

        var red =
          0;

        var green =
          0;

        var blue =
          0;

        points.forEach(
          function (point) {
            var pixel =
              context.getImageData(
                point[0],
                point[1],
                1,
                1
              ).data;

            red +=
              pixel[0];

            green +=
              pixel[1];

            blue +=
              pixel[2];
          }
        );

        var detected =
          rgbToHex(
            red /
              points.length,
            green /
              points.length,
            blue /
              points.length
          );

        setInputValue(
          query(
            state.card,
            '[data-ts-background-color]'
          ),
          detected
        );
      } catch (error) {
        console.error(
          'Background detection error:',
          error
        );
      }
    }

    var backgroundValidationRecords=new WeakMap(),backgroundRefusals={has:function(hash){return window.NovaProjectArtworkAccess.background.isRejected(hash);}};
    var BACKGROUND_REFUSAL=window.NovaProjectArtworkAccess.background.refusal;
    function rememberBackgroundRefusal(hash){window.NovaProjectArtworkAccess.background.reject(hash);states.forEach(syncBackgroundRefusal);}
    function backgroundUnsupportedError(){return window.NovaProjectArtworkAccess.background.unsupported();}
    function pixelDigest(bytes){return window.NovaProjectArtworkAccess.background.digest(bytes);}
    function buildEdgeConnectedBackgroundMask(){return window.NovaProjectArtworkAccess.background.mask.apply(null,arguments);}
    function syncBackgroundRefusal(state) {
      var refused = Boolean(state.sourceByteHash && backgroundRefusals.has(state.sourceByteHash));
      var actions = query(state.card, '.ts-background-actions');
      if (!actions) return;
      var panel = query(state.card, '[data-ts-background-refusal]');
      if (!panel) {
        panel = document.createElement('section');
        panel.setAttribute('data-ts-background-refusal', ''); panel.setAttribute('role', 'status');
        var heading = document.createElement('h5'); heading.textContent = 'Background too complex';
        var detail = document.createElement('p'); detail.textContent = BACKGROUND_REFUSAL;
        panel.appendChild(heading); panel.appendChild(detail);
        actions.parentNode.insertBefore(panel, actions);
      }
      panel.hidden = !refused;
      queryAll(state.card, '[data-ts-remove-white],[data-ts-apply-background-removal]').forEach(function (button) {
        button.disabled = refused;
      });
    }

    function serviceBoundary(state, tool, stage, errorClass, status, exception, rule) {
      var card = state.card;
      card.setAttribute('data-ts-service-tool', tool);
      card.setAttribute('data-ts-service-stage', stage);
      card.setAttribute('data-ts-service-state', errorClass ? 'error' : stage === 'service-result' ? 'ready' : 'processing');
      card.setAttribute('data-ts-service-error', errorClass || '');
      card.setAttribute('data-ts-service-status', Number.isInteger(status) ? String(status) : '');
      card.setAttribute('data-ts-service-validation-rule', rule === 'background_foreground' ? rule : '');
      var safeException = ['Error','TypeError','ReferenceError','RangeError','SecurityError','EncodingError','NotSupportedError','NetworkError','AbortError','TimeoutError'].indexOf(exception) >= 0 ? exception : '';
      card.setAttribute('data-ts-service-exception', safeException);
      var diagnostic = window.NovaUpscaleSafeDiagnostics;
      if (diagnostic && diagnostic.enabled) diagnostic.capture(stage, {tool:tool,event:errorClass ? 'failed' : stage === 'service-result' ? 'ready' : 'running',errorClass:errorClass,status:status,exception:safeException});
    }

    async function applyBackgroundRemoval(
      state
    ) {
      if (state.artworkServiceBusy) return;
      if (
        !state.file ||
        state.isVector
      ) {
        serviceBoundary(state, 'background-removal', 'service-source', 'service_input_unavailable');
        window.alert(
          'Background removal is available for PNG, JPG, JPEG, WebP, GIF, and BMP files.'
        );

        return;
      }

      var card =
        state.card;

      var automaticDetection =
        card.getAttribute(
          'data-ts-auto-detect-background-request'
        ) ===
        'true';

      if (
        automaticDetection
      ) {
        card.removeAttribute(
          'data-ts-auto-detect-background-request'
        );
      }

      var colorInput =
        query(
          card,
          '[data-ts-background-color]'
        );

      var toleranceInput =
        query(
          card,
          '[data-ts-background-tolerance]'
        );

      var cleanupInput =
        query(
          card,
          '[data-ts-edge-cleanup]'
        );

      var target =
        hexToRgb(
          colorInput
            ? colorInput.value
            : '#ffffff'
        );

      var tolerance =
        Number(
          toleranceInput
            ? toleranceInput.value
            : 32
        );

      var cleanup =
        Number(
          cleanupInput
            ? cleanupInput.value
            : 1
        );

      state.artworkServiceBusy = true;
      backgroundValidationRecords.delete(card);
      var boundary = 'service-source';
      serviceBoundary(state, 'background-removal', boundary);
      try {
        var sourceFile = state.file;
        var sourceByteHash = await pixelDigest(await sourceFile.arrayBuffer());
        if (state.file !== sourceFile || sourceByteHash !== state.sourceByteHash) throw new Error('The background-removal source changed. Nothing was processed.');
        if (backgroundRefusals.has(sourceByteHash)) throw backgroundUnsupportedError();
        var sourceUrl = state.originalUrl;
        function requireCurrentSource() {
          if (state.file !== sourceFile || state.sourceByteHash !== sourceByteHash || state.originalUrl !== sourceUrl) {
            var changed = new Error('The background-removal source changed. No stale result was applied.');
            changed.errorClass = 'source_load_failed'; throw changed;
          }
        }
        var image =
          await loadImageFromUrl(
            sourceUrl
          );
        requireCurrentSource();

        var canvas =
          document.createElement(
            'canvas'
          );

        canvas.width =
          image.naturalWidth;

        canvas.height =
          image.naturalHeight;

        if(!canvas.width||!canvas.height||canvas.width*canvas.height>20000000)throw Error('The source exceeds the 20-million-pixel background-removal limit. Your Original is unchanged.');
        var context =
          canvas.getContext(
            '2d',
            {
              willReadFrequently:
                true
            }
          );

        context.drawImage(
          image,
          0,
          0
        );

        var imageData =
          context.getImageData(
            0,
            0,
            canvas.width,
            canvas.height
          );

        var sourcePixelHash = await pixelDigest(imageData.data);
        var capture = window.NovaUpscaleSafeDiagnostics;
        if (capture && capture.enabled) capture.capture('service-source', {
          tool:'background-removal',sourceHash:await pixelDigest(await state.file.arrayBuffer()),
          fileType:state.file.type,bytes:state.file.size,width:canvas.width,height:canvas.height
        });
        boundary = 'service-processing'; serviceBoundary(state, 'background-removal', boundary);
        // Desktop manual-color controls and mobile automatic removal share the
        // same source eligibility screen. A manual color choice is not allowed
        // to bypass the simple-background boundary.
        buildEdgeConnectedBackgroundMask(imageData, canvas.width, canvas.height, {
          assessmentOnly: true, tolerance: 32, cleanup: 1
        });
        var maskEvidence;
        try {
          maskEvidence = buildEdgeConnectedBackgroundMask(
            imageData,
            canvas.width,
            canvas.height,
            {
              preferredTarget:
                target,
              preferTarget:
                !automaticDetection,
              tolerance:
                tolerance,
              cleanup:
                cleanup
            }
          );
        } catch (maskError) {
          if (!automaticDetection && maskError.errorClass === 'background_unsupported_input') {
            maskError = new Error('The selected background color could not be separated safely. Choose the surrounding background color or continue with Original.');
            maskError.errorClass = 'result_mismatch';
          }
          throw maskError;
        }

        setInputValue(
          colorInput,
          maskEvidence.backgroundColor
        );

        if (
          window.NovaMobileReleaseGate &&
          typeof window.NovaMobileReleaseGate.record ===
            'function'
        ) {
          window.NovaMobileReleaseGate.record(
            'twisted-swag-background-mask-built',
            maskEvidence
          );
        }

        context.putImageData(
          imageData,
          0,
          0
        );

        var blob =
          await canvasToBlob(
            canvas,
            'image/png',
            1
          );
        requireCurrentSource();

        revokeObjectUrl(
          state.backgroundUrl
        );

        state.backgroundBlob =
          blob;

        state.backgroundUrl =
          createObjectUrl(
            blob
          );

        state.currentPreviewUrl =
          state.backgroundUrl;

        var mainPreview =
          query(
            card,
            '[data-ts-artwork-preview-image]'
          );

        var backgroundPreview =
          query(
            card,
            '[data-ts-version-background-image]'
          );

        if (mainPreview) {
          mainPreview.src =
            state.backgroundUrl;
        }

        if (backgroundPreview) {
          backgroundPreview.src =
            state.backgroundUrl;
        }

        // Bind the existing edge-connected mask's confidence to both exact decoded
        // pixel buffers. No semantic "most border pixels must be background"
        // assumption is made when foreground legitimately meets an image edge.
        backgroundValidationRecords.set(card, {
          version:'edge-connected-mask-v1', originalPreview:state.originalUrl, outputPreview:state.backgroundUrl,
          sourcePixelHash:sourcePixelHash,
          outputPixelHash:await pixelDigest(context.getImageData(0, 0, canvas.width, canvas.height).data),
          width:canvas.width, height:canvas.height, confidence:maskEvidence.confidence === true,
          removedPixelCount:maskEvidence.removedPixelCount,
          connectedRemovedPixelCount:maskEvidence.connectedRemovedPixelCount
        });

        setHidden(
          query(
            card,
            '[data-ts-version-option="background_removed"]'
          ),
          false
        );

        var restoreButton =
          query(
            card,
            '[data-ts-restore-original]'
          );

        if (restoreButton) {
          restoreButton.disabled =
            false;
        }

        setInputValue(
          query(
            card,
            '[data-ts-property-background-status]'
          ),
          'Yes'
        );

        boundary = 'service-storage'; serviceBoundary(state, 'background-removal', boundary);
        state.backgroundStoredUrl =
          await uploadStoredFile(
            state,
            blob,
            'background-removed',
            'artwork-' +
              state.number +
              '-background-removed.png'
          );

        // Storage/completion alone never selects a billable result.
        var selectedPreview=state.selectedVersion==='vector'?state.vectorUrl:state.selectedVersion==='background_removed'?state.backgroundUrl:state.originalUrl;
        state.currentPreviewUrl=selectedPreview;if(mainPreview)mainPreview.src=selectedPreview;
        await preserveArtworkState(state);
        serviceBoundary(state, 'background-removal', 'service-result');
      } catch (error) {
        if (error.errorClass === 'background_unsupported_input' && sourceByteHash && state.file === sourceFile) {
          rememberBackgroundRefusal(sourceByteHash);
        }
        var failureClass = boundary === 'service-storage' && (error.status === 401 || error.status === 403)
          ? 'authorization_failed' : error.errorClass || (boundary === 'service-storage' ? 'storage_failed' : boundary === 'service-source' ? 'source_load_failed' : 'processing_failed');
        serviceBoundary(state, 'background-removal', boundary, failureClass, error.status, error.name, error.novaArtworkValidationRule);
        console.error(
          'Background removal failed at:',
          boundary
        );

        if (!automaticDetection && error.errorClass !== 'background_unsupported_input') window.alert(
          error &&
          error.message
            ? error.message
            : 'The background could not be removed. Your original artwork remains safe.'
        );
      } finally { state.artworkServiceBusy = false; }
    }

    function restoreOriginal(state) {
      if (!state.file) return;

      state.currentPreviewUrl =
        state.originalUrl;

      var preview =
        query(
          state.card,
          '[data-ts-artwork-preview-image]'
        );

      if (preview) {
        preview.src =
          state.originalUrl;
      }

      selectVersion(
        state,
        'original'
      );
    }

    function updateVectorProgress(
      state,
      percent,
      message
    ) {
      var card =
        state.card;

      var progress =
        query(
          card,
          '[data-ts-vector-progress]'
        );

      setHidden(
        progress,
        false
      );

      setText(
        query(
          card,
          '[data-ts-vector-progress-message]'
        ),
        message
      );

      setText(
        query(
          card,
          '[data-ts-vector-progress-percent]'
        ),
        Math.round(
          percent
        ) + '%'
      );

      var fill =
        query(
          card,
          '[data-ts-vector-progress-fill]'
        );

      if (fill) {
        fill.style.width =
          clamp(
            percent,
            0,
            100
          ) + '%';
      }
    }

    function startVectorProgress(state) {
      clearProgressTimer(state);var started=Date.now(),fill=query(state.card,'[data-ts-vector-progress-fill]');
      setHidden(query(state.card,'[data-ts-vector-progress]'),false);
      var message=query(state.card,'[data-ts-vector-progress-message]'),elapsed=query(state.card,'[data-ts-vector-progress-percent]');if(message){message.setAttribute('role','status');message.setAttribute('aria-live','polite');message.textContent='Verifying selected artwork…';}if(elapsed){elapsed.setAttribute('aria-live','off');elapsed.textContent='Elapsed 0s';}
      if(fill){fill.style.width='35%';if(!window.matchMedia('(prefers-reduced-motion: reduce)').matches&&fill.animate)state.vectorAnimation=fill.animate([{transform:'translateX(-100%)'},{transform:'translateX(300%)'}],{duration:1300,iterations:Infinity});}
      state.progressTimer=window.setInterval(function(){setText(query(state.card,'[data-ts-vector-progress-percent]'),'Elapsed '+Math.floor((Date.now()-started)/1000)+'s');},1000);
    }
    async function createVector(state) {
      if (
        !state.file ||
        state.isVector
      ) {
        return;
      }

      var card =
        state.card;

      var button =
        query(
          card,
          '[data-ts-create-vector]'
        );

      var buttonText =
        query(
          card,
          '[data-ts-create-vector-text]'
        );

      setHidden(
        query(
          card,
          '[data-ts-vector-error]'
        ),
        true
      );

      if (button) {
        button.disabled =
          true;
      }

      setText(
        buttonText,
        'Creating Enhanced Vector…'
      );

      startVectorProgress(
        state
      );

      var formData =
        new FormData();

      var sourceFile =
        state.backgroundBlob ||
        state.file;

      var sourceName =
        state.backgroundBlob
          ? 'artwork-' +
            state.number +
            '-transparent.png'
          : state.file.name;

      formData.append(
        'image',
        sourceFile,
        sourceName
      );

      try {
        var originalAtDispatch=state.file;
        await preserveArtworkState(state);
        var data=await window.NovaProjectArtworkAccess.submit('vector-'+state.number,sourceFile,true,{version:state.selectedVersion,originalStoredUrl:state.originalStoredUrl,backgroundStoredUrl:state.backgroundStoredUrl,vectorUrl:state.vectorUrl},function(message){setText(query(card,'[data-ts-vector-progress-message]'),message);});
        if(state.file!==originalAtDispatch)throw Error('The selected source changed. The completed result was retained; it was not applied to your newer artwork.');
        clearProgressTimer(
          state
        );

        updateVectorProgress(
          state,
          100,
          'Enhanced vector ready.'
        );

        await window.NovaProjectArtworkAccess.vectorFees.register(data.vectorUrl);
        state.vectorUrl =
          data.vectorUrl;

        var vectorPreview =
          query(
            card,
            '[data-ts-version-vector-image]'
          );

        if (vectorPreview) {
          vectorPreview.src =
            data.previewUrl;
        }

        setHidden(
          query(
            card,
            '[data-ts-version-option="vector"]'
          ),
          false
        );

        setInputValue(
          query(
            card,
            '[data-ts-property-vector-url]'
          ),
          state.vectorUrl
        );

        setText(
          buttonText,
          'Enhanced Vector Created'
        );

        selectVersion(
          state,
          'vector'
        );

        window.setTimeout(
          function () {
            setHidden(
              query(
                card,
                '[data-ts-vector-progress]'
              ),
              true
            );
          },
          600
        );
      } catch (error) {
        clearProgressTimer(
          state
        );

        setHidden(
          query(
            card,
            '[data-ts-vector-progress]'
          ),
          true
        );

        var errorBox =
          query(
            card,
            '[data-ts-vector-error]'
          );

        setHidden(
          errorBox,
          false
        );

        setText(
          query(
            card,
            '[data-ts-vector-error-message]'
          ),
          error &&
          error.message
            ? error.message
            : 'Your original artwork remains available.'
        );

        if (button) {
          button.disabled =
            false;
        }

        setText(
          buttonText,
          'Try Enhancement Again'
        );
      }
    }

    function handleLocationChange(state) {
      var card =
        state.card;

      var select =
        query(
          card,
          '[data-ts-location-select]'
        );

      var selectedOption =
        select &&
        select.selectedIndex >= 0
          ? select.options[
              select.selectedIndex
            ]
          : null;

      var maxWidth =
        selectedOption
          ? parseFloat(
              selectedOption.getAttribute(
                'data-max-width'
              )
            )
          : 0;

      var maxHeight =
        selectedOption
          ? parseFloat(
              selectedOption.getAttribute(
                'data-max-height'
              )
            )
          : 0;

      if (
        maxWidth &&
        maxHeight &&
        state.aspectRatio
      ) {
        var width =
          maxWidth;

        var height =
          width /
          state.aspectRatio;

        if (
          height >
          maxHeight
        ) {
          height =
            maxHeight;

          width =
            height *
            state.aspectRatio;
        }

        setInputValue(
          query(
            card,
            '[data-ts-print-width]'
          ),
          roundToTwo(width)
        );

        setInputValue(
          query(
            card,
            '[data-ts-print-height]'
          ),
          roundToTwo(height)
        );
      }

      setInputValue(
        query(
          card,
          '[data-ts-property-location]'
        ),
        select
          ? select.value
          : ''
      );

      updateSizeAndQuality(
        state
      );
    }

    function handleWidthChange(state) {
      var card =
        state.card;

      var widthInput =
        query(
          card,
          '[data-ts-print-width]'
        );

      var heightInput =
        query(
          card,
          '[data-ts-print-height]'
        );

      var width =
        parseFloat(
          widthInput
            ? widthInput.value
            : ''
        );

      if (
        state.isLocked &&
        width > 0 &&
        state.aspectRatio
      ) {
        setInputValue(
          heightInput,
          roundToTwo(
            width /
            state.aspectRatio
          )
        );
      }

      updateSizeAndQuality(
        state
      );
    }

    function handleHeightChange(state) {
      var card =
        state.card;

      var widthInput =
        query(
          card,
          '[data-ts-print-width]'
        );

      var heightInput =
        query(
          card,
          '[data-ts-print-height]'
        );

      var height =
        parseFloat(
          heightInput
            ? heightInput.value
            : ''
        );

      if (
        state.isLocked &&
        height > 0 &&
        state.aspectRatio
      ) {
        setInputValue(
          widthInput,
          roundToTwo(
            height *
            state.aspectRatio
          )
        );
      }

      updateSizeAndQuality(
        state
      );
    }

    function toggleAspectLock(state) {
      state.isLocked =
        !state.isLocked;

      var button =
        query(
          state.card,
          '[data-ts-aspect-lock]'
        );

      if (button) {
        button.classList.toggle(
          'is-locked',
          state.isLocked
        );

        button.setAttribute(
          'aria-pressed',
          state.isLocked
            ? 'true'
            : 'false'
        );

        button.setAttribute(
          'aria-label',
          state.isLocked
            ? 'Unlock artwork proportions'
            : 'Lock artwork proportions'
        );
      }

      setText(
        query(
          state.card,
          '[data-ts-aspect-lock-text]'
        ),
        state.isLocked
          ? 'Locked'
          : 'Unlocked'
      );
    }

    studio.addEventListener(
      'click',
      function (event) {
        var tooltipButton =
          event.target.closest(
            '[data-ts-tooltip-button]'
          );

        if (tooltipButton) {
          event.preventDefault();
          event.stopPropagation();

          toggleTooltip(
            tooltipButton
          );

          return;
        }

        var state =
          getStateFromElement(
            event.target
          );

        if (!state) return;

        var replaceButton =
          event.target.closest(
            '[data-ts-replace-artwork]'
          );

        if (replaceButton) {
          event.preventDefault();

          var fileInput =
            query(
              state.card,
              '[data-ts-artwork-input]'
            );

          if (fileInput) {
            fileInput.value =
              '';

            fileInput.click();
          }

          return;
        }

        var removeButton =
          event.target.closest(
            '[data-ts-remove-artwork]'
          );

        if (removeButton) {
          event.preventDefault();

          clearCardUi(
            state
          );

          return;
        }

        var previewButton =
          event.target.closest(
            '[data-ts-open-preview]'
          );

        if (previewButton) {
          event.preventDefault();

          openModal(
            state.currentPreviewUrl ||
            state.originalUrl,
            state.file
              ? state.file.name
              : 'Artwork Preview'
          );

          return;
        }

        var whiteButton =
          event.target.closest(
            '[data-ts-remove-white]'
          );

        if (whiteButton) {
          event.preventDefault();

          setInputValue(
            query(
              state.card,
              '[data-ts-background-color]'
            ),
            '#ffffff'
          );

          applyBackgroundRemoval(
            state
          );

          return;
        }

        var detectButton =
          event.target.closest(
            '[data-ts-detect-background]'
          );

        if (detectButton) {
          event.preventDefault();

          detectBackgroundColor(
            state
          );

          return;
        }

        var applyButton =
          event.target.closest(
            '[data-ts-apply-background-removal]'
          );

        if (applyButton) {
          event.preventDefault();

          applyBackgroundRemoval(
            state
          );

          return;
        }

        var restoreButton =
          event.target.closest(
            '[data-ts-restore-original]'
          );

        if (restoreButton) {
          event.preventDefault();

          restoreOriginal(
            state
          );

          return;
        }

        var vectorButton =
          event.target.closest(
            '[data-ts-create-vector]'
          );

        if (vectorButton) {
          event.preventDefault();

          createVector(
            state
          );

          return;
        }

        var lockButton =
          event.target.closest(
            '[data-ts-aspect-lock]'
          );

        if (lockButton) {
          event.preventDefault();

          toggleAspectLock(
            state
          );
        }
      }
    );

    studio.addEventListener(
      'change',
      function (event) {
        var state =
          getStateFromElement(
            event.target
          );

        if (!state) return;

        if (
          event.target.matches(
            '[data-ts-artwork-input]'
          )
        ) {
          if (
            event.target.files &&
            event.target.files.length
          ) {
            handleFileSelection(
              state,
              event.target.files[0]
            );
          }

          return;
        }

        if (
          event.target.matches(
            '[data-ts-location-select]'
          )
        ) {
          handleLocationChange(
            state
          );

          return;
        }

        if (
          event.target.matches(
            '[data-ts-version-choice]'
          )
        ) {
          selectVersion(
            state,
            event.target.value
          );
        }
      }
    );

    studio.addEventListener(
      'input',
      function (event) {
        var state =
          getStateFromElement(
            event.target
          );

        if (!state) return;

        if (
          event.target.matches(
            '[data-ts-print-width]'
          )
        ) {
          handleWidthChange(
            state
          );

          return;
        }

        if (
          event.target.matches(
            '[data-ts-print-height]'
          )
        ) {
          handleHeightChange(
            state
          );

          return;
        }

        if (
          event.target.matches(
            '[data-ts-background-tolerance]'
          )
        ) {
          setText(
            query(
              state.card,
              '[data-ts-background-tolerance-value]'
            ),
            event.target.value
          );

          return;
        }

        if (
          event.target.matches(
            '[data-ts-edge-cleanup]'
          )
        ) {
          setText(
            query(
              state.card,
              '[data-ts-edge-cleanup-value]'
            ),
            event.target.value
          );
        }
      }
    );

    document.addEventListener(
      'click',
      function (event) {
        if (
          !event.target.closest(
            '[data-ts-tooltip-button]'
          ) &&
          !event.target.closest(
            '[data-ts-tooltip]'
          )
        ) {
          closeAllTooltips();
        }
      }
    );

    if (modalClose) {
      modalClose.addEventListener(
        'click',
        closeModal
      );
    }

    if (modal) {
      modal.addEventListener(
        'click',
        function (event) {
          if (
            event.target ===
            modal
          ) {
            closeModal();
          }
        }
      );
    }

    document.addEventListener(
      'keydown',
      function (event) {
        if (
          event.key ===
          'Escape'
        ) {
          closeAllTooltips();

          if (
            modal &&
            modal.classList.contains(
              'is-open'
            )
          ) {
            closeModal();
          }
        }
      }
    );

    window.addEventListener(
      'beforeunload',
      function () {
        states.forEach(
          function (state) {
            clearProgressTimer(
              state
            );

            resetStateUrls(
              state
            );
          }
        );
      }
    );

    movePropertiesIntoProductForm(
      studio
    );

    states.forEach(
      function (state) {
        clearProperties(
          state
        );

        selectVersion(
          state,
          'original'
        );
      }
    );

    updateSummary();
    states.forEach(function(state){var action=query(state.card,'.ts-background-actions');if(action&&!query(state.card,'[data-ts-simple-background-guidance]')){var guide=document.createElement('p');guide.setAttribute('data-ts-simple-background-guidance','');guide.textContent='Works best with solid or simple backgrounds. Not suitable for extracting people, pets or objects from complex photographic scenes. $15 when you use the background-removed result. No fee for running or discarding an unused result.';guide.style.cssText='font-size:12px;font-weight:400;line-height:1.4;';action.parentNode.insertBefore(guide,action);}});
    states.forEach(function(state){restoreArtworkState(state).catch(function(error){setText(query(state.card,'[data-ts-vector-error-message]'),error.message);setHidden(query(state.card,'[data-ts-vector-error]'),false);});});
  }

  function initializeAllStudios() {
    document
      .querySelectorAll(
        '[data-ts-artwork-studio]'
      )
      .forEach(
        initializeStudio
      );
  }

  if (
    document.readyState ===
    'loading'
  ) {
    document.addEventListener(
      'DOMContentLoaded',
      initializeAllStudios
    );
  } else {
    initializeAllStudios();
  }

  window.addEventListener(
    'load',
    initializeAllStudios
  );

  document.addEventListener(
    'shopify:section:load',
    initializeAllStudios
  );
})();
window.NovaProjectArtworkConsumers=window.NovaProjectArtworkConsumers||{};window.NovaProjectArtworkConsumers.adapter='private-project-v1';
